import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import copyToClipboard from 'copy-to-clipboard';
import Vue from 'vue';

//
// i18n
// - n/a
//
// icons
// - n/a
//
// sass
// - n/a
//
var script$11 = {
  name: 'AtriumLayout'
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
var __vue_script__$11 = script$11;
/* template */

var __vue_render__$11 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "atriumLayout"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "atriumLayout-top"
  }, [_vm._t("top")], 2), _c('div', {
    staticClass: "columns is-multiline"
  }, [_c('div', {
    staticClass: "column is-two-thirds"
  }, [_c('div', {
    staticClass: "atriumLayout-left"
  }, [_vm._t("left")], 2)]), _c('div', {
    staticClass: "column is-one-third"
  }, [_c('div', {
    staticClass: "atriumLayout-right"
  }, [_vm._t("right")], 2)])]), _c('div', {
    staticClass: "atriumLayout-bottom"
  }, [_vm._t("bottom")], 2)])]);
};

var __vue_staticRenderFns__$11 = [];
/* style */

var __vue_inject_styles__$12 = undefined;
/* scoped */

var __vue_scope_id__$12 = undefined;
/* module identifier */

var __vue_module_identifier__$12 = undefined;
/* functional template */

var __vue_is_functional_template__$12 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$12 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$11,
  staticRenderFns: __vue_staticRenderFns__$11
}, __vue_inject_styles__$12, __vue_script__$11, __vue_scope_id__$12, __vue_is_functional_template__$12, __vue_module_identifier__$12, false, undefined, undefined, undefined);

//
// i18n
// - n/a
//
// icons
// - n/a
//
// sass
// - $boxContent-titleFamily
//
var script$10 = {
  name: 'BoxContent',
  props: {
    title: {
      type: String,
      default: ''
    }
  }
};

/* script */
var __vue_script__$10 = script$10;
/* template */

var __vue_render__$10 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "boxContent"
  }, [_c('div', {
    staticClass: "container is-small"
  }, [_vm.title ? _c('h2', {
    staticClass: "boxContent-title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._t("default")], 2)]);
};

var __vue_staticRenderFns__$10 = [];
/* style */

var __vue_inject_styles__$11 = undefined;
/* scoped */

var __vue_scope_id__$11 = undefined;
/* module identifier */

var __vue_module_identifier__$11 = undefined;
/* functional template */

var __vue_is_functional_template__$11 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$11 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$10,
  staticRenderFns: __vue_staticRenderFns__$10
}, __vue_inject_styles__$11, __vue_script__$10, __vue_scope_id__$11, __vue_is_functional_template__$11, __vue_module_identifier__$11, false, undefined, undefined, undefined);

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var regeneratorRuntime$1 = {exports: {}};

var _typeof$1 = {exports: {}};

(function (module) {
function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}

module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
}(_typeof$1));

(function (module) {
var _typeof = _typeof$1.exports["default"];

function _regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) {
            if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
          }

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) {
      keys.push(key);
    }

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) {
        "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
      }
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;
}(regeneratorRuntime$1));

// TODO(Babel 8): Remove this file.

var runtime = regeneratorRuntime$1.exports();
var regenerator = runtime;

// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$4(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// prettier-ignore
var deconfDefaultEndpoints = {
  'AttendanceRoutes.attend': function AttendanceRoutesAttend(sessionId) {
    return "attendance/".concat(sessionId, "/attend");
  },
  'AttendanceRoutes.unattend': function AttendanceRoutesUnattend(sessionId) {
    return "attendance/".concat(sessionId, "/unattend");
  },
  'AttendanceRoutes.getSessionAttendance': function AttendanceRoutesGetSessionAttendance(sessionId) {
    return "attendance/".concat(sessionId);
  },
  'AttendanceRoutes.getUserAttendance': function AttendanceRoutesGetUserAttendance() {
    return "attendance/me";
  },
  'CarbonRoutes.getCarbon': function CarbonRoutesGetCarbon() {
    return "carbon/estimate";
  },
  'CalendarRoutes.getSessionIcsFile': function CalendarRoutesGetSessionIcsFile(sessionId) {
    return "calendar/ical/".concat(sessionId);
  },
  'CalendarRoutes.getGoogleCalendarUrl': function CalendarRoutesGetGoogleCalendarUrl(sessionId) {
    return "calendar/google/".concat(sessionId);
  },
  'CalendarRoutes.getUserIcs': function CalendarRoutesGetUserIcs(token) {
    return "calendar/me/".concat(token);
  },
  'CalendarRoutes.createUserCalendar': function CalendarRoutesCreateUserCalendar() {
    return "calendar/me";
  },
  'ConferenceRoutes.generateIcs': function ConferenceRoutesGenerateIcs(sessionId) {
    return "schedule/".concat(sessionId, "/ics");
  },
  'ConferenceRoutes.getSchedule': function ConferenceRoutesGetSchedule() {
    return "schedule";
  },
  'ConferenceRoutes.getLinks': function ConferenceRoutesGetLinks(sessionId) {
    return "schedule/".concat(sessionId, "/links");
  },
  'ConferenceRoutes.lintSessions': function ConferenceRoutesLintSessions() {
    return 'schedule/lint';
  },
  'ContentRoutes.getContent': function ContentRoutesGetContent(slug) {
    return "content/".concat(slug);
  },
  'RegistrationRoutes.getRegistration': function RegistrationRoutesGetRegistration() {
    return "auth/me";
  },
  'RegistrationRoutes.startEmailLogin': function RegistrationRoutesStartEmailLogin() {
    return "auth/login";
  },
  'RegistrationRoutes.finishEmailLogin': function RegistrationRoutesFinishEmailLogin(token) {
    return "auth/login/".concat(token);
  },
  'RegistrationRoutes.startRegister': function RegistrationRoutesStartRegister() {
    return "auth/register";
  },
  'RegistrationRoutes.finishRegister': function RegistrationRoutesFinishRegister(token) {
    return "auth/register/".concat(token);
  },
  'RegistrationRoutes.unregister': function RegistrationRoutesUnregister() {
    return "auth/unregister";
  }
};
var jsonHeaders = {
  'Content-Type': 'application/json'
};
var DeconfApiClient = /*#__PURE__*/function () {
  function DeconfApiClient(baseUrl) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, DeconfApiClient);

    _defineProperty(this, "authToken", null);

    this.baseUrl = baseUrl;
    this.options = options;
  } //
  // Helpers
  //


  _createClass(DeconfApiClient, [{
    key: "setAuthToken",
    value: function setAuthToken(token) {
      this.authToken = token;
    }
  }, {
    key: "applyAuthToken",
    value: function applyAuthToken(init) {
      if (this.authToken) {
        var headers = init.headers = new Headers(init.headers);
        headers.append('Authorization', 'Bearer ' + this.authToken);
      }
    }
  }, {
    key: "getEndpoint",
    value: function getEndpoint(key) {
      var _this$options$endpoin, _this$options, _this$options$endpoin2;

      var getter = (_this$options$endpoin = (_this$options = this.options) === null || _this$options === void 0 ? void 0 : (_this$options$endpoin2 = _this$options.endpointMap) === null || _this$options$endpoin2 === void 0 ? void 0 : _this$options$endpoin2[key]) !== null && _this$options$endpoin !== void 0 ? _this$options$endpoin : deconfDefaultEndpoints[key];
      if (!getter) throw new Error("Unknown endpoint '".concat(key, "'"));

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return getter.apply(void 0, args);
    }
  }, {
    key: "fetch",
    value: function (_fetch) {
      function fetch(_x) {
        return _fetch.apply(this, arguments);
      }

      fetch.toString = function () {
        return _fetch.toString();
      };

      return fetch;
    }( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(endpoint) {
        var init,
            _args = arguments;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                init = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                this.applyAuthToken(init);
                return _context.abrupt("return", fetch(new URL(endpoint, this.baseUrl).toString(), init).then(function (r) {
                  return r.ok;
                }));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function (_x2) {
        return _ref.apply(this, arguments);
      };
    }())
  }, {
    key: "fetchJson",
    value: function () {
      var _fetchJson = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(endpoint) {
        var init,
            _args2 = arguments;
        return regenerator.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                init = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
                this.applyAuthToken(init);
                return _context2.abrupt("return", fetch(new URL(endpoint, this.baseUrl).toString(), init).then(function (r) {
                  return r.json();
                }, function (error) {
                  return console.error(error), null;
                }));

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchJson(_x3) {
        return _fetchJson.apply(this, arguments);
      }

      return fetchJson;
    }() //
    // Attendance
    //

  }, {
    key: "attend",
    value: function attend(sessionId) {
      return this.fetch(this.getEndpoint('AttendanceRoutes.attend', sessionId), {
        method: 'POST'
      });
    }
  }, {
    key: "unattend",
    value: function unattend(sessionId) {
      return this.fetch(this.getEndpoint('AttendanceRoutes.unattend', sessionId), {
        method: 'POST'
      });
    }
  }, {
    key: "getSessionAttendance",
    value: function getSessionAttendance(sessionId) {
      return this.fetchJson(this.getEndpoint('AttendanceRoutes.getSessionAttendance', sessionId));
    }
  }, {
    key: "getUserAttendance",
    value: function getUserAttendance() {
      return this.fetchJson(this.getEndpoint('AttendanceRoutes.getUserAttendance'));
    } //
    // Carbon
    //

  }, {
    key: "getCarbon",
    value: function getCarbon() {
      return this.fetchJson(this.getEndpoint('CarbonRoutes.getCarbon'));
    } //
    // Calendar
    //

  }, {
    key: "createUserCalendar",
    value: function () {
      var _createUserCalendar = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
        var result;
        return regenerator.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.fetchJson(this.getEndpoint('CalendarRoutes.createUserCalendar'));

              case 2:
                result = _context3.sent;
                if (result) result.url = new URL(result.url);
                return _context3.abrupt("return", result);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function createUserCalendar() {
        return _createUserCalendar.apply(this, arguments);
      }

      return createUserCalendar;
    }() //
    // Conference
    //

  }, {
    key: "getSchedule",
    value: function getSchedule() {
      return this.fetchJson(this.getEndpoint('ConferenceRoutes.getSchedule'));
    }
  }, {
    key: "getLinks",
    value: function getLinks(sessionId) {
      return this.fetchJson(this.getEndpoint('ConferenceRoutes.getLinks', sessionId));
    } //
    // Content
    //

  }, {
    key: "getContent",
    value: function () {
      var _getContent = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4(slug) {
        var _raw$content;

        var raw;
        return regenerator.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.fetchJson(this.getEndpoint('ContentRoutes.getContent', slug));

              case 2:
                raw = _context4.sent;
                return _context4.abrupt("return", (_raw$content = raw === null || raw === void 0 ? void 0 : raw.content) !== null && _raw$content !== void 0 ? _raw$content : null);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getContent(_x4) {
        return _getContent.apply(this, arguments);
      }

      return getContent;
    }() //
    // Registration
    //

  }, {
    key: "getRegistration",
    value: function getRegistration() {
      return this.fetchJson(this.getEndpoint('RegistrationRoutes.getRegistration'));
    }
  }, {
    key: "startEmailLogin",
    value: function startEmailLogin(email) {
      return this.fetch(this.getEndpoint('RegistrationRoutes.startEmailLogin'), {
        method: 'POST',
        body: JSON.stringify({
          email: email
        }),
        headers: _objectSpread$4({}, jsonHeaders)
      });
    }
  }, {
    key: "startRegister",
    value: function startRegister(body) {
      return this.fetch(this.getEndpoint('RegistrationRoutes.startRegister'), {
        method: 'POST',
        body: JSON.stringify(body),
        headers: _objectSpread$4({}, jsonHeaders)
      });
    }
  }, {
    key: "unregister",
    value: function unregister() {
      return this.fetch(this.getEndpoint('RegistrationRoutes.unregister'));
    }
  }]);

  return DeconfApiClient;
}();

var Routes;

(function (Routes) {
  Routes["Atrium"] = "Atrium";
  Routes["WhatsOn"] = "WhatsOn";
  Routes["Schedule"] = "Schedule";
  Routes["CoffeeChatLobby"] = "CoffeeChatLobby";
  Routes["CoffeeChatRoom"] = "CoffeeChatRoom";
  Routes["HelpDesk"] = "HelpDesk";
  Routes["Profile"] = "Profile";
  Routes["Terms"] = "Terms";
  Routes["Privacy"] = "Privacy";
  Routes["Guidelines"] = "Guidelines";
  Routes["Faqs"] = "Faqs";
  Routes["Error"] = "Error";
  Routes["Session"] = "Session";
  Routes["Login"] = "Login";
  Routes["Register"] = "Register";
  Routes["TokenCapture"] = "TokenCapture";
  Routes["NotFound"] = "NotFound";
  Routes["Translator"] = "Translator";
  Routes["InterpretHome"] = "InterpretHome";
  Routes["InterpretSession"] = "InterpretSession";
})(Routes || (Routes = {}));

var MS_PER_SECOND = 1000;
var MS_PER_MINUTE = 60 * 1000;
var MS_PER_HOUR = 60 * 60 * 1000;
var MS_PER_DAY = 24 * 60 * 60 * 1000;
function getCountdown(currentDate, targetDate) {
  var remaining = targetDate.getTime() - currentDate.getTime();
  if (remaining <= 0) return {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  }; // Remaining days

  var days = Math.floor(remaining / MS_PER_DAY);
  remaining = remaining - days * MS_PER_DAY; // Remaining hours

  var hours = Math.floor(remaining / MS_PER_HOUR);
  remaining = remaining - hours * MS_PER_HOUR; // Remaining minutes

  var minutes = Math.floor(remaining / MS_PER_MINUTE);
  remaining = remaining - minutes * MS_PER_MINUTE; // Remaining seconds

  var seconds = Math.floor(remaining / MS_PER_SECOND);
  remaining = remaining - seconds * MS_PER_SECOND;
  return {
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: seconds
  };
}
function getCountdownMessage(_ref, tc) {
  var days = _ref.days,
      hours = _ref.hours,
      minutes = _ref.minutes,
      seconds = _ref.seconds;
  var seperator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ' ';

  var convert = function convert(value, unit) {
    if (!value) return null;
    return "".concat(value, " ").concat(tc("deconf.general.".concat(unit), value));
  };

  return [convert(days, 'days'), convert(hours, 'hours'), convert(minutes, 'minutes'), convert(seconds, 'seconds')].filter(function (str) {
    return Boolean(str);
  }).join(seperator);
}

/** Work out the start of the day */
function startOfDay(input) {
  var d = new Date(input);
  d.setHours(0, 0, 0, 0);
  return d;
}
/** Whether two dates are on the same day */

function isSameDay(a, b) {
  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
}
/** Get a friendly date string in the current locale */

function friendlyDate(date) {
  return date.toLocaleDateString([], {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  });
}

// A function
function debounce(interval, callback) {
  var timerId;

  var cancel = function cancel() {
    if (timerId) {
      window.clearTimeout(timerId);
      timerId = null;
    }
  };

  var invoke = function invoke() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    cancel();
    timerId = window.setTimeout(function () {
      return callback.apply(void 0, args);
    }, interval);
  };

  return Object.assign(invoke, {
    cancel: cancel
  });
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _createForOfIteratorHelper$5(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$6(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$6(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$6(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$6(o, minLen); }

function _arrayLikeToArray$6(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/** A method to seal javascript objects to improve Vue performance */
function deepSeal(input) {
  Object.seal(input);

  if (Array.isArray(input)) {
    var _iterator = _createForOfIteratorHelper$5(input),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var item = _step.value;
        deepSeal(item);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  if (_typeof(input) === 'object') {
    for (var key in input) {
      deepSeal(input[key]);
    }
  }

  return input;
}

function shouldInitiallyShowDevTools() {
  if (process.env.NODE_ENV === 'development') return true;
  var url = new URL(location.href);
  if (url.searchParams.has('dev')) return true;
  return false;
}

var DevPlugin = /*#__PURE__*/function () {
  function DevPlugin(Vue) {
    var _this = this;

    _classCallCheck(this, DevPlugin);

    this._vm = new Vue({
      data: {
        isEnabled: shouldInitiallyShowDevTools(),
        isVisible: false,
        slotState: undefined,
        scheduleDate: undefined
      }
    }); // eslint-disable-next-line @typescript-eslint/no-explicit-any

    window._enableDevMode = function () {
      _this.isEnabled = true;
    }; // eslint-disable-next-line @typescript-eslint/no-explicit-any


    window._disableDevMode = function () {
      _this.isEnabled = false;
    };
  }

  _createClass(DevPlugin, [{
    key: "slotState",
    get: function get() {
      return this._vm.slotState;
    },
    set: function set(newValue) {
      this._vm.slotState = newValue;
    }
  }, {
    key: "isEnabled",
    get: function get() {
      return this._vm.isEnabled;
    },
    set: function set(newValue) {
      this._vm.isEnabled = newValue;
    }
  }, {
    key: "isVisible",
    get: function get() {
      return this._vm.isVisible;
    },
    set: function set(newValue) {
      this._vm.isVisible = newValue;
    }
  }, {
    key: "scheduleDate",
    get: function get() {
      return this._vm.scheduleDate;
    },
    set: function set(newValue) {
      this._vm.scheduleDate = newValue;
    }
  }], [{
    key: "install",
    value: function install(Vue) {
      Vue.prototype.$dev = new DevPlugin(Vue);
    } // Use an internal vue component to fake the reactivity of properties
    // so consumers can bind to $dev values

  }]);

  return DevPlugin;
}();

var DialogPlugin = /*#__PURE__*/function () {
  function DialogPlugin(Vue) {
    _classCallCheck(this, DialogPlugin);

    this._vm = new Vue({
      data: {
        component: null,
        props: {}
      }
    });
  }

  _createClass(DialogPlugin, [{
    key: "component",
    get: function get() {
      return this._vm.component;
    }
  }, {
    key: "props",
    get: function get() {
      return this._vm.props;
    } // Use an internal vue component to fake the reactivity of properties
    // so consumers can bind to $dev values

  }, {
    key: "show",
    value: function show(component) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this._vm.component = component;
      this._vm.props = props;
    }
  }, {
    key: "close",
    value: function close() {
      this._vm.component = null;
      this._vm.props = {};
    }
  }], [{
    key: "install",
    value: function install(Vue) {
      var plugin = new DialogPlugin(Vue);
      Vue.prototype.$dialog = plugin;
      DialogPlugin.shared = plugin;
    }
  }]);

  return DialogPlugin;
}();

_defineProperty(DialogPlugin, "shared", null);

/** Decode a base64 JWT */
function decodeJwt(token) {
  return JSON.parse(window.atob(token.split('.')[1]));
}

function _arrayLikeToArray$5(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$5(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray$5(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$5(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$5(o, minLen);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray$5(arr) || _nonIterableSpread();
}

function isDomain(url) {
  for (var _len = arguments.length, domains = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    domains[_key - 1] = arguments[_key];
  }

  return domains.some(function (d) {
    return url.hostname.endsWith(d);
  });
}

function splitPath(url) {
  return url.pathname.split(/\/+/).filter(function (p) {
    return p;
  });
}

function parsePrimaryLink(link) {
  var url = new URL(link);
  var pathSegments = splitPath(url);
  var isYouTube = isDomain(url, 'youtube.com', 'youtube-nocookie.com'); //
  // Actual embeds
  //

  if (isYouTube && url.searchParams.has('v')) {
    return {
      kind: 'youtube-video',
      data: url.searchParams.get('v')
    };
  }

  if (isYouTube && url.pathname === '/embed/live_stream' && url.searchParams.has('channel')) {
    return {
      kind: 'youtube-channel',
      data: url.searchParams.get('channel')
    };
  }

  if (isDomain(url, 'youtu.be') && pathSegments.length === 1) {
    return {
      kind: 'youtube-video',
      data: pathSegments[0]
    };
  }

  if (isDomain(url, 'player.vimeo.com') && pathSegments.length === 2 && pathSegments[0] === 'video') {
    return {
      kind: 'vimeo',
      data: pathSegments[1]
    };
  } // https://vimeo.com/123456


  if (isDomain(url, 'vimeo.com') && pathSegments.length === 1) {
    return {
      kind: 'vimeo',
      data: pathSegments[0]
    };
  } // https://vimeo.com/event/123456


  if (isDomain(url, 'vimeo.com') && pathSegments.length === 2 && pathSegments[0] === 'event') {
    return {
      kind: 'vimeo-event',
      data: pathSegments[1]
    };
  }

  if (isDomain(url, 'hosted.panopto.com') && url.pathname === '/Panopto/Pages/Embed.aspx' && url.searchParams.has('id')) {
    return {
      kind: 'panopto',
      data: url.toString()
    };
  }

  if (isDomain(url, 'twitch.tv') && pathSegments.length === 1) {
    return {
      kind: 'twitch',
      data: pathSegments[0]
    };
  } // https://anchor.fm/:username/embed/episodes/*


  if (isDomain(url, 'anchor.fm') && pathSegments[1] === 'embed' && pathSegments[2] === 'episodes') {
    return {
      kind: 'anchor-fm-embed',
      data: url.toString()
    };
  } //
  // Links out
  //
  // https://zoom.us/my/abcdef


  if (isDomain(url, 'zoom.us') && url.pathname.startsWith('/my/')) {
    return {
      kind: 'zoom',
      data: url.toString()
    };
  } // https://zoom.us/j/123456789


  if (isDomain(url, 'zoom.us') && url.pathname.startsWith('/j/')) {
    return {
      kind: 'zoom',
      data: url.toString()
    };
  } // https://some-org.zoom.us/meeting/register/abcdef-1234567890


  if (isDomain(url, 'zoom.us') && url.pathname.startsWith('/meeting/register/')) {
    return {
      kind: 'zoom-register',
      data: url.toString()
    };
  } // https://meet.google.com/abc-defg-hij


  if (isDomain(url, 'meet.google.com')) {
    return {
      kind: 'google-meet',
      data: url.toString()
    };
  }

  if (isDomain(url, 'teams.microsoft.com')) {
    return {
      kind: 'teams',
      data: url.toString()
    };
  }

  if (isDomain(url, 'hubs.mozilla.com') || isDomain(url, 'hub.link') || isDomain(url, 'hubs.mozillafestival.org')) {
    return {
      kind: 'mozilla-hubs',
      data: url.toString()
    };
  }

  if (isDomain(url, 'spatial.chat') && pathSegments.length === 2 && pathSegments[0] === 's') {
    return {
      kind: 'spatial-chat',
      data: url.toString()
    };
  } // https://cinnamon.video/watch?v=660791655456048824
  // https://cinnamon.video/embed?v=660791655456048824


  if (isDomain(url, 'cinnamon.video') && pathSegments.length === 1 && ['watch', 'embed'].includes(pathSegments[0]) && url.searchParams.has('v')) {
    return {
      kind: 'cinnamon-video',
      data: url.searchParams.get('v')
    };
  }

  return null;
}
/** @deprecated renamed to parsePrimaryLink */

var parseEmbedLink = parsePrimaryLink;
function parseSecondaryLink(link) {
  var url = new URL(link);
  var pathSegments = splitPath(url); // https://vimeo.com/live-chat/123456/

  if (isDomain(url, 'vimeo.com') && pathSegments[0] === 'live-chat') {
    return {
      kind: 'vimeo-chat',
      data: pathSegments[1]
    };
  } // https://vimeo.com/event/123456/chat/interaction/


  if (isDomain(url, 'vimeo.com') && pathSegments.length === 4 && pathSegments[0] === 'event' && pathSegments[2] === 'chat' && pathSegments[3] === 'interaction') {
    return {
      kind: 'vimeo-event-chat',
      data: pathSegments[1]
    };
  }

  return null;
}
function getLocaleLinks(links, locale, fallback) {
  // First add the specific language links
  var result = links.filter(function (l) {
    return l.language === locale;
  }); // Add fallback languages afterwards, if different from the main language

  if (locale !== fallback) {
    result.push.apply(result, _toConsumableArray(links.filter(function (l) {
      return l.language === fallback;
    })));
  }

  return result;
}

function localiseFromObject(locale, object) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  for (var _i = 0, _arr = [locale].concat(_toConsumableArray(options.fallbacks || ['en'])); _i < _arr.length; _i++) {
    var key = _arr[_i];
    var value = object[key];
    if (value) return value;
  }

  return null;
}

function stripMarkdown(input) {
  return input.replaceAll(/\*\*(.*?)\*\*/g, function (_, match) {
    return match;
  }).replaceAll(/\[(.+?)\]\(.+?\)/g, function (_, match) {
    return match;
  }).replaceAll(/_(.*?)_/g, function (_, match) {
    return match;
  }).replaceAll(/_(.*?)_/g, function (_, match) {
    return match;
  }).replaceAll(/~~(.*?)~~/g, function (_, match) {
    return match;
  }).replaceAll(/`(.*?)`/g, function (_, match) {
    return match;
  }).replaceAll(/#{1,6}\s+/gm, '').replaceAll(/<.+?>/g, '');
}

/** not passing `kind` is @deprecated */
function createICalEvent(sessionId, kind) {
  return {
    eventName: "session/ical",
    payload: {
      sessionId: sessionId,
      kind: kind
    }
  };
}
function createAttendanceEvent(action, sessionId) {
  return {
    eventName: "attendance/".concat(action),
    payload: {
      sessionId: sessionId
    }
  };
}
function createLoginStartEvent(emailHash) {
  return {
    eventName: 'login/start',
    payload: {
      emailHash: emailHash
    }
  };
}
function createLoginFinishEvent() {
  return {
    eventName: 'login/finish',
    payload: {}
  };
}
function createLogoutEvent() {
  return {
    eventName: 'login/logout',
    payload: {}
  };
}
function createRegisterStartEvent(country) {
  return {
    eventName: 'register/start',
    payload: {
      country: country
    }
  };
}
function createUnregisterEvent(confirmed) {
  return {
    eventName: 'login/unregister',
    payload: {
      confirmed: confirmed
    }
  };
}
function createPageViewEvent(routeName, params) {
  return {
    eventName: 'general/pageView',
    payload: {
      routeName: routeName,
      params: params
    }
  };
}
function createSessionLinkEvent(sessionId, action, link) {
  return {
    eventName: 'session/link',
    payload: {
      sessionId: sessionId,
      action: action,
      link: link
    }
  };
}
function createAtriumWidgetEvent(widget) {
  return {
    eventName: 'atrium/widget',
    payload: {
      widget: widget
    }
  };
}

/** @deprecated */
function getDefaultRoutes(user, settings, t) {
  var routes = [];

  if (settings.atrium.visible) {
    routes.push({
      title: t('deconf.appLayout.atrium'),
      name: Routes.Atrium,
      enabled: settings.atrium.enabled,
      icon: undefined
    });
  }

  if (settings.whatsOn.visible) {
    routes.push({
      title: t('deconf.appLayout.whatsOn'),
      name: Routes.WhatsOn,
      enabled: settings.whatsOn.enabled,
      icon: undefined
    });
  }

  if (settings.schedule.visible) {
    routes.push({
      title: t('deconf.appLayout.schedule'),
      name: Routes.Schedule,
      enabled: Boolean(user) && settings.schedule.enabled,
      icon: undefined
    });
  }

  if (settings.coffeeChat.visible) {
    routes.push({
      title: t('deconf.appLayout.coffeeChat'),
      name: Routes.CoffeeChatLobby,
      enabled: Boolean(user) && settings.coffeeChat.enabled,
      icon: undefined
    });
  }

  if (settings.helpDesk.visible) {
    routes.push({
      title: t('deconf.appLayout.helpDesk'),
      name: Routes.HelpDesk,
      enabled: Boolean(user) && settings.helpDesk.enabled,
      icon: undefined
    });
  }

  return routes;
}
/** Guard a route against a PageFlag unless an admin is visiting */

function guardRoute(schedule, key, user, router) {
  if (user && user.user_roles.includes('admin')) return;
  if (!schedule) return;
  var flag = schedule[key];

  if (!flag || flag.enabled !== true || flag.visible !== true) {
    router.replace({
      name: Routes.NotFound
    });
  }
}
/**
 * Generate a title for a given route, based on `meta.pageTitle` i18n key,
 * plus `deconf.general.appName`.
 */

function getRouteTitle(route, i18n) {
  var routeWithTitle = _toConsumableArray(route.matched).reverse().find(function (r) {
    return r.meta.pageTitle;
  });

  var appName = i18n.t('deconf.general.appName');
  if (!routeWithTitle) return appName;
  var pageName = i18n.t(routeWithTitle.meta.pageTitle);
  return [pageName, appName].join(' | ');
}
/** Generate a normal-ish scroll-behaviour for a SPA that wants to act like a webpage */

function getScrollBehaviour(scrollOffest) {
  return function (to, from, savedPosition) {
    // If they clicked on a hash, scroll to that
    if (to.hash && to.name !== Routes.TokenCapture) {
      return {
        selector: to.hash,
        offset: {
          x: 0,
          y: scrollOffest
        }
      };
    } // If they've been to the page, scroll back to there
    // Only available when navigating back via the browser


    if (savedPosition) return savedPosition; // Otherwise, its a new page so go to the top

    return {
      x: 0,
      y: 0
    };
  };
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray$5(arr, i) || _nonIterableRest();
}

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$3(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper$4(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$4(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$4(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$4(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$4(o, minLen); }

function _arrayLikeToArray$4(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/** Take a set of sessios and slots and group them by slot */
function groupSessionsBySlot(sessions, sessionSlots) {
  var bySlot = new Map();

  var _iterator = _createForOfIteratorHelper$4(sessions),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _session = _step.value;
      if (!_session.slot) continue;
      var match = bySlot.get(_session.slot);
      if (match) match.push(_session);else bySlot.set(_session.slot, [_session]);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return sessionSlots.map(function (slot) {
    return {
      slot: slot,
      sessions: bySlot.get(slot.id) || []
    };
  }).filter(function (slotted) {
    return slotted.sessions.length > 0;
  });
}
function groupSessionsByDay(sessions, sessionSlots) {
  // Group sessions by their slot
  var slottedSessions = groupSessionsBySlot(sessions, sessionSlots); // Generate a key based on a date (excluding time)

  var keyify = function keyify(d) {
    return startOfDay(d).toISOString();
  }; // Group slots (and their sessions) by the day that they are on
  // Only include where there are sessions


  var groupedByDay = new Map();

  var _iterator2 = _createForOfIteratorHelper$4(slottedSessions),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var group = _step2.value;
      if (group.sessions.length === 0) continue;
      var key = keyify(group.slot.start);
      var groups = groupedByDay.get(key) || [];
      groups.push(group);
      groupedByDay.set(key, groups);
    } // Bundle the date-mapped groups into an single array for return

  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  var output = [];

  var _iterator3 = _createForOfIteratorHelper$4(groupedByDay),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _step3$value = _slicedToArray(_step3.value, 2),
          day = _step3$value[0],
          _groups = _step3$value[1];

      var date = new Date(day);
      var title = friendlyDate(date);
      output.push({
        date: date,
        title: title,
        groups: _groups
      });
    } // Make sure the days are in order

  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  output.sort(function (a, b) {
    return a.date.getTime() - b.date.getTime();
  }); // Make sure each day's slots-groups are in the right order

  for (var _i = 0, _output = output; _i < _output.length; _i++) {
    var item = _output[_i];
    item.groups.sort(function (a, b) {
      return a.slot.start.getTime() - b.slot.start.getTime();
    });
  }

  return output;
}
/** Load and parse schedule filters from localStorage, setting missing default values */

function loadScheduleFilters(key) {
  try {
    var json = localStorage.getItem(key);
    if (!json) throw new Error();
    var urlFilters = JSON.parse(json);

    var filters = _objectSpread$3(_objectSpread$3({}, decodeScheduleFilters(urlFilters)), {}, {
      viewMode: decoder.enum(urlFilters.viewMode, ['all', 'user'])
    });

    return filters;
  } catch (error) {
    return decodeScheduleFilters({});
  }
}
/** Determine if any of the filters in a record are "active" */

function filtersAreSet(filters) {
  return Object.keys(filters).filter(function (k) {
    return k !== 'viewMode';
  }).some(function (k) {
    return Boolean(filters[k]);
  });
}
/** A method used to yes/no a session based on some unknown logic */

/**
 * Create a SessionPredicate based on a text query an a locale
 * Returns null when no query should be applied
 */
function createQueryPredicate(locale, query, schedule) {
  if (!query || !query.trim()) return null; // A little method to trim down a string, removing excess whitespace and casing

  var trim = function trim(input) {
    return input.toLowerCase().replace(/\s+/g, ' ');
  }; // Cache a trimmed version of the query and have a method to test a string matches it


  var trimmedQuery = trim(query);

  var matchesQuery = function matchesQuery(input) {
    return trim(input).includes(trimmedQuery);
  }; // Cache a map of speaker-id to their name for easy lookups


  var speakerNames = new Map(schedule.speakers.map(function (s) {
    return [s.id, s.name];
  })); // Create a SessionPredicate to match if a session contains a text value
  // Based on OR logic so passes if any sub-value matches the string.
  // So it returns true as soon as possible.

  return function (session) {
    if (matchesQuery(session.id)) return true; // Check the session title

    var title = localiseFromObject(locale, session.title);
    if (title && matchesQuery(title)) return true; // Check the speaker names

    var speakers = session.speakers.map(function (s) {
      return speakerNames.get(s);
    });
    if (speakers.some(function (name) {
      return name && matchesQuery(name);
    })) return true; // At this point no strings matched

    return false;
  };
}
/**
 * Create a SessionPredicate based on a set of relational filters.
 * With null meaning "no filters apply"
 */

function createFilterPredicate(locale, filters, schedule) {
  if (!filtersAreSet(filters)) return null;
  var sessionType = filters.sessionType,
      track = filters.track,
      date = filters.date,
      isRecorded = filters.isRecorded,
      theme = filters.theme,
      language = filters.language; // Cache a map of slot-id to slot for easy lookups

  var sessionSlotMap = new Map(schedule.slots.map(function (s) {
    return [s.id, s];
  })); // Cache a text-based query predicate

  var queryPredicate = createQueryPredicate(locale, filters.query, schedule); // Create a predicate based on cached values to determine if a session
  // matches the set filters.
  // Based on AND logic so all parts of the filter (if set) must match.
  // So it returns false as soon as possible.

  return function (session) {
    // Check the text query
    if (queryPredicate && !queryPredicate(session)) return false; // Check the session type

    if (sessionType !== null && session.type !== sessionType) return false; // Check the track

    if (track !== null && session.track !== track) return false; // Check for themes

    if (theme !== null && !session.themes.includes(theme)) return false; // Check for language

    if (language !== null && !session.hostLanguages.includes(language)) {
      return false;
    } // Check the date


    var slot = session.slot ? sessionSlotMap.get(session.slot) : null;
    if (date && !slot) return false;
    if (date && slot && !isSameDay(slot.start, date)) return false; // Check if recorded

    if (isRecorded !== null && session.isRecorded !== isRecorded) return false; // If all logic passed at this point, the session matches

    return true;
  };
}
/** Determine if the cofference is happening right now or not */

function isDuringConference(scheduleDate, appSettings) {
  if (!appSettings) return false;
  return appSettings.startDate.getTime() < scheduleDate.getTime() && appSettings.endDate.getTime() > scheduleDate.getTime();
}
function getFeaturedSessions(schedule, daysInFuture, currentDate, predicate) {
  if (!schedule) return null;
  if (!schedule.settings.schedule.enabled) return null;
  var now = currentDate.getTime();
  var inTheFuture = now + daysInFuture * 24 * 60 * 60 * 1000;
  var slotMap = new Map(schedule.slots.map(function (s) {
    return [s.id, s];
  }));
  return schedule.sessions.filter(function (session) {
    return Boolean(session.slot) && predicate(session);
  }).map(function (session) {
    return {
      slot: slotMap.get(session.slot),
      session: session
    };
  }).filter(function (group) {
    return Boolean(group.slot) && group.slot.end.getTime() > now && group.slot.start.getTime() < inTheFuture;
  }).sort(function (a, b) {
    return a.slot.start.getTime() - b.slot.start.getTime();
  });
}
function encodeScheduleFilters(filters) {
  return stripNulls({
    query: encoder.string(filters.query),
    sessionType: encoder.string(filters.sessionType),
    track: encoder.string(filters.track),
    theme: encoder.string(filters.theme),
    language: encoder.string(filters.language),
    date: encoder.date(filters.date),
    isRecorded: encoder.boolean(filters.isRecorded)
  });
}
function decodeUrlScheduleFilters(input) {
  if (Object.keys(input).length === 0) return null;
  return decodeScheduleFilters(input);
}
function decodeScheduleFilters(input) {
  return {
    viewMode: 'all',
    query: decoder.string(input.query) || '',
    sessionType: decoder.string(input.sessionType),
    track: decoder.string(input.track),
    theme: decoder.string(input.theme),
    date: decoder.date(input.date),
    isRecorded: decoder.boolean(input.isRecorded),
    language: decoder.string(input.language)
  };
}
var encoder = {
  string: function string(value) {
    return typeof value === 'string' && value ? value : null;
  },
  boolean: function boolean(value) {
    if (typeof value !== 'boolean') return null;
    return value ? 'true' : 'false';
  },
  date: function date(value) {
    return value instanceof Date ? value.toISOString() : null;
  },
  enum: function _enum(value, options) {
    return options.includes(value) ? value : null;
  }
};
var decoder = {
  string: function string(value) {
    return typeof value === 'string' ? value : null;
  },
  boolean: function boolean(value) {
    if (value === 'true') return true;
    if (value === 'false') return false;
    return null;
  },
  date: function date(value) {
    if (typeof value !== 'string') return null;
    var date = new Date(value);
    if (Number.isNaN(date.getTime())) return null;
    return date;
  },
  enum: function _enum(value, options) {
    return options.includes(value) ? value : options[0];
  }
};

function stripNulls(input) {
  return Object.fromEntries(Object.entries(input).filter(function (pair) {
    return pair[1] !== null;
  }));
}

function getSlug(input) {
  return input.toLowerCase().trim().replace(/\s+/g, '-').replace(/-+/g, '-').replace(/[^\w-]+/g, '');
}

/** Get the earliest and lastest dates based on a set of sessions */
function getScheduleStartAndEnd(sessions, schedule) {
  var slots = new Map(schedule.slots.map(function (s) {
    return [s.id, s];
  }));
  var firstDate = null;
  var lastDate = null;

  var _iterator4 = _createForOfIteratorHelper$4(sessions),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var _session2 = _step4.value;
      var slot = _session2.slot ? slots.get(_session2.slot) : undefined;
      if (!slot) continue;

      if (!firstDate || slot.start.getTime() < firstDate.getTime()) {
        firstDate = slot.start;
      }

      if (!lastDate || slot.end.getTime() > lastDate.getTime()) {
        lastDate = slot.end;
      }
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  if (!firstDate || !lastDate) return null;
  return {
    start: firstDate,
    end: lastDate
  };
}
/** Wether a `Date` is inside a `DateRange` */

function isInRange(range, date) {
  return date.getTime() >= range.start.getTime() && date.getTime() <= range.end.getTime();
}
/**
 * Create a new schedule record with only the relevant resource in it.
 * It looks through each session and only keeps slots/speakers/themes/tracks/types
 * that existing on the provided sessions.
 */

function filterScheduleFromSessions(schedule, sessions) {
  var slotIds = new Set();
  var speakerIds = new Set();
  var themeIds = new Set();
  var trackIds = new Set();
  var typeIds = new Set();

  var _iterator5 = _createForOfIteratorHelper$4(sessions),
      _step5;

  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var _session3 = _step5.value;
      if (_session3.slot) slotIds.add(_session3.slot);
      if (_session3.track) trackIds.add(_session3.track);
      if (_session3.type) typeIds.add(_session3.type);

      _session3.speakers.forEach(function (id) {
        return speakerIds.add(id);
      });

      _session3.themes.forEach(function (id) {
        return themeIds.add(id);
      });
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }

  var slots = schedule.slots.filter(function (s) {
    return slotIds.has(s.id);
  });
  var speakers = schedule.speakers.filter(function (s) {
    return speakerIds.has(s.id);
  });
  var themes = schedule.themes.filter(function (s) {
    return themeIds.has(s.id);
  });
  var tracks = schedule.tracks.filter(function (s) {
    return trackIds.has(s.id);
  });
  var types = schedule.types.filter(function (s) {
    return typeIds.has(s.id);
  });
  return _objectSpread$3(_objectSpread$3({}, schedule), {}, {
    slots: slots,
    speakers: speakers,
    themes: themes,
    tracks: tracks,
    types: types
  });
}

function _createForOfIteratorHelper$3(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$3(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$3(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$3(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$3(o, minLen); }

function _arrayLikeToArray$3(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function filterGroups(days, predicate) {
  return days.map(function (day) {
    return {
      title: day.title,
      date: day.date,
      groups: day.groups.filter(function (g) {
        return predicate(g);
      })
    };
  }).filter(function (d) {
    return d.groups.length > 0;
  });
}

function scheduleComputed() {
  return {
    filterPredicate: function filterPredicate() {
      return createFilterPredicate(this.$i18n.locale, this.filters, this.schedule);
    },
    filteredSessions: function filteredSessions() {
      var _this = this;

      var showUserSessions = this.filters.viewMode === 'user';
      var userSessions = new Set(this.userSessions);
      return this.sessions.filter(function (session) {
        if (showUserSessions && !userSessions.has(session.id)) return false;
        if (_this.filterPredicate && !_this.filterPredicate(session)) return false;
        return true;
      });
    },
    sessionsByDay: function sessionsByDay() {
      return groupSessionsByDay(this.filteredSessions, this.schedule.slots);
    },
    previousDays: function previousDays() {
      // If outside the conference or there is an active filter, do nothing
      if (!this.isDuringConference || this.filterPredicate) return null;
      var now = this.scheduleDate.getTime();
      return filterGroups(this.sessionsByDay, function (group) {
        return group.slot.end.getTime() < now;
      });
    },
    upcomingDays: function upcomingDays() {
      if (this.filterPredicate !== null) return this.searchResults;
      if (!this.isDuringConference) return this.sessionsByDay;
      var now = this.scheduleDate.getTime();
      return filterGroups(this.sessionsByDay, function (group) {
        return group.slot.end.getTime() > now;
      });
    },
    searchResults: function searchResults() {
      if (!this.filterPredicate) return null;
      var result = groupSessionsByDay(this.filteredSessions, this.schedule.slots); // Add "search result" text to each day's title
      // written in a backwards-compatable array, so it still works
      // if the i18n string isn't set

      var _iterator = _createForOfIteratorHelper$3(result),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          var newTitle = this.$t('deconf.schedule.resultHeading', [item.title]);
          item.title = newTitle !== 'deconf.schedule.resultHeading' ? newTitle : "".concat(item.title, " - Search Results");
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return result;
    }
  };
}

var oneHour = 60 * 60 * 1000;
function getSlotState(currentDate, startDate, endDate) {
  var now = currentDate.getTime();
  var start = startDate.getTime();
  var end = endDate.getTime();
  if (now < start && now > start - oneHour) return 'soon';
  if (now < start) return 'future';
  if (now > end) return 'past';
  return 'present';
}

function _createForOfIteratorHelper$2(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$2(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen); }

function _arrayLikeToArray$2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/** A "this" value with a partially strongly typed state */

/** A generated set of "computed" values to retrieve namespaced state */

/** Creates a strongly-typed "mapXState" method for easier vuex + TypeScript */
function createStateMapper() {
  return function (namespace, keys) {
    var output = {};

    var _iterator = _createForOfIteratorHelper$2(keys),
        _step;

    try {
      var _loop = function _loop() {
        var key = _step.value;

        output[key] = function () {
          return this.$store.state[namespace][key];
        };
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return output;
  };
}

/**
 * A plugin to provide a $temporal.date object that can be bound to in components.
 * The date is only updated every `interval` milliseconds.
 *
 * It uses an internal Vue instance to with object getters to provide reactivity.
 */
var TemporalPlugin = /*#__PURE__*/function () {
  function TemporalPlugin(Vue, interval) {
    _classCallCheck(this, TemporalPlugin);

    _defineProperty(this, "timerId", null);

    this.interval = interval;
    this._vm = new Vue({
      data: function data() {
        return {
          date: new Date()
        };
      }
    });
  }

  _createClass(TemporalPlugin, [{
    key: "date",
    get: function get() {
      return this._vm.date;
    },
    set: function set(newValue) {
      this._vm.date = newValue;
    }
  }, {
    key: "setup",
    value: function setup() {
      var _this = this;

      this.teardown();
      this.timerId = window.setInterval(function () {
        _this.date = new Date();
      }, this.interval);
    }
  }, {
    key: "teardown",
    value: function teardown() {
      if (!this.timerId) return;
      window.clearInterval(this.timerId);
      this.timerId = null;
    }
  }], [{
    key: "install",
    value: function install(Vue) {
      var interval = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
      Vue.prototype.$temporal = new TemporalPlugin(Vue, interval);
    }
  }]);

  return TemporalPlugin;
}();
function pause(ms) {
  return new Promise(function (resolve) {
    return window.setTimeout(resolve, ms);
  });
}

// i18n
// - deconf.addToCalendarDialog.title
// - deconf.addToCalendarDialog.ical
// - deconf.addToCalendarDialog.google
// - deconf.addToCalendarDialog.cancel
//
// icons
// - fas calendar-plus
// - fab google
//
// sass
// - $addToCalendarDialog-titleFamily
// - $addToCalendarDialog-titleSize
// - $addToCalendarDialog-titleWeight
//

var script$$ = {
  name: 'AddToCalendarDialog',
  components: {
    FontAwesomeIcon: FontAwesomeIcon
  },
  props: {
    session: {
      type: Object,
      required: true
    }
  },
  computed: {
    icalLink: function icalLink() {
      return this.$deconf.getCalendarLink(this.session, 'ical');
    },
    googleLink: function googleLink() {
      return this.$deconf.getCalendarLink(this.session, 'google');
    }
  },
  methods: {
    finish: function finish(kind) {
      this.$deconf.trackMetric(createICalEvent(this.session.id, kind));
      this.$deconf.closeDialog();
    },
    cancel: function cancel() {
      this.$deconf.closeDialog();
    }
  }
};

/* script */
var __vue_script__$$ = script$$;
/* template */

var __vue_render__$$ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "addToCalendarDialog"
  }, [_c('header', {
    staticClass: "addToCalendarDialog-header"
  }, [_c('h1', {
    staticClass: "addToCalendarDialog-title"
  }, [_vm._v(" " + _vm._s(_vm.$t('deconf.addToCalendarDialog.title')) + " ")]), _c('p', {
    staticClass: "addToCalendarDialog-body"
  }, [_vm._v(" " + _vm._s(_vm.$t('deconf.addToCalendarDialog.info')) + " ")])]), _c('section', {
    staticClass: "addToCalendarDialog-actions"
  }, [_vm.icalLink ? _c('a', {
    staticClass: "button is-fullwidth is-link is-medium",
    attrs: {
      "href": _vm.icalLink,
      "target": "_blank",
      "rel": "nofollow"
    },
    on: {
      "click": function click($event) {
        return _vm.finish('ical');
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('FontAwesomeIcon', {
    attrs: {
      "icon": ['fas', 'calendar-plus']
    }
  })], 1), _c('span', [_vm._v(" " + _vm._s(_vm.$t('deconf.addToCalendarDialog.ical')) + " ")])]) : _vm._e(), _vm.googleLink ? _c('a', {
    staticClass: "button is-fullwidth is-google is-medium",
    attrs: {
      "href": _vm.googleLink,
      "target": "_blank",
      "rel": "nofollow"
    },
    on: {
      "click": function click($event) {
        return _vm.finish('google');
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('FontAwesomeIcon', {
    attrs: {
      "icon": ['fab', 'google']
    }
  })], 1), _c('span', [_vm._v(" " + _vm._s(_vm.$t('deconf.addToCalendarDialog.google')) + " ")])]) : _vm._e(), _c('button', {
    staticClass: "button is-danger is-light is-medium is-fullwidth addToCalendarDialog-cancel",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('deconf.addToCalendarDialog.cancel')) + " ")])])]);
};

var __vue_staticRenderFns__$$ = [];
/* style */

var __vue_inject_styles__$10 = undefined;
/* scoped */

var __vue_scope_id__$10 = undefined;
/* module identifier */

var __vue_module_identifier__$10 = undefined;
/* functional template */

var __vue_is_functional_template__$10 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$10 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$$,
  staticRenderFns: __vue_staticRenderFns__$$
}, __vue_inject_styles__$10, __vue_script__$$, __vue_scope_id__$10, __vue_is_functional_template__$10, __vue_module_identifier__$10, false, undefined, undefined, undefined);

// i18n
// - deconf.addToCalendar.action - Button to add to calendar
//
// icons
// - fas calendar-plus
//
// sass
// - n/a
//
// notes
// - passing the `calendar-link` prop is deprecated, pass a `session` instead
//

var script$_ = {
  name: 'AddToCalendar',
  components: {
    FontAwesomeIcon: FontAwesomeIcon
  },
  props: {
    calendarLink: {
      type: String,
      default: null
    },
    session: {
      type: Object,
      default: null
    }
  },
  methods: {
    onClickLink: function onClickLink(event) {
      this.$emit('click', event);
    },
    onClickButton: function onClickButton(event) {
      this.$emit('click', event);
      this.$deconf.showDialog(__vue_component__$10, {
        session: this.session
      }, {
        size: 'small'
      });
    }
  }
};

/* script */
var __vue_script__$_ = script$_;
/* template */

var __vue_render__$_ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.session ? _c('button', {
    staticClass: "addToCalendar button",
    on: {
      "click": _vm.onClickButton
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('FontAwesomeIcon', {
    attrs: {
      "icon": ['fas', 'calendar-plus']
    }
  })], 1), _c('span', [_vm._v(" " + _vm._s(_vm.$t('deconf.addToCalendar.action')) + " ")])]) : _vm.calendarLink ? _c('a', {
    staticClass: "addToCalendar button",
    attrs: {
      "href": _vm.calendarLink,
      "target": "_blank",
      "rel": "noopener"
    },
    on: {
      "click": _vm.onClickLink
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('FontAwesomeIcon', {
    attrs: {
      "icon": ['fas', 'calendar-plus']
    }
  })], 1), _c('span', [_vm._v(" " + _vm._s(_vm.$t('deconf.addToCalendar.action')) + " ")])]) : _vm._e();
};

var __vue_staticRenderFns__$_ = [];
/* style */

var __vue_inject_styles__$$ = undefined;
/* scoped */

var __vue_scope_id__$$ = undefined;
/* module identifier */

var __vue_module_identifier__$$ = undefined;
/* functional template */

var __vue_is_functional_template__$$ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$$ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$_,
  staticRenderFns: __vue_staticRenderFns__$_
}, __vue_inject_styles__$$, __vue_script__$_, __vue_scope_id__$$, __vue_is_functional_template__$$, __vue_module_identifier__$$, false, undefined, undefined, undefined);

// i18n
// - n/a
//
// icons
// - n/a
//
// sass
// - n/a
//

var script$Z = {
  components: {
    FontAwesomeIcon: FontAwesomeIcon
  },
  props: {
    ltr: {
      type: Array,
      required: true
    },
    rtl: {
      type: Array,
      required: true
    }
  }
};

/* script */
var __vue_script__$Z = script$Z;
/* template */

var __vue_render__$Z = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('span', [_c('span', {
    staticClass: "icon ltr-only"
  }, [_c('FontAwesomeIcon', {
    attrs: {
      "icon": _vm.ltr
    }
  })], 1), _c('span', {
    staticClass: "icon rtl-only"
  }, [_c('FontAwesomeIcon', {
    attrs: {
      "icon": _vm.rtl
    }
  })], 1)]);
};

var __vue_staticRenderFns__$Z = [];
/* style */

var __vue_inject_styles__$_ = undefined;
/* scoped */

var __vue_scope_id__$_ = undefined;
/* module identifier */

var __vue_module_identifier__$_ = undefined;
/* functional template */

var __vue_is_functional_template__$_ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$_ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$Z,
  staticRenderFns: __vue_staticRenderFns__$Z
}, __vue_inject_styles__$_, __vue_script__$Z, __vue_scope_id__$_, __vue_is_functional_template__$_, __vue_module_identifier__$_, false, undefined, undefined, undefined);

var actions = {
  future: 'deconf.joinSession.future',
  soon: 'deconf.joinSession.present',
  present: 'deconf.joinSession.present',
  past: 'deconf.joinSession.past'
}; //
// i18n
// - deconf.joinSession.past - Button for a session in the past
// - deconf.joinSession.present - Button for a session thats live
// - deconf.joinSession.future - Button for a session in the future
//
// icons
// - fas arrow-left
// - fas arrow-right
//
// sass
// - n/a
//

var script$Y = {
  name: 'JoinSession',
  components: {
    BidirectionalIcon: __vue_component__$_
  },
  props: {
    slotState: {
      type: String,
      required: true
    },
    sessionId: {
      type: String,
      required: true
    }
  },
  computed: {
    classes: function classes() {
      return {
        'is-success': ['present', 'past'].includes(this.slotState)
      };
    },
    action: function action() {
      return actions[this.slotState] || actions.past;
    },
    sessionRoute: function sessionRoute() {
      return {
        name: Routes.Session,
        params: {
          sessionId: this.sessionId
        }
      };
    }
  }
};

/* script */
var __vue_script__$Y = script$Y;
/* template */

var __vue_render__$Y = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('router-link', {
    staticClass: "joinSession button",
    class: _vm.classes,
    attrs: {
      "to": _vm.sessionRoute
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t(_vm.action)) + " ")]), _c('BidirectionalIcon', {
    attrs: {
      "ltr": ['fas', 'arrow-right'],
      "rtl": ['fas', 'arrow-left']
    }
  })], 1);
};

var __vue_staticRenderFns__$Y = [];
/* style */

var __vue_inject_styles__$Z = undefined;
/* scoped */

var __vue_scope_id__$Z = undefined;
/* module identifier */

var __vue_module_identifier__$Z = undefined;
/* functional template */

var __vue_is_functional_template__$Z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$Z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$Y,
  staticRenderFns: __vue_staticRenderFns__$Y
}, __vue_inject_styles__$Z, __vue_script__$Y, __vue_scope_id__$Z, __vue_is_functional_template__$Z, __vue_module_identifier__$Z, false, undefined, undefined, undefined);

//
// i18n
// - deconf.sessionAttributes.isRecorded
// - deconf.sessionAttributes.notRecorded
//
// icons
// - fas globe
// - fas save
// - fas code-branch
// - fas tags
// - fas id-badge
//
// sass
// - $sessionAttributes-color
// - $sessionAttributes-strong
//
// makeBold enum:
// - locale
// - recorded
// - track
//
var script$X = {
  name: 'SessionAttributes',
  components: {
    FontAwesomeIcon: FontAwesomeIcon
  },
  props: {
    languages: {
      type: Array,
      default: null
    },
    isRecorded: {
      type: Boolean,
      default: null
    },
    track: {
      type: Object,
      default: null
    },
    themes: {
      type: Array,
      default: null
    },
    organisation: {
      type: String,
      default: null
    }
  },
  methods: {
    localise: function localise(object) {
      return localiseFromObject(this.$i18n.locale, object);
    }
  }
};

/* script */
var __vue_script__$X = script$X;
/* template */

var __vue_render__$X = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "sessionAttributes"
  }, [_vm.languages !== null ? _c('span', {
    staticClass: "sessionAttributes-attribute sessionAttributes-attribute-languages"
  }, [_c('span', {
    staticClass: "icon-text"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('FontAwesomeIcon', {
    attrs: {
      "icon": ['fas', 'globe'],
      "fixed-width": ""
    }
  })], 1), _c('span', {
    staticClass: "is-uppercase"
  }, [_vm._v(" " + _vm._s(_vm.languages.join('/')) + " ")])])]) : _vm._e(), _vm.organisation !== null ? _c('span', {
    staticClass: "sessionAttributes-attribute sessionAttributes-attribute-org"
  }, [_c('span', {
    staticClass: "icon-text"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('FontAwesomeIcon', {
    attrs: {
      "icon": ['fas', 'id-badge'],
      "fixed-width": ""
    }
  })], 1), _c('span', [_vm._v(" " + _vm._s(_vm.organisation) + " ")])])]) : _vm._e(), _vm.track !== null ? _c('span', {
    staticClass: "sessionAttributes-attribute sessionAttributes-attribute-track"
  }, [_c('span', {
    staticClass: "icon-text"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('FontAwesomeIcon', {
    attrs: {
      "icon": ['fas', 'code-branch'],
      "fixed-width": ""
    }
  })], 1), _c('span', [_vm._v(" " + _vm._s(_vm.localise(_vm.track.title)) + " ")])])]) : _vm._e(), _vm.themes !== null && _vm.themes.length > 0 ? _c('span', {
    staticClass: "sessionAttributes-attribute sessionAttributes-attribute-themes"
  }, [_c('span', {
    staticClass: "icon-text"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('FontAwesomeIcon', {
    attrs: {
      "icon": ['fas', 'tags'],
      "fixed-width": ""
    }
  })], 1), _c('span', [_vm._v(" " + _vm._s(_vm.themes.map(function (t) {
    return _vm.localise(t.title);
  }).join(', ')) + " ")])])]) : _vm._e(), _vm.isRecorded !== null ? _c('span', {
    staticClass: "sessionAttributes-attribute sessionAttributes-attribute-isRecorded"
  }, [_c('span', {
    staticClass: "icon-text"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('FontAwesomeIcon', {
    attrs: {
      "icon": ['fas', 'save'],
      "fixed-width": ""
    }
  })], 1), _vm.isRecorded ? _c('span', [_vm._v(" " + _vm._s(_vm.$t('deconf.sessionAttributes.isRecorded')) + " ")]) : _c('span', [_vm._v(" " + _vm._s(_vm.$t('deconf.sessionAttributes.notRecorded')) + " ")])])]) : _vm._e()]);
};

var __vue_staticRenderFns__$X = [];
/* style */

var __vue_inject_styles__$Y = undefined;
/* scoped */

var __vue_scope_id__$Y = undefined;
/* module identifier */

var __vue_module_identifier__$Y = undefined;
/* functional template */

var __vue_is_functional_template__$Y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$Y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$X,
  staticRenderFns: __vue_staticRenderFns__$X
}, __vue_inject_styles__$Y, __vue_script__$X, __vue_scope_id__$Y, __vue_is_functional_template__$Y, __vue_module_identifier__$Y, false, undefined, undefined, undefined);

//
// i18n
// - n/a
//
// icons
// - fas code-branch
// - fas tags
// - [from SessionType prop]
//
// sass
// - $sessionHeader-color
// - $sessionHeader-weight
//
var script$W = {
  name: 'SessionHeader',
  components: {
    FontAwesomeIcon: FontAwesomeIcon
  },
  props: {
    sessionType: {
      type: Object,
      default: null
    },
    track: {
      type: Object,
      default: null
    },
    themes: {
      type: Array,
      default: null
    }
  },
  methods: {
    localise: function localise(object) {
      return localiseFromObject(this.$i18n.locale, object);
    }
  }
};

/* script */
var __vue_script__$W = script$W;
/* template */

var __vue_render__$W = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "sessionHeader"
  }, [_c('div', {
    staticClass: "icon-text"
  }, [_vm.sessionType ? [_c('span', {
    staticClass: "icon"
  }, [_c('FontAwesomeIcon', {
    attrs: {
      "icon": [_vm.sessionType.iconGroup, _vm.sessionType.iconName],
      "size": "lg",
      "fixed-width": ""
    }
  })], 1), _c('span', {
    staticClass: "text"
  }, [_vm._v(" " + _vm._s(_vm.localise(_vm.sessionType.title)) + " ")])] : _vm._e(), _vm.track ? [_c('span', {
    staticClass: "icon"
  }, [_c('FontAwesomeIcon', {
    attrs: {
      "icon": ['fas', 'code-branch'],
      "size": "lg",
      "fixed-width": ""
    }
  })], 1), _c('span', {
    staticClass: "text"
  }, [_vm._v(" " + _vm._s(_vm.localise(_vm.track.title)) + " ")])] : _vm._e(), _vm.themes && _vm.themes.length > 0 ? [_c('span', {
    staticClass: "icon"
  }, [_c('FontAwesomeIcon', {
    attrs: {
      "icon": ['fas', 'tags'],
      "size": "lg",
      "fixed-width": ""
    }
  })], 1), _c('span', {
    staticClass: "text"
  }, [_vm._v(" " + _vm._s(_vm.themes.map(function (t) {
    return _vm.localise(t.title);
  }).join(', ')) + " ")])] : _vm._e()], 2)]);
};

var __vue_staticRenderFns__$W = [];
/* style */

var __vue_inject_styles__$X = undefined;
/* scoped */

var __vue_scope_id__$X = undefined;
/* module identifier */

var __vue_module_identifier__$X = undefined;
/* functional template */

var __vue_is_functional_template__$X = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$X = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$W,
  staticRenderFns: __vue_staticRenderFns__$W
}, __vue_inject_styles__$X, __vue_script__$W, __vue_scope_id__$X, __vue_is_functional_template__$X, __vue_module_identifier__$X, false, undefined, undefined, undefined);

//
// i18n
// - n/a
//
// icons
// - n/a
//
// sass
// - $fullScreenDialog-background
// - $fullScreenDialog-boxRadius
// - $fullScreenDialog-boxBackground
// - $fullScreenDialig-regular
// - $fullScreenDialig-small
//
var dialogSizes = ['small', 'regular'];
var script$V = {
  name: 'FullScreenDialog',
  props: {
    size: {
      type: String,
      default: 'regular',
      validator: function validator(v) {
        return dialogSizes.includes(v);
      }
    }
  },
  computed: {
    classes: function classes() {
      return {
        'is-small': this.size === 'small'
      };
    }
  },
  mounted: function mounted() {
    // Stop window scroll
    document.documentElement.classList.add('has-dialog');
  },
  destroyed: function destroyed() {
    // Stop window scroll
    document.documentElement.classList.remove('has-dialog');
  },
  methods: {
    onBackgroundClick: function onBackgroundClick(event) {
      if (event.target !== this.$el) return;
      this.$emit('close');
    }
  }
};

/* script */
var __vue_script__$V = script$V;
/* template */

var __vue_render__$V = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "fullScreenDialog",
    class: _vm.classes,
    on: {
      "click": _vm.onBackgroundClick
    }
  }, [_c('div', {
    staticClass: "fullScreenDialog-box"
  }, [_vm._t("default")], 2)]);
};

var __vue_staticRenderFns__$V = [];
/* style */

var __vue_inject_styles__$W = undefined;
/* scoped */

var __vue_scope_id__$W = undefined;
/* module identifier */

var __vue_module_identifier__$W = undefined;
/* functional template */

var __vue_is_functional_template__$W = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$W = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$V,
  staticRenderFns: __vue_staticRenderFns__$V
}, __vue_inject_styles__$W, __vue_script__$V, __vue_scope_id__$W, __vue_is_functional_template__$W, __vue_module_identifier__$W, false, undefined, undefined, undefined);

//
// i18n
// - n/a
//
// icons
// - n/a
//
// sass
// - n/a
//
var script$U = {
  name: 'AppDialog',
  components: {
    FullScreenDialog: __vue_component__$W
  },
  props: {
    dialogPlugin: {
      type: Object,
      required: true
    }
  }
};

/* script */
var __vue_script__$U = script$U;
/* template */

var __vue_render__$U = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.dialogPlugin.component ? _c('FullScreenDialog', {
    on: {
      "close": function close($event) {
        return _vm.dialogPlugin.close();
      }
    }
  }, [_c(_vm.dialogPlugin.component, _vm._b({
    tag: "component"
  }, 'component', _vm.dialogPlugin.props, false))], 1) : _vm._e();
};

var __vue_staticRenderFns__$U = [];
/* style */

var __vue_inject_styles__$V = undefined;
/* scoped */

var __vue_scope_id__$V = undefined;
/* module identifier */

var __vue_module_identifier__$V = undefined;
/* functional template */

var __vue_is_functional_template__$V = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$V = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$U,
  staticRenderFns: __vue_staticRenderFns__$U
}, __vue_inject_styles__$V, __vue_script__$U, __vue_scope_id__$V, __vue_is_functional_template__$V, __vue_module_identifier__$V, false, undefined, undefined, undefined);

// i18n
// - deconf.apiMessage.loginExpired.title
// - deconf.apiMessage.loginExpired.info
// - deconf.apiMessage.loginExpired.action
// - deconf.apiMessage.unknown.title
// - deconf.apiMessage.unknown.info
// - deconf.apiMessage.unknown.email
//
// icons
// - n/a
//
// sass
// - n/a
//

var script$T = {
  name: 'ApiMessage',
  props: {
    errorCode: {
      type: String,
      default: 'unknown'
    }
  },
  computed: {
    loginRoute: function loginRoute() {
      return {
        name: Routes.Login
      };
    }
  }
};

/* script */
var __vue_script__$T = script$T;
/* template */

var __vue_render__$T = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "content"
  }, [_vm.errorCode === 'login_expired' ? [_c('h1', [_vm._v(_vm._s(_vm.$t('deconf.apiMessage.loginExpired.title')))]), _c('p', [_vm._v(_vm._s(_vm.$t('deconf.apiMessage.loginExpired.info')))]), _c('p', [_c('router-link', {
    staticClass: "button is-link",
    attrs: {
      "to": _vm.loginRoute
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('deconf.apiMessage.loginExpired.action')) + " ")])], 1)] : [_c('h1', [_vm._v(_vm._s(_vm.$t('deconf.apiMessage.unknown.title')))]), _c('p', [_vm._v(_vm._s(_vm.$t('deconf.apiMessage.unknown.info')))]), _c('p', [_c('a', {
    attrs: {
      "href": "mailto:" + _vm.$t('deconf.apiMessage.unknown.email')
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('deconf.apiMessage.unknown.email')) + " ")])])]], 2);
};

var __vue_staticRenderFns__$T = [];
/* style */

var __vue_inject_styles__$U = undefined;
/* scoped */

var __vue_scope_id__$U = undefined;
/* module identifier */

var __vue_module_identifier__$U = undefined;
/* functional template */

var __vue_is_functional_template__$U = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$U = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$T,
  staticRenderFns: __vue_staticRenderFns__$T
}, __vue_inject_styles__$U, __vue_script__$T, __vue_scope_id__$U, __vue_is_functional_template__$U, __vue_module_identifier__$U, false, undefined, undefined, undefined);

//
// i18n
// - n/a
//
// icons
// - n/a
//
// sass
// - n/a
//
var script$S = {
  name: 'FullHeight',
  data: function data() {
    return {
      windowHeight: window.innerHeight
    };
  },
  computed: {
    styles: function styles() {
      return {
        'min-height': "".concat(this.windowHeight, "px")
      };
    }
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.update);
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.update);
  },
  methods: {
    update: function update() {
      this.windowHeight = window.innerHeight;
    }
  }
};

/* script */
var __vue_script__$S = script$S;
/* template */

var __vue_render__$S = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "fullHeight",
    style: _vm.styles
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__$S = [];
/* style */

var __vue_inject_styles__$T = undefined;
/* scoped */

var __vue_scope_id__$T = undefined;
/* module identifier */

var __vue_module_identifier__$T = undefined;
/* functional template */

var __vue_is_functional_template__$T = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$T = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$S,
  staticRenderFns: __vue_staticRenderFns__$S
}, __vue_inject_styles__$T, __vue_script__$S, __vue_scope_id__$T, __vue_is_functional_template__$T, __vue_module_identifier__$T, false, undefined, undefined, undefined);

// A wrapper for utility-like pages on the site, like login or privacy
// - configure whether to show a language control or not
//
//
// i18n
// - n/a
//
// icons
// - n/a
//
// sass
// - $utilLayout-regular
// - $utilLayout-medium
// - $utilLayout-large
//

var script$R = {
  name: 'UtilLayout',
  components: {
    FullHeight: __vue_component__$T
  },
  props: {
    homeRoute: {
      type: [Object, String],
      required: true
    },
    width: {
      type: String,
      validator: function validator(v) {
        return ['regular', 'medium', 'large'].includes(v);
      },
      default: 'regular'
    }
  },
  computed: {
    pageClasses: function pageClasses() {
      return {
        'is-medium': this.width === 'medium',
        'is-large': this.width === 'large'
      };
    }
  }
};

/* script */
var __vue_script__$R = script$R;
/* template */

var __vue_render__$R = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('FullHeight', {
    staticClass: "utilLayout"
  }, [_c('nav', {
    staticClass: "utilLayout-nav",
    attrs: {
      "role": "navigation",
      "aria-label": "main navigation"
    }
  }, [_c('router-link', {
    staticClass: "utilLayout-item",
    attrs: {
      "to": _vm.homeRoute,
      "active-class": ""
    }
  }, [_vm._t("brand")], 2), _vm.$slots.languageControl ? _c('div', {
    staticClass: "utilLayout-item"
  }, [_vm._t("languageControl")], 2) : _vm._e()], 1), _c('div', {
    staticClass: "utilLayout-page",
    class: _vm.pageClasses
  }, [_c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "buttons"
  }, [_vm._t("backButton")], 2), _c('div', {
    staticClass: "box"
  }, [_vm._t("main")], 2)])]), _vm._t("footer")], 2);
};

var __vue_staticRenderFns__$R = [];
/* style */

var __vue_inject_styles__$S = undefined;
/* scoped */

var __vue_scope_id__$S = undefined;
/* module identifier */

var __vue_module_identifier__$S = undefined;
/* functional template */

var __vue_is_functional_template__$S = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$S = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$R,
  staticRenderFns: __vue_staticRenderFns__$R
}, __vue_inject_styles__$S, __vue_script__$R, __vue_scope_id__$S, __vue_is_functional_template__$S, __vue_module_identifier__$S, false, undefined, undefined, undefined);

// i18n
// - deconf.apiError.title - Title if the API is unreachable
// - deconf.apiError.content - Text if an the API is unreachable
// - deconf.apiError.retry - Message for retrying if the API is unreachable (^1)
// - deconf.general.hours
// - deconf.general.minutes
// - deconf.general.seconds
//
// icons
// - n/a
//
// sass
// - n/a
//

var TICK_INTERVAL = 500;
var script$Q = {
  name: 'ApiError',
  components: {
    UtilLayout: __vue_component__$S
  },
  props: {
    homeRoute: {
      type: Object,
      required: true
    },
    retry: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    var retryDate = new Date();
    retryDate.setMinutes(retryDate.getMinutes() + this.retry);
    return {
      timerId: null,
      retryDate: retryDate,
      currentDate: new Date()
    };
  },
  computed: {
    localeCountdown: function localeCountdown() {
      var _this = this;

      return getCountdownMessage(getCountdown(this.currentDate, this.retryDate), function (key, value) {
        return _this.$tc(key, value);
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.timerId = window.setInterval(function () {
      _this2.currentDate = new Date();

      var timeLeft = _this2.retryDate.getTime() - _this2.currentDate.getTime();

      if (timeLeft < 1500) {
        window.location.reload();
      }
    }, TICK_INTERVAL);
  },
  destroyed: function destroyed() {
    if (this.timerId) {
      window.clearInterval(this.timerId);
    }
  }
};

/* script */
var __vue_script__$Q = script$Q;
/* template */

var __vue_render__$Q = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('UtilLayout', {
    attrs: {
      "home-route": _vm.homeRoute
    }
  }, [_vm._t("brand", null, {
    "slot": "brand"
  }), _c('div', {
    staticClass: "content",
    attrs: {
      "slot": "main"
    },
    slot: "main"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('deconf.apiError.title')))]), _c('p', [_vm._v(_vm._s(_vm.$t('deconf.apiError.content')))]), _c('p', [_vm._v(_vm._s(_vm.$t('deconf.apiError.retry', [_vm.localeCountdown])))])]), _vm._t("footer", null, {
    "slot": "footer"
  })], 2);
};

var __vue_staticRenderFns__$Q = [];
/* style */

var __vue_inject_styles__$R = undefined;
/* scoped */

var __vue_scope_id__$R = undefined;
/* module identifier */

var __vue_module_identifier__$R = undefined;
/* functional template */

var __vue_is_functional_template__$R = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$R = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$Q,
  staticRenderFns: __vue_staticRenderFns__$Q
}, __vue_inject_styles__$R, __vue_script__$Q, __vue_scope_id__$R, __vue_is_functional_template__$R, __vue_module_identifier__$R, false, undefined, undefined, undefined);

//
// i18n
// - deconf.navigationBar.unavailable - Unavailable string in the menu
// - deconf.navigationBar.login - The title of the Log In menu item
// - deconf.navigationBar.profile - The title of the Profile menu item
// - deconf.navigationBar.register - The title of the Register menu item
// - deconf.navigationBar.interpret - The title of the Interpret menu item
//
// icons
// - fas user
//
// sass
// - $navigationBar-activeColor
// - $navigationBar-activeBackground
// - $navigationBar-mobileBackground
// - $navigationBar-mobileColor
//
var script$P = {
  name: 'NavigationBar',
  components: {
    FontAwesomeIcon: FontAwesomeIcon
  },
  data: function data() {
    return {
      isShowingMenu: false
    };
  },
  props: {
    appSettings: {
      type: Object,
      required: true
    },
    isLoggedIn: {
      type: Boolean,
      required: true
    },
    isInterpreter: {
      type: Boolean,
      required: true
    },
    routes: {
      type: Array,
      required: true
    },
    languages: {
      type: Array,
      default: null
    },
    links: {
      type: Array,
      default: function _default() {
        return ['login', 'register', 'interpret', 'profile'];
      }
    }
  },
  computed: {
    activeClasses: function activeClasses() {
      return {
        'is-active': this.isShowingMenu
      };
    },
    homeRoute: function homeRoute() {
      return {
        name: Routes.Atrium
      };
    },
    interpretRoute: function interpretRoute() {
      return {
        name: Routes.InterpretHome
      };
    },
    profileRoute: function profileRoute() {
      return {
        name: Routes.Profile
      };
    },
    loginRoute: function loginRoute() {
      return {
        name: Routes.Login
      };
    },
    registerRoute: function registerRoute() {
      return {
        name: Routes.Register
      };
    }
  },
  methods: {
    toggleMenu: function toggleMenu() {
      this.isShowingMenu = !this.isShowingMenu;
    },
    showLink: function showLink(link) {
      return this.links.includes(link);
    }
  }
};

/* script */
var __vue_script__$P = script$P;
/* template */

var __vue_render__$P = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "navigationBar"
  }, [_c('nav', {
    staticClass: "navbar",
    attrs: {
      "role": "navigation",
      "aria-label": "main navigation"
    }
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": _vm.homeRoute,
      "active-class": ""
    }
  }, [_vm._t("brandA")], 2), _c('a', {
    ref: "menuButton",
    staticClass: "navbar-burger burger",
    attrs: {
      "role": "button",
      "aria-label": "menu",
      "aria-expanded": "false",
      "data-target": "navbarBasicExample"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.toggleMenu.apply(null, arguments);
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1), _c('div', {
    staticClass: "navbar-menu",
    class: _vm.activeClasses
  }, [_c('div', {
    staticClass: "navbar-start"
  }, _vm._l(_vm.routes, function (item) {
    return _c('router-link', {
      key: item.name,
      staticClass: "navbar-item",
      attrs: {
        "to": {
          name: item.name
        },
        "disabled": !item.enabled,
        "title": item.title,
        "active-class": "is-active"
      }
    }, [_c(item.icon, {
      tag: "component",
      staticClass: "navbar-item-icon"
    }), _c('span', {
      staticClass: "navbar-item-text",
      domProps: {
        "textContent": _vm._s(item.title)
      }
    }), !item.enabled ? _c('span', [_vm._v("   " + _vm._s(_vm.$t('deconf.navigationBar.unavailable')) + " ")]) : _vm._e()], 1);
  }), 1), _c('div', {
    staticClass: "navbar-end"
  }, [_vm.$slots.brandB ? _c('div', {
    staticClass: "navbar-item"
  }, [_vm._t("brandB")], 2) : _vm._e(), _vm.$slots.languageControl ? _c('div', {
    staticClass: "navbar-item"
  }, [_vm._t("languageControl")], 2) : _vm._e(), _vm.isLoggedIn && _vm.isInterpreter && _vm.showLink('interpret') ? _c('div', {
    staticClass: "navbar-item"
  }, [_c('router-link', {
    staticClass: "button is-secondary is-small",
    attrs: {
      "to": _vm.interpretRoute
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('deconf.navigationBar.interpret')) + " ")])], 1) : _vm._e(), _vm.isLoggedIn && _vm.showLink('profile') ? _c('div', {
    staticClass: "navbar-item"
  }, [_c('router-link', {
    staticClass: "button is-small has-addons",
    attrs: {
      "to": _vm.profileRoute
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('FontAwesomeIcon', {
    attrs: {
      "icon": ['fas', 'user']
    }
  })], 1), _c('span', [_vm._v(_vm._s(_vm.$t('deconf.navigationBar.profile')))])])], 1) : _vm._e(), !_vm.isLoggedIn && (_vm.showLink('login') || _vm.showLink('register')) ? _c('div', {
    staticClass: "navbar-item"
  }, [_c('div', {
    staticClass: "buttons"
  }, [_vm.showLink('login') ? _c('router-link', {
    staticClass: "button is-light is-small",
    attrs: {
      "to": _vm.loginRoute
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('deconf.navigationBar.login')) + " ")]) : _vm._e(), _vm.showLink('register') ? _c('router-link', {
    staticClass: "button is-primary is-small",
    attrs: {
      "to": _vm.registerRoute
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('deconf.navigationBar.register')) + " ")]) : _vm._e()], 1)]) : _vm._e()])])])]);
};

var __vue_staticRenderFns__$P = [];
/* style */

var __vue_inject_styles__$Q = undefined;
/* scoped */

var __vue_scope_id__$Q = undefined;
/* module identifier */

var __vue_module_identifier__$Q = undefined;
/* functional template */

var __vue_is_functional_template__$Q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$Q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$P,
  staticRenderFns: __vue_staticRenderFns__$P
}, __vue_inject_styles__$Q, __vue_script__$P, __vue_scope_id__$Q, __vue_is_functional_template__$Q, __vue_module_identifier__$Q, false, undefined, undefined, undefined);

//
// i18n
// - deconf.sideTabs.unavailable - The title when a tab isn't available
//
// icons
// - n/a
//
// sass
// - $sideTabs-background
// - $sideTabs-color
// - $sideTabs-active
// - $sideTabs-activeBackground
//
var script$O = {
  name: 'SideTabs',
  props: {
    routes: {
      type: Array,
      required: true
    }
  },
  methods: {
    routeArgs: function routeArgs(item) {
      if (item.enabled) {
        return {
          to: {
            name: item.name
          },
          'active-class': 'is-active'
        };
      } else {
        return {
          disabled: true,
          title: this.$t('deconf.sideTabs.unavailable')
        };
      }
    }
  }
};

/* script */
var __vue_script__$O = script$O;
/* template */

var __vue_render__$O = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "sideTabs"
  }, [_vm.$slots.brand ? _c('div', {
    staticClass: "sideTabs-tab"
  }, [_vm._t("brand")], 2) : _vm._e(), _vm._l(_vm.routes, function (item) {
    return _c(item.enabled ? 'router-link' : 'span', _vm._b({
      key: item.name,
      tag: "component",
      staticClass: "sideTabs-tab"
    }, 'component', _vm.routeArgs(item), false), [_c(item.icon, {
      tag: "component",
      staticClass: "sideTabs-tabIcon"
    }), _c('span', {
      staticClass: "sideTabs-tabText"
    }, [_vm._v(" " + _vm._s(item.title) + " ")])], 1);
  })], 2);
};

var __vue_staticRenderFns__$O = [];
/* style */

var __vue_inject_styles__$P = undefined;
/* scoped */

var __vue_scope_id__$P = undefined;
/* module identifier */

var __vue_module_identifier__$P = undefined;
/* functional template */

var __vue_is_functional_template__$P = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$P = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$O,
  staticRenderFns: __vue_staticRenderFns__$O
}, __vue_inject_styles__$P, __vue_script__$O, __vue_scope_id__$P, __vue_is_functional_template__$P, __vue_module_identifier__$P, false, undefined, undefined, undefined);

// i18n
// - n/a
//
// icons
// - n/a
//
// sass
// - n/a
//
// notes:
// - slot=main is flexed so you can flex:1 to make it fill height
//

var script$N = {
  name: 'AppLayout',
  components: {
    FullHeight: __vue_component__$T,
    NavigationBar: __vue_component__$Q,
    SideTabs: __vue_component__$P
  },
  props: {
    appSettings: {
      type: Object,
      required: true
    },
    user: {
      type: Object,
      default: null
    },
    routes: {
      type: Array,
      required: true
    },
    navLinks: {
      type: Array,
      required: false
    }
  },
  computed: {
    isLoggedIn: function isLoggedIn() {
      return Boolean(this.user);
    },
    isInterpreter: function isInterpreter() {
      if (!this.user) return false;
      return this.user.user_roles.includes('interpreter') || this.user.user_roles.includes('admin');
    }
  }
};

/* script */
var __vue_script__$N = script$N;
/* template */

var __vue_render__$N = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('FullHeight', {
    staticClass: "appLayout"
  }, [_c('div', {
    staticClass: "appLayout-header"
  }, [_c('NavigationBar', {
    attrs: {
      "app-settings": _vm.appSettings,
      "is-logged-in": _vm.isLoggedIn,
      "is-interpreter": _vm.isInterpreter,
      "routes": _vm.routes,
      "links": _vm.navLinks
    }
  }, [_vm._t("brandA", null, {
    "slot": "brandA"
  }), _vm._t("brandB", null, {
    "slot": "brandB"
  }), _vm._t("languageControl", null, {
    "slot": "languageControl"
  })], 2)], 1), _c('div', {
    staticClass: "appLayout-tabs"
  }, [_c('SideTabs', {
    attrs: {
      "routes": _vm.routes
    }
  }, [_vm._t("brandC", null, {
    "slot": "brand"
  })], 2)], 1), _c('div', {
    staticClass: "appLayout-page"
  }, [_vm._t("main")], 2)]);
};

var __vue_staticRenderFns__$N = [];
/* style */

var __vue_inject_styles__$O = undefined;
/* scoped */

var __vue_scope_id__$O = undefined;
/* module identifier */

var __vue_module_identifier__$O = undefined;
/* functional template */

var __vue_is_functional_template__$O = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$O = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$N,
  staticRenderFns: __vue_staticRenderFns__$N
}, __vue_inject_styles__$O, __vue_script__$N, __vue_scope_id__$O, __vue_is_functional_template__$O, __vue_module_identifier__$O, false, undefined, undefined, undefined);

// i18n
// - deconf.appLoading.message - Message when data is being initially fetched
//
// icons
// - fas sync
//
// sass
// - n/a
//

var DEBOUNCE_MS = 500;
var script$M = {
  name: 'AppLoading',
  components: {
    FontAwesomeIcon: FontAwesomeIcon
  },
  data: function data() {
    return {
      hasWaited: false,
      timerId: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    //
    // Only show loading after 500ms
    //
    this.timerId = window.setTimeout(function () {
      return _this.hasWaited = true;
    }, DEBOUNCE_MS);
  },
  destroyed: function destroyed() {
    if (this.timerId) clearInterval(this.timerId);
    this.timerId = null;
  }
};

/* script */
var __vue_script__$M = script$M;
/* template */

var __vue_render__$M = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.hasWaited ? _c('div', {
    staticClass: "appLoading"
  }, [_c('div', {
    staticClass: "appLoading-box"
  }, [_c('span', {
    staticClass: "icon-text"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('FontAwesomeIcon', {
    attrs: {
      "icon": ['fas', 'sync'],
      "spin": "",
      "size": "sm"
    }
  })], 1), _c('span', [_vm._v(_vm._s(_vm.$t('deconf.appLoading.message')))])])])]) : _vm._e();
};

var __vue_staticRenderFns__$M = [];
/* style */

var __vue_inject_styles__$N = undefined;
/* scoped */

var __vue_scope_id__$N = undefined;
/* module identifier */

var __vue_module_identifier__$N = undefined;
/* functional template */

var __vue_is_functional_template__$N = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$N = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$M,
  staticRenderFns: __vue_staticRenderFns__$M
}, __vue_inject_styles__$N, __vue_script__$M, __vue_scope_id__$N, __vue_is_functional_template__$N, __vue_module_identifier__$N, false, undefined, undefined, undefined);

// i18n
// - n/a
//
// icons
// - fas arrow-left
// - fas arrow-right
//
// sass
// - n/a
//

var script$L = {
  name: 'BackButton',
  components: {
    BidirectionalIcon: __vue_component__$_
  },
  props: {
    to: {
      type: [String, Object],
      required: true
    }
  }
};

/* script */
var __vue_script__$L = script$L;
/* template */

var __vue_render__$L = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('router-link', {
    staticClass: "backButton button is-white",
    attrs: {
      "active-class": "",
      "to": _vm.to
    }
  }, [_c('BidirectionalIcon', {
    attrs: {
      "ltr": ['fas', 'arrow-left'],
      "rtl": ['fas', 'arrow-right']
    }
  }), _c('span', [_vm._t("default")], 2)], 1);
};

var __vue_staticRenderFns__$L = [];
/* style */

var __vue_inject_styles__$M = undefined;
/* scoped */

var __vue_scope_id__$M = undefined;
/* module identifier */

var __vue_module_identifier__$M = undefined;
/* functional template */

var __vue_is_functional_template__$M = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$M = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$L,
  staticRenderFns: __vue_staticRenderFns__$L
}, __vue_inject_styles__$M, __vue_script__$L, __vue_scope_id__$M, __vue_is_functional_template__$M, __vue_module_identifier__$M, false, undefined, undefined, undefined);

//
// i18n
// - n/a
//
// icons
// - n/a
//
// sass
// - n/a
//
var script$K = {
  name: 'InlineMessage'
};

/* script */
var __vue_script__$K = script$K;
/* template */

var __vue_render__$K = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('section', {
    staticClass: "section is-large inlineMessage"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._t("default")], 2)])]);
};

var __vue_staticRenderFns__$K = [];
/* style */

var __vue_inject_styles__$L = undefined;
/* scoped */

var __vue_scope_id__$L = undefined;
/* module identifier */

var __vue_module_identifier__$L = undefined;
/* functional template */

var __vue_is_functional_template__$L = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$L = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$K,
  staticRenderFns: __vue_staticRenderFns__$K
}, __vue_inject_styles__$L, __vue_script__$K, __vue_scope_id__$L, __vue_is_functional_template__$L, __vue_module_identifier__$L, false, undefined, undefined, undefined);

//
// i18n
// - n/a
//
// icons
// - n/a
//
// sass
// - $pageFooter-color
// - $pageFooter-background
// - $pageFooter-anchorColor
// - $pageFooter-anchorWeight
//
var script$J = {
  name: 'PageFooter',
  props: {
    links: {
      type: Array,
      required: true
    }
  }
};

/* script */
var __vue_script__$J = script$J;
/* template */

var __vue_render__$J = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "pageFooter"
  }, [_vm.$slots.beforeLinks ? _c('p', {
    staticClass: "pageFooter-line"
  }, [_vm._t("beforeLinks")], 2) : _vm._e(), _c('p', {
    staticClass: "pageFooter-line"
  }, _vm._l(_vm.links, function (link, i) {
    return _c('span', {
      key: link.key
    }, [_c('a', {
      attrs: {
        "href": link.url,
        "target": "_blank",
        "rel": "noopener"
      }
    }, [_vm._v(" " + _vm._s(link.title) + " ")]), i < _vm.links.length - 1 ? [_vm._v(" / ")] : _vm._e()], 2);
  }), 0), _c('p', {
    staticClass: "pageFooter-line"
  }, [_vm._t("default")], 2)]);
};

var __vue_staticRenderFns__$J = [];
/* style */

var __vue_inject_styles__$K = undefined;
/* scoped */

var __vue_scope_id__$K = undefined;
/* module identifier */

var __vue_module_identifier__$K = undefined;
/* functional template */

var __vue_is_functional_template__$K = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$K = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$J,
  staticRenderFns: __vue_staticRenderFns__$J
}, __vue_inject_styles__$K, __vue_script__$J, __vue_scope_id__$K, __vue_is_functional_template__$K, __vue_module_identifier__$K, false, undefined, undefined, undefined);

/**
 * marked - a markdown parser
 * Copyright (c) 2011-2022, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/markedjs/marked
 */

/**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */

function getDefaults() {
  return {
    async: false,
    baseUrl: null,
    breaks: false,
    extensions: null,
    gfm: true,
    headerIds: true,
    headerPrefix: '',
    highlight: null,
    langPrefix: 'language-',
    mangle: true,
    pedantic: false,
    renderer: null,
    sanitize: false,
    sanitizer: null,
    silent: false,
    smartypants: false,
    tokenizer: null,
    walkTokens: null,
    xhtml: false
  };
}

let defaults = getDefaults();

function changeDefaults(newDefaults) {
  defaults = newDefaults;
}

/**
 * Helpers
 */
const escapeTest = /[&<>"']/;
const escapeReplace = /[&<>"']/g;
const escapeTestNoEncode = /[<>"']|&(?!#?\w+;)/;
const escapeReplaceNoEncode = /[<>"']|&(?!#?\w+;)/g;
const escapeReplacements = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
};
const getEscapeReplacement = (ch) => escapeReplacements[ch];
function escape(html, encode) {
  if (encode) {
    if (escapeTest.test(html)) {
      return html.replace(escapeReplace, getEscapeReplacement);
    }
  } else {
    if (escapeTestNoEncode.test(html)) {
      return html.replace(escapeReplaceNoEncode, getEscapeReplacement);
    }
  }

  return html;
}

const unescapeTest = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig;

/**
 * @param {string} html
 */
function unescape(html) {
  // explicitly match decimal, hex, and named HTML entities
  return html.replace(unescapeTest, (_, n) => {
    n = n.toLowerCase();
    if (n === 'colon') return ':';
    if (n.charAt(0) === '#') {
      return n.charAt(1) === 'x'
        ? String.fromCharCode(parseInt(n.substring(2), 16))
        : String.fromCharCode(+n.substring(1));
    }
    return '';
  });
}

const caret = /(^|[^\[])\^/g;

/**
 * @param {string | RegExp} regex
 * @param {string} opt
 */
function edit(regex, opt) {
  regex = typeof regex === 'string' ? regex : regex.source;
  opt = opt || '';
  const obj = {
    replace: (name, val) => {
      val = val.source || val;
      val = val.replace(caret, '$1');
      regex = regex.replace(name, val);
      return obj;
    },
    getRegex: () => {
      return new RegExp(regex, opt);
    }
  };
  return obj;
}

const nonWordAndColonTest = /[^\w:]/g;
const originIndependentUrl = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;

/**
 * @param {boolean} sanitize
 * @param {string} base
 * @param {string} href
 */
function cleanUrl(sanitize, base, href) {
  if (sanitize) {
    let prot;
    try {
      prot = decodeURIComponent(unescape(href))
        .replace(nonWordAndColonTest, '')
        .toLowerCase();
    } catch (e) {
      return null;
    }
    if (prot.indexOf('javascript:') === 0 || prot.indexOf('vbscript:') === 0 || prot.indexOf('data:') === 0) {
      return null;
    }
  }
  if (base && !originIndependentUrl.test(href)) {
    href = resolveUrl(base, href);
  }
  try {
    href = encodeURI(href).replace(/%25/g, '%');
  } catch (e) {
    return null;
  }
  return href;
}

const baseUrls = {};
const justDomain = /^[^:]+:\/*[^/]*$/;
const protocol = /^([^:]+:)[\s\S]*$/;
const domain = /^([^:]+:\/*[^/]*)[\s\S]*$/;

/**
 * @param {string} base
 * @param {string} href
 */
function resolveUrl(base, href) {
  if (!baseUrls[' ' + base]) {
    // we can ignore everything in base after the last slash of its path component,
    // but we might need to add _that_
    // https://tools.ietf.org/html/rfc3986#section-3
    if (justDomain.test(base)) {
      baseUrls[' ' + base] = base + '/';
    } else {
      baseUrls[' ' + base] = rtrim(base, '/', true);
    }
  }
  base = baseUrls[' ' + base];
  const relativeBase = base.indexOf(':') === -1;

  if (href.substring(0, 2) === '//') {
    if (relativeBase) {
      return href;
    }
    return base.replace(protocol, '$1') + href;
  } else if (href.charAt(0) === '/') {
    if (relativeBase) {
      return href;
    }
    return base.replace(domain, '$1') + href;
  } else {
    return base + href;
  }
}

const noopTest = { exec: function noopTest() {} };

function merge(obj) {
  let i = 1,
    target,
    key;

  for (; i < arguments.length; i++) {
    target = arguments[i];
    for (key in target) {
      if (Object.prototype.hasOwnProperty.call(target, key)) {
        obj[key] = target[key];
      }
    }
  }

  return obj;
}

function splitCells(tableRow, count) {
  // ensure that every cell-delimiting pipe has a space
  // before it to distinguish it from an escaped pipe
  const row = tableRow.replace(/\|/g, (match, offset, str) => {
      let escaped = false,
        curr = offset;
      while (--curr >= 0 && str[curr] === '\\') escaped = !escaped;
      if (escaped) {
        // odd number of slashes means | is escaped
        // so we leave it alone
        return '|';
      } else {
        // add space before unescaped |
        return ' |';
      }
    }),
    cells = row.split(/ \|/);
  let i = 0;

  // First/last cell in a row cannot be empty if it has no leading/trailing pipe
  if (!cells[0].trim()) { cells.shift(); }
  if (cells.length > 0 && !cells[cells.length - 1].trim()) { cells.pop(); }

  if (cells.length > count) {
    cells.splice(count);
  } else {
    while (cells.length < count) cells.push('');
  }

  for (; i < cells.length; i++) {
    // leading or trailing whitespace is ignored per the gfm spec
    cells[i] = cells[i].trim().replace(/\\\|/g, '|');
  }
  return cells;
}

/**
 * Remove trailing 'c's. Equivalent to str.replace(/c*$/, '').
 * /c*$/ is vulnerable to REDOS.
 *
 * @param {string} str
 * @param {string} c
 * @param {boolean} invert Remove suffix of non-c chars instead. Default falsey.
 */
function rtrim(str, c, invert) {
  const l = str.length;
  if (l === 0) {
    return '';
  }

  // Length of suffix matching the invert condition.
  let suffLen = 0;

  // Step left until we fail to match the invert condition.
  while (suffLen < l) {
    const currChar = str.charAt(l - suffLen - 1);
    if (currChar === c && !invert) {
      suffLen++;
    } else if (currChar !== c && invert) {
      suffLen++;
    } else {
      break;
    }
  }

  return str.slice(0, l - suffLen);
}

function findClosingBracket(str, b) {
  if (str.indexOf(b[1]) === -1) {
    return -1;
  }
  const l = str.length;
  let level = 0,
    i = 0;
  for (; i < l; i++) {
    if (str[i] === '\\') {
      i++;
    } else if (str[i] === b[0]) {
      level++;
    } else if (str[i] === b[1]) {
      level--;
      if (level < 0) {
        return i;
      }
    }
  }
  return -1;
}

function checkSanitizeDeprecation(opt) {
  if (opt && opt.sanitize && !opt.silent) {
    console.warn('marked(): sanitize and sanitizer parameters are deprecated since version 0.7.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/#/USING_ADVANCED.md#options');
  }
}

// copied from https://stackoverflow.com/a/5450113/806777
/**
 * @param {string} pattern
 * @param {number} count
 */
function repeatString(pattern, count) {
  if (count < 1) {
    return '';
  }
  let result = '';
  while (count > 1) {
    if (count & 1) {
      result += pattern;
    }
    count >>= 1;
    pattern += pattern;
  }
  return result + pattern;
}

function outputLink(cap, link, raw, lexer) {
  const href = link.href;
  const title = link.title ? escape(link.title) : null;
  const text = cap[1].replace(/\\([\[\]])/g, '$1');

  if (cap[0].charAt(0) !== '!') {
    lexer.state.inLink = true;
    const token = {
      type: 'link',
      raw,
      href,
      title,
      text,
      tokens: lexer.inlineTokens(text)
    };
    lexer.state.inLink = false;
    return token;
  }
  return {
    type: 'image',
    raw,
    href,
    title,
    text: escape(text)
  };
}

function indentCodeCompensation(raw, text) {
  const matchIndentToCode = raw.match(/^(\s+)(?:```)/);

  if (matchIndentToCode === null) {
    return text;
  }

  const indentToCode = matchIndentToCode[1];

  return text
    .split('\n')
    .map(node => {
      const matchIndentInNode = node.match(/^\s+/);
      if (matchIndentInNode === null) {
        return node;
      }

      const [indentInNode] = matchIndentInNode;

      if (indentInNode.length >= indentToCode.length) {
        return node.slice(indentToCode.length);
      }

      return node;
    })
    .join('\n');
}

/**
 * Tokenizer
 */
class Tokenizer {
  constructor(options) {
    this.options = options || defaults;
  }

  space(src) {
    const cap = this.rules.block.newline.exec(src);
    if (cap && cap[0].length > 0) {
      return {
        type: 'space',
        raw: cap[0]
      };
    }
  }

  code(src) {
    const cap = this.rules.block.code.exec(src);
    if (cap) {
      const text = cap[0].replace(/^ {1,4}/gm, '');
      return {
        type: 'code',
        raw: cap[0],
        codeBlockStyle: 'indented',
        text: !this.options.pedantic
          ? rtrim(text, '\n')
          : text
      };
    }
  }

  fences(src) {
    const cap = this.rules.block.fences.exec(src);
    if (cap) {
      const raw = cap[0];
      const text = indentCodeCompensation(raw, cap[3] || '');

      return {
        type: 'code',
        raw,
        lang: cap[2] ? cap[2].trim() : cap[2],
        text
      };
    }
  }

  heading(src) {
    const cap = this.rules.block.heading.exec(src);
    if (cap) {
      let text = cap[2].trim();

      // remove trailing #s
      if (/#$/.test(text)) {
        const trimmed = rtrim(text, '#');
        if (this.options.pedantic) {
          text = trimmed.trim();
        } else if (!trimmed || / $/.test(trimmed)) {
          // CommonMark requires space before trailing #s
          text = trimmed.trim();
        }
      }

      return {
        type: 'heading',
        raw: cap[0],
        depth: cap[1].length,
        text,
        tokens: this.lexer.inline(text)
      };
    }
  }

  hr(src) {
    const cap = this.rules.block.hr.exec(src);
    if (cap) {
      return {
        type: 'hr',
        raw: cap[0]
      };
    }
  }

  blockquote(src) {
    const cap = this.rules.block.blockquote.exec(src);
    if (cap) {
      const text = cap[0].replace(/^ *>[ \t]?/gm, '');

      return {
        type: 'blockquote',
        raw: cap[0],
        tokens: this.lexer.blockTokens(text, []),
        text
      };
    }
  }

  list(src) {
    let cap = this.rules.block.list.exec(src);
    if (cap) {
      let raw, istask, ischecked, indent, i, blankLine, endsWithBlankLine,
        line, nextLine, rawLine, itemContents, endEarly;

      let bull = cap[1].trim();
      const isordered = bull.length > 1;

      const list = {
        type: 'list',
        raw: '',
        ordered: isordered,
        start: isordered ? +bull.slice(0, -1) : '',
        loose: false,
        items: []
      };

      bull = isordered ? `\\d{1,9}\\${bull.slice(-1)}` : `\\${bull}`;

      if (this.options.pedantic) {
        bull = isordered ? bull : '[*+-]';
      }

      // Get next list item
      const itemRegex = new RegExp(`^( {0,3}${bull})((?:[\t ][^\\n]*)?(?:\\n|$))`);

      // Check if current bullet point can start a new List Item
      while (src) {
        endEarly = false;
        if (!(cap = itemRegex.exec(src))) {
          break;
        }

        if (this.rules.block.hr.test(src)) { // End list if bullet was actually HR (possibly move into itemRegex?)
          break;
        }

        raw = cap[0];
        src = src.substring(raw.length);

        line = cap[2].split('\n', 1)[0];
        nextLine = src.split('\n', 1)[0];

        if (this.options.pedantic) {
          indent = 2;
          itemContents = line.trimLeft();
        } else {
          indent = cap[2].search(/[^ ]/); // Find first non-space char
          indent = indent > 4 ? 1 : indent; // Treat indented code blocks (> 4 spaces) as having only 1 indent
          itemContents = line.slice(indent);
          indent += cap[1].length;
        }

        blankLine = false;

        if (!line && /^ *$/.test(nextLine)) { // Items begin with at most one blank line
          raw += nextLine + '\n';
          src = src.substring(nextLine.length + 1);
          endEarly = true;
        }

        if (!endEarly) {
          const nextBulletRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:[*+-]|\\d{1,9}[.)])((?: [^\\n]*)?(?:\\n|$))`);
          const hrRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`);
          const fencesBeginRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:\`\`\`|~~~)`);
          const headingBeginRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}#`);

          // Check if following lines should be included in List Item
          while (src) {
            rawLine = src.split('\n', 1)[0];
            line = rawLine;

            // Re-align to follow commonmark nesting rules
            if (this.options.pedantic) {
              line = line.replace(/^ {1,4}(?=( {4})*[^ ])/g, '  ');
            }

            // End list item if found code fences
            if (fencesBeginRegex.test(line)) {
              break;
            }

            // End list item if found start of new heading
            if (headingBeginRegex.test(line)) {
              break;
            }

            // End list item if found start of new bullet
            if (nextBulletRegex.test(line)) {
              break;
            }

            // Horizontal rule found
            if (hrRegex.test(src)) {
              break;
            }

            if (line.search(/[^ ]/) >= indent || !line.trim()) { // Dedent if possible
              itemContents += '\n' + line.slice(indent);
            } else if (!blankLine) { // Until blank line, item doesn't need indentation
              itemContents += '\n' + line;
            } else { // Otherwise, improper indentation ends this item
              break;
            }

            if (!blankLine && !line.trim()) { // Check if current line is blank
              blankLine = true;
            }

            raw += rawLine + '\n';
            src = src.substring(rawLine.length + 1);
          }
        }

        if (!list.loose) {
          // If the previous item ended with a blank line, the list is loose
          if (endsWithBlankLine) {
            list.loose = true;
          } else if (/\n *\n *$/.test(raw)) {
            endsWithBlankLine = true;
          }
        }

        // Check for task list items
        if (this.options.gfm) {
          istask = /^\[[ xX]\] /.exec(itemContents);
          if (istask) {
            ischecked = istask[0] !== '[ ] ';
            itemContents = itemContents.replace(/^\[[ xX]\] +/, '');
          }
        }

        list.items.push({
          type: 'list_item',
          raw,
          task: !!istask,
          checked: ischecked,
          loose: false,
          text: itemContents
        });

        list.raw += raw;
      }

      // Do not consume newlines at end of final item. Alternatively, make itemRegex *start* with any newlines to simplify/speed up endsWithBlankLine logic
      list.items[list.items.length - 1].raw = raw.trimRight();
      list.items[list.items.length - 1].text = itemContents.trimRight();
      list.raw = list.raw.trimRight();

      const l = list.items.length;

      // Item child tokens handled here at end because we needed to have the final item to trim it first
      for (i = 0; i < l; i++) {
        this.lexer.state.top = false;
        list.items[i].tokens = this.lexer.blockTokens(list.items[i].text, []);
        const spacers = list.items[i].tokens.filter(t => t.type === 'space');
        const hasMultipleLineBreaks = spacers.every(t => {
          const chars = t.raw.split('');
          let lineBreaks = 0;
          for (const char of chars) {
            if (char === '\n') {
              lineBreaks += 1;
            }
            if (lineBreaks > 1) {
              return true;
            }
          }

          return false;
        });

        if (!list.loose && spacers.length && hasMultipleLineBreaks) {
          // Having a single line break doesn't mean a list is loose. A single line break is terminating the last list item
          list.loose = true;
          list.items[i].loose = true;
        }
      }

      return list;
    }
  }

  html(src) {
    const cap = this.rules.block.html.exec(src);
    if (cap) {
      const token = {
        type: 'html',
        raw: cap[0],
        pre: !this.options.sanitizer
          && (cap[1] === 'pre' || cap[1] === 'script' || cap[1] === 'style'),
        text: cap[0]
      };
      if (this.options.sanitize) {
        const text = this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]);
        token.type = 'paragraph';
        token.text = text;
        token.tokens = this.lexer.inline(text);
      }
      return token;
    }
  }

  def(src) {
    const cap = this.rules.block.def.exec(src);
    if (cap) {
      if (cap[3]) cap[3] = cap[3].substring(1, cap[3].length - 1);
      const tag = cap[1].toLowerCase().replace(/\s+/g, ' ');
      return {
        type: 'def',
        tag,
        raw: cap[0],
        href: cap[2],
        title: cap[3]
      };
    }
  }

  table(src) {
    const cap = this.rules.block.table.exec(src);
    if (cap) {
      const item = {
        type: 'table',
        header: splitCells(cap[1]).map(c => { return { text: c }; }),
        align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
        rows: cap[3] && cap[3].trim() ? cap[3].replace(/\n[ \t]*$/, '').split('\n') : []
      };

      if (item.header.length === item.align.length) {
        item.raw = cap[0];

        let l = item.align.length;
        let i, j, k, row;
        for (i = 0; i < l; i++) {
          if (/^ *-+: *$/.test(item.align[i])) {
            item.align[i] = 'right';
          } else if (/^ *:-+: *$/.test(item.align[i])) {
            item.align[i] = 'center';
          } else if (/^ *:-+ *$/.test(item.align[i])) {
            item.align[i] = 'left';
          } else {
            item.align[i] = null;
          }
        }

        l = item.rows.length;
        for (i = 0; i < l; i++) {
          item.rows[i] = splitCells(item.rows[i], item.header.length).map(c => { return { text: c }; });
        }

        // parse child tokens inside headers and cells

        // header child tokens
        l = item.header.length;
        for (j = 0; j < l; j++) {
          item.header[j].tokens = this.lexer.inline(item.header[j].text);
        }

        // cell child tokens
        l = item.rows.length;
        for (j = 0; j < l; j++) {
          row = item.rows[j];
          for (k = 0; k < row.length; k++) {
            row[k].tokens = this.lexer.inline(row[k].text);
          }
        }

        return item;
      }
    }
  }

  lheading(src) {
    const cap = this.rules.block.lheading.exec(src);
    if (cap) {
      return {
        type: 'heading',
        raw: cap[0],
        depth: cap[2].charAt(0) === '=' ? 1 : 2,
        text: cap[1],
        tokens: this.lexer.inline(cap[1])
      };
    }
  }

  paragraph(src) {
    const cap = this.rules.block.paragraph.exec(src);
    if (cap) {
      const text = cap[1].charAt(cap[1].length - 1) === '\n'
        ? cap[1].slice(0, -1)
        : cap[1];
      return {
        type: 'paragraph',
        raw: cap[0],
        text,
        tokens: this.lexer.inline(text)
      };
    }
  }

  text(src) {
    const cap = this.rules.block.text.exec(src);
    if (cap) {
      return {
        type: 'text',
        raw: cap[0],
        text: cap[0],
        tokens: this.lexer.inline(cap[0])
      };
    }
  }

  escape(src) {
    const cap = this.rules.inline.escape.exec(src);
    if (cap) {
      return {
        type: 'escape',
        raw: cap[0],
        text: escape(cap[1])
      };
    }
  }

  tag(src) {
    const cap = this.rules.inline.tag.exec(src);
    if (cap) {
      if (!this.lexer.state.inLink && /^<a /i.test(cap[0])) {
        this.lexer.state.inLink = true;
      } else if (this.lexer.state.inLink && /^<\/a>/i.test(cap[0])) {
        this.lexer.state.inLink = false;
      }
      if (!this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(cap[0])) {
        this.lexer.state.inRawBlock = true;
      } else if (this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(cap[0])) {
        this.lexer.state.inRawBlock = false;
      }

      return {
        type: this.options.sanitize
          ? 'text'
          : 'html',
        raw: cap[0],
        inLink: this.lexer.state.inLink,
        inRawBlock: this.lexer.state.inRawBlock,
        text: this.options.sanitize
          ? (this.options.sanitizer
            ? this.options.sanitizer(cap[0])
            : escape(cap[0]))
          : cap[0]
      };
    }
  }

  link(src) {
    const cap = this.rules.inline.link.exec(src);
    if (cap) {
      const trimmedUrl = cap[2].trim();
      if (!this.options.pedantic && /^</.test(trimmedUrl)) {
        // commonmark requires matching angle brackets
        if (!(/>$/.test(trimmedUrl))) {
          return;
        }

        // ending angle bracket cannot be escaped
        const rtrimSlash = rtrim(trimmedUrl.slice(0, -1), '\\');
        if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) {
          return;
        }
      } else {
        // find closing parenthesis
        const lastParenIndex = findClosingBracket(cap[2], '()');
        if (lastParenIndex > -1) {
          const start = cap[0].indexOf('!') === 0 ? 5 : 4;
          const linkLen = start + cap[1].length + lastParenIndex;
          cap[2] = cap[2].substring(0, lastParenIndex);
          cap[0] = cap[0].substring(0, linkLen).trim();
          cap[3] = '';
        }
      }
      let href = cap[2];
      let title = '';
      if (this.options.pedantic) {
        // split pedantic href and title
        const link = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(href);

        if (link) {
          href = link[1];
          title = link[3];
        }
      } else {
        title = cap[3] ? cap[3].slice(1, -1) : '';
      }

      href = href.trim();
      if (/^</.test(href)) {
        if (this.options.pedantic && !(/>$/.test(trimmedUrl))) {
          // pedantic allows starting angle bracket without ending angle bracket
          href = href.slice(1);
        } else {
          href = href.slice(1, -1);
        }
      }
      return outputLink(cap, {
        href: href ? href.replace(this.rules.inline._escapes, '$1') : href,
        title: title ? title.replace(this.rules.inline._escapes, '$1') : title
      }, cap[0], this.lexer);
    }
  }

  reflink(src, links) {
    let cap;
    if ((cap = this.rules.inline.reflink.exec(src))
        || (cap = this.rules.inline.nolink.exec(src))) {
      let link = (cap[2] || cap[1]).replace(/\s+/g, ' ');
      link = links[link.toLowerCase()];
      if (!link || !link.href) {
        const text = cap[0].charAt(0);
        return {
          type: 'text',
          raw: text,
          text
        };
      }
      return outputLink(cap, link, cap[0], this.lexer);
    }
  }

  emStrong(src, maskedSrc, prevChar = '') {
    let match = this.rules.inline.emStrong.lDelim.exec(src);
    if (!match) return;

    // _ can't be between two alphanumerics. \p{L}\p{N} includes non-english alphabet/numbers as well
    if (match[3] && prevChar.match(/[\p{L}\p{N}]/u)) return;

    const nextChar = match[1] || match[2] || '';

    if (!nextChar || (nextChar && (prevChar === '' || this.rules.inline.punctuation.exec(prevChar)))) {
      const lLength = match[0].length - 1;
      let rDelim, rLength, delimTotal = lLength, midDelimTotal = 0;

      const endReg = match[0][0] === '*' ? this.rules.inline.emStrong.rDelimAst : this.rules.inline.emStrong.rDelimUnd;
      endReg.lastIndex = 0;

      // Clip maskedSrc to same section of string as src (move to lexer?)
      maskedSrc = maskedSrc.slice(-1 * src.length + lLength);

      while ((match = endReg.exec(maskedSrc)) != null) {
        rDelim = match[1] || match[2] || match[3] || match[4] || match[5] || match[6];

        if (!rDelim) continue; // skip single * in __abc*abc__

        rLength = rDelim.length;

        if (match[3] || match[4]) { // found another Left Delim
          delimTotal += rLength;
          continue;
        } else if (match[5] || match[6]) { // either Left or Right Delim
          if (lLength % 3 && !((lLength + rLength) % 3)) {
            midDelimTotal += rLength;
            continue; // CommonMark Emphasis Rules 9-10
          }
        }

        delimTotal -= rLength;

        if (delimTotal > 0) continue; // Haven't found enough closing delimiters

        // Remove extra characters. *a*** -> *a*
        rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal);

        // Create `em` if smallest delimiter has odd char count. *a***
        if (Math.min(lLength, rLength) % 2) {
          const text = src.slice(1, lLength + match.index + rLength);
          return {
            type: 'em',
            raw: src.slice(0, lLength + match.index + rLength + 1),
            text,
            tokens: this.lexer.inlineTokens(text)
          };
        }

        // Create 'strong' if smallest delimiter has even char count. **a***
        const text = src.slice(2, lLength + match.index + rLength - 1);
        return {
          type: 'strong',
          raw: src.slice(0, lLength + match.index + rLength + 1),
          text,
          tokens: this.lexer.inlineTokens(text)
        };
      }
    }
  }

  codespan(src) {
    const cap = this.rules.inline.code.exec(src);
    if (cap) {
      let text = cap[2].replace(/\n/g, ' ');
      const hasNonSpaceChars = /[^ ]/.test(text);
      const hasSpaceCharsOnBothEnds = /^ /.test(text) && / $/.test(text);
      if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) {
        text = text.substring(1, text.length - 1);
      }
      text = escape(text, true);
      return {
        type: 'codespan',
        raw: cap[0],
        text
      };
    }
  }

  br(src) {
    const cap = this.rules.inline.br.exec(src);
    if (cap) {
      return {
        type: 'br',
        raw: cap[0]
      };
    }
  }

  del(src) {
    const cap = this.rules.inline.del.exec(src);
    if (cap) {
      return {
        type: 'del',
        raw: cap[0],
        text: cap[2],
        tokens: this.lexer.inlineTokens(cap[2])
      };
    }
  }

  autolink(src, mangle) {
    const cap = this.rules.inline.autolink.exec(src);
    if (cap) {
      let text, href;
      if (cap[2] === '@') {
        text = escape(this.options.mangle ? mangle(cap[1]) : cap[1]);
        href = 'mailto:' + text;
      } else {
        text = escape(cap[1]);
        href = text;
      }

      return {
        type: 'link',
        raw: cap[0],
        text,
        href,
        tokens: [
          {
            type: 'text',
            raw: text,
            text
          }
        ]
      };
    }
  }

  url(src, mangle) {
    let cap;
    if (cap = this.rules.inline.url.exec(src)) {
      let text, href;
      if (cap[2] === '@') {
        text = escape(this.options.mangle ? mangle(cap[0]) : cap[0]);
        href = 'mailto:' + text;
      } else {
        // do extended autolink path validation
        let prevCapZero;
        do {
          prevCapZero = cap[0];
          cap[0] = this.rules.inline._backpedal.exec(cap[0])[0];
        } while (prevCapZero !== cap[0]);
        text = escape(cap[0]);
        if (cap[1] === 'www.') {
          href = 'http://' + text;
        } else {
          href = text;
        }
      }
      return {
        type: 'link',
        raw: cap[0],
        text,
        href,
        tokens: [
          {
            type: 'text',
            raw: text,
            text
          }
        ]
      };
    }
  }

  inlineText(src, smartypants) {
    const cap = this.rules.inline.text.exec(src);
    if (cap) {
      let text;
      if (this.lexer.state.inRawBlock) {
        text = this.options.sanitize ? (this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0])) : cap[0];
      } else {
        text = escape(this.options.smartypants ? smartypants(cap[0]) : cap[0]);
      }
      return {
        type: 'text',
        raw: cap[0],
        text
      };
    }
  }
}

/**
 * Block-Level Grammar
 */
const block = {
  newline: /^(?: *(?:\n|$))+/,
  code: /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/,
  fences: /^ {0,3}(`{3,}(?=[^`\n]*\n)|~{3,})([^\n]*)\n(?:|([\s\S]*?)\n)(?: {0,3}\1[~`]* *(?=\n|$)|$)/,
  hr: /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/,
  heading: /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/,
  blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
  list: /^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/,
  html: '^ {0,3}(?:' // optional indentation
    + '<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)' // (1)
    + '|comment[^\\n]*(\\n+|$)' // (2)
    + '|<\\?[\\s\\S]*?(?:\\?>\\n*|$)' // (3)
    + '|<![A-Z][\\s\\S]*?(?:>\\n*|$)' // (4)
    + '|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)' // (5)
    + '|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)' // (6)
    + '|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)' // (7) open tag
    + '|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)' // (7) closing tag
    + ')',
  def: /^ {0,3}\[(label)\]: *(?:\n *)?<?([^\s>]+)>?(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/,
  table: noopTest,
  lheading: /^([^\n]+)\n {0,3}(=+|-+) *(?:\n+|$)/,
  // regex template, placeholders will be replaced according to different paragraph
  // interruption rules of commonmark and the original markdown spec:
  _paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/,
  text: /^[^\n]+/
};

block._label = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
block._title = /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/;
block.def = edit(block.def)
  .replace('label', block._label)
  .replace('title', block._title)
  .getRegex();

block.bullet = /(?:[*+-]|\d{1,9}[.)])/;
block.listItemStart = edit(/^( *)(bull) */)
  .replace('bull', block.bullet)
  .getRegex();

block.list = edit(block.list)
  .replace(/bull/g, block.bullet)
  .replace('hr', '\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))')
  .replace('def', '\\n+(?=' + block.def.source + ')')
  .getRegex();

block._tag = 'address|article|aside|base|basefont|blockquote|body|caption'
  + '|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption'
  + '|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe'
  + '|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option'
  + '|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr'
  + '|track|ul';
block._comment = /<!--(?!-?>)[\s\S]*?(?:-->|$)/;
block.html = edit(block.html, 'i')
  .replace('comment', block._comment)
  .replace('tag', block._tag)
  .replace('attribute', / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/)
  .getRegex();

block.paragraph = edit(block._paragraph)
  .replace('hr', block.hr)
  .replace('heading', ' {0,3}#{1,6} ')
  .replace('|lheading', '') // setex headings don't interrupt commonmark paragraphs
  .replace('|table', '')
  .replace('blockquote', ' {0,3}>')
  .replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n')
  .replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
  .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)')
  .replace('tag', block._tag) // pars can be interrupted by type (6) html blocks
  .getRegex();

block.blockquote = edit(block.blockquote)
  .replace('paragraph', block.paragraph)
  .getRegex();

/**
 * Normal Block Grammar
 */

block.normal = merge({}, block);

/**
 * GFM Block Grammar
 */

block.gfm = merge({}, block.normal, {
  table: '^ *([^\\n ].*\\|.*)\\n' // Header
    + ' {0,3}(?:\\| *)?(:?-+:? *(?:\\| *:?-+:? *)*)(?:\\| *)?' // Align
    + '(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)' // Cells
});

block.gfm.table = edit(block.gfm.table)
  .replace('hr', block.hr)
  .replace('heading', ' {0,3}#{1,6} ')
  .replace('blockquote', ' {0,3}>')
  .replace('code', ' {4}[^\\n]')
  .replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n')
  .replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
  .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)')
  .replace('tag', block._tag) // tables can be interrupted by type (6) html blocks
  .getRegex();

block.gfm.paragraph = edit(block._paragraph)
  .replace('hr', block.hr)
  .replace('heading', ' {0,3}#{1,6} ')
  .replace('|lheading', '') // setex headings don't interrupt commonmark paragraphs
  .replace('table', block.gfm.table) // interrupt paragraphs with table
  .replace('blockquote', ' {0,3}>')
  .replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n')
  .replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
  .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)')
  .replace('tag', block._tag) // pars can be interrupted by type (6) html blocks
  .getRegex();
/**
 * Pedantic grammar (original John Gruber's loose markdown specification)
 */

block.pedantic = merge({}, block.normal, {
  html: edit(
    '^ *(?:comment *(?:\\n|\\s*$)'
    + '|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)' // closed tag
    + '|<tag(?:"[^"]*"|\'[^\']*\'|\\s[^\'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))')
    .replace('comment', block._comment)
    .replace(/tag/g, '(?!(?:'
      + 'a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub'
      + '|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)'
      + '\\b)\\w+(?!:|[^\\w\\s@]*@)\\b')
    .getRegex(),
  def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
  heading: /^(#{1,6})(.*)(?:\n+|$)/,
  fences: noopTest, // fences not supported
  paragraph: edit(block.normal._paragraph)
    .replace('hr', block.hr)
    .replace('heading', ' *#{1,6} *[^\n]')
    .replace('lheading', block.lheading)
    .replace('blockquote', ' {0,3}>')
    .replace('|fences', '')
    .replace('|list', '')
    .replace('|html', '')
    .getRegex()
});

/**
 * Inline-Level Grammar
 */
const inline = {
  escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,
  autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
  url: noopTest,
  tag: '^comment'
    + '|^</[a-zA-Z][\\w:-]*\\s*>' // self-closing tag
    + '|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>' // open tag
    + '|^<\\?[\\s\\S]*?\\?>' // processing instruction, e.g. <?php ?>
    + '|^<![a-zA-Z]+\\s[\\s\\S]*?>' // declaration, e.g. <!DOCTYPE html>
    + '|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>', // CDATA section
  link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/,
  reflink: /^!?\[(label)\]\[(ref)\]/,
  nolink: /^!?\[(ref)\](?:\[\])?/,
  reflinkSearch: 'reflink|nolink(?!\\()',
  emStrong: {
    lDelim: /^(?:\*+(?:([punct_])|[^\s*]))|^_+(?:([punct*])|([^\s_]))/,
    //        (1) and (2) can only be a Right Delimiter. (3) and (4) can only be Left.  (5) and (6) can be either Left or Right.
    //          () Skip orphan inside strong  () Consume to delim (1) #***                (2) a***#, a***                   (3) #***a, ***a                 (4) ***#              (5) #***#                 (6) a***a
    rDelimAst: /^[^_*]*?\_\_[^_*]*?\*[^_*]*?(?=\_\_)|[^*]+(?=[^*])|[punct_](\*+)(?=[\s]|$)|[^punct*_\s](\*+)(?=[punct_\s]|$)|[punct_\s](\*+)(?=[^punct*_\s])|[\s](\*+)(?=[punct_])|[punct_](\*+)(?=[punct_])|[^punct*_\s](\*+)(?=[^punct*_\s])/,
    rDelimUnd: /^[^_*]*?\*\*[^_*]*?\_[^_*]*?(?=\*\*)|[^_]+(?=[^_])|[punct*](\_+)(?=[\s]|$)|[^punct*_\s](\_+)(?=[punct*\s]|$)|[punct*\s](\_+)(?=[^punct*_\s])|[\s](\_+)(?=[punct*])|[punct*](\_+)(?=[punct*])/ // ^- Not allowed for _
  },
  code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,
  br: /^( {2,}|\\)\n(?!\s*$)/,
  del: noopTest,
  text: /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/,
  punctuation: /^([\spunctuation])/
};

// list of punctuation marks from CommonMark spec
// without * and _ to handle the different emphasis markers * and _
inline._punctuation = '!"#$%&\'()+\\-.,/:;<=>?@\\[\\]`^{|}~';
inline.punctuation = edit(inline.punctuation).replace(/punctuation/g, inline._punctuation).getRegex();

// sequences em should skip over [title](link), `code`, <html>
inline.blockSkip = /\[[^\]]*?\]\([^\)]*?\)|`[^`]*?`|<[^>]*?>/g;
inline.escapedEmSt = /\\\*|\\_/g;

inline._comment = edit(block._comment).replace('(?:-->|$)', '-->').getRegex();

inline.emStrong.lDelim = edit(inline.emStrong.lDelim)
  .replace(/punct/g, inline._punctuation)
  .getRegex();

inline.emStrong.rDelimAst = edit(inline.emStrong.rDelimAst, 'g')
  .replace(/punct/g, inline._punctuation)
  .getRegex();

inline.emStrong.rDelimUnd = edit(inline.emStrong.rDelimUnd, 'g')
  .replace(/punct/g, inline._punctuation)
  .getRegex();

inline._escapes = /\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/g;

inline._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/;
inline._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/;
inline.autolink = edit(inline.autolink)
  .replace('scheme', inline._scheme)
  .replace('email', inline._email)
  .getRegex();

inline._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/;

inline.tag = edit(inline.tag)
  .replace('comment', inline._comment)
  .replace('attribute', inline._attribute)
  .getRegex();

inline._label = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
inline._href = /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/;
inline._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/;

inline.link = edit(inline.link)
  .replace('label', inline._label)
  .replace('href', inline._href)
  .replace('title', inline._title)
  .getRegex();

inline.reflink = edit(inline.reflink)
  .replace('label', inline._label)
  .replace('ref', block._label)
  .getRegex();

inline.nolink = edit(inline.nolink)
  .replace('ref', block._label)
  .getRegex();

inline.reflinkSearch = edit(inline.reflinkSearch, 'g')
  .replace('reflink', inline.reflink)
  .replace('nolink', inline.nolink)
  .getRegex();

/**
 * Normal Inline Grammar
 */

inline.normal = merge({}, inline);

/**
 * Pedantic Inline Grammar
 */

inline.pedantic = merge({}, inline.normal, {
  strong: {
    start: /^__|\*\*/,
    middle: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
    endAst: /\*\*(?!\*)/g,
    endUnd: /__(?!_)/g
  },
  em: {
    start: /^_|\*/,
    middle: /^()\*(?=\S)([\s\S]*?\S)\*(?!\*)|^_(?=\S)([\s\S]*?\S)_(?!_)/,
    endAst: /\*(?!\*)/g,
    endUnd: /_(?!_)/g
  },
  link: edit(/^!?\[(label)\]\((.*?)\)/)
    .replace('label', inline._label)
    .getRegex(),
  reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/)
    .replace('label', inline._label)
    .getRegex()
});

/**
 * GFM Inline Grammar
 */

inline.gfm = merge({}, inline.normal, {
  escape: edit(inline.escape).replace('])', '~|])').getRegex(),
  _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,
  url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,
  _backpedal: /(?:[^?!.,:;*_~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_~)]+(?!$))+/,
  del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
  text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
});

inline.gfm.url = edit(inline.gfm.url, 'i')
  .replace('email', inline.gfm._extended_email)
  .getRegex();
/**
 * GFM + Line Breaks Inline Grammar
 */

inline.breaks = merge({}, inline.gfm, {
  br: edit(inline.br).replace('{2,}', '*').getRegex(),
  text: edit(inline.gfm.text)
    .replace('\\b_', '\\b_| {2,}\\n')
    .replace(/\{2,\}/g, '*')
    .getRegex()
});

/**
 * smartypants text replacement
 * @param {string} text
 */
function smartypants(text) {
  return text
    // em-dashes
    .replace(/---/g, '\u2014')
    // en-dashes
    .replace(/--/g, '\u2013')
    // opening singles
    .replace(/(^|[-\u2014/(\[{"\s])'/g, '$1\u2018')
    // closing singles & apostrophes
    .replace(/'/g, '\u2019')
    // opening doubles
    .replace(/(^|[-\u2014/(\[{\u2018\s])"/g, '$1\u201c')
    // closing doubles
    .replace(/"/g, '\u201d')
    // ellipses
    .replace(/\.{3}/g, '\u2026');
}

/**
 * mangle email addresses
 * @param {string} text
 */
function mangle(text) {
  let out = '',
    i,
    ch;

  const l = text.length;
  for (i = 0; i < l; i++) {
    ch = text.charCodeAt(i);
    if (Math.random() > 0.5) {
      ch = 'x' + ch.toString(16);
    }
    out += '&#' + ch + ';';
  }

  return out;
}

/**
 * Block Lexer
 */
class Lexer {
  constructor(options) {
    this.tokens = [];
    this.tokens.links = Object.create(null);
    this.options = options || defaults;
    this.options.tokenizer = this.options.tokenizer || new Tokenizer();
    this.tokenizer = this.options.tokenizer;
    this.tokenizer.options = this.options;
    this.tokenizer.lexer = this;
    this.inlineQueue = [];
    this.state = {
      inLink: false,
      inRawBlock: false,
      top: true
    };

    const rules = {
      block: block.normal,
      inline: inline.normal
    };

    if (this.options.pedantic) {
      rules.block = block.pedantic;
      rules.inline = inline.pedantic;
    } else if (this.options.gfm) {
      rules.block = block.gfm;
      if (this.options.breaks) {
        rules.inline = inline.breaks;
      } else {
        rules.inline = inline.gfm;
      }
    }
    this.tokenizer.rules = rules;
  }

  /**
   * Expose Rules
   */
  static get rules() {
    return {
      block,
      inline
    };
  }

  /**
   * Static Lex Method
   */
  static lex(src, options) {
    const lexer = new Lexer(options);
    return lexer.lex(src);
  }

  /**
   * Static Lex Inline Method
   */
  static lexInline(src, options) {
    const lexer = new Lexer(options);
    return lexer.inlineTokens(src);
  }

  /**
   * Preprocessing
   */
  lex(src) {
    src = src
      .replace(/\r\n|\r/g, '\n');

    this.blockTokens(src, this.tokens);

    let next;
    while (next = this.inlineQueue.shift()) {
      this.inlineTokens(next.src, next.tokens);
    }

    return this.tokens;
  }

  /**
   * Lexing
   */
  blockTokens(src, tokens = []) {
    if (this.options.pedantic) {
      src = src.replace(/\t/g, '    ').replace(/^ +$/gm, '');
    } else {
      src = src.replace(/^( *)(\t+)/gm, (_, leading, tabs) => {
        return leading + '    '.repeat(tabs.length);
      });
    }

    let token, lastToken, cutSrc, lastParagraphClipped;

    while (src) {
      if (this.options.extensions
        && this.options.extensions.block
        && this.options.extensions.block.some((extTokenizer) => {
          if (token = extTokenizer.call({ lexer: this }, src, tokens)) {
            src = src.substring(token.raw.length);
            tokens.push(token);
            return true;
          }
          return false;
        })) {
        continue;
      }

      // newline
      if (token = this.tokenizer.space(src)) {
        src = src.substring(token.raw.length);
        if (token.raw.length === 1 && tokens.length > 0) {
          // if there's a single \n as a spacer, it's terminating the last line,
          // so move it there so that we don't get unecessary paragraph tags
          tokens[tokens.length - 1].raw += '\n';
        } else {
          tokens.push(token);
        }
        continue;
      }

      // code
      if (token = this.tokenizer.code(src)) {
        src = src.substring(token.raw.length);
        lastToken = tokens[tokens.length - 1];
        // An indented code block cannot interrupt a paragraph.
        if (lastToken && (lastToken.type === 'paragraph' || lastToken.type === 'text')) {
          lastToken.raw += '\n' + token.raw;
          lastToken.text += '\n' + token.text;
          this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
        } else {
          tokens.push(token);
        }
        continue;
      }

      // fences
      if (token = this.tokenizer.fences(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // heading
      if (token = this.tokenizer.heading(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // hr
      if (token = this.tokenizer.hr(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // blockquote
      if (token = this.tokenizer.blockquote(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // list
      if (token = this.tokenizer.list(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // html
      if (token = this.tokenizer.html(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // def
      if (token = this.tokenizer.def(src)) {
        src = src.substring(token.raw.length);
        lastToken = tokens[tokens.length - 1];
        if (lastToken && (lastToken.type === 'paragraph' || lastToken.type === 'text')) {
          lastToken.raw += '\n' + token.raw;
          lastToken.text += '\n' + token.raw;
          this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
        } else if (!this.tokens.links[token.tag]) {
          this.tokens.links[token.tag] = {
            href: token.href,
            title: token.title
          };
        }
        continue;
      }

      // table (gfm)
      if (token = this.tokenizer.table(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // lheading
      if (token = this.tokenizer.lheading(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // top-level paragraph
      // prevent paragraph consuming extensions by clipping 'src' to extension start
      cutSrc = src;
      if (this.options.extensions && this.options.extensions.startBlock) {
        let startIndex = Infinity;
        const tempSrc = src.slice(1);
        let tempStart;
        this.options.extensions.startBlock.forEach(function(getStartIndex) {
          tempStart = getStartIndex.call({ lexer: this }, tempSrc);
          if (typeof tempStart === 'number' && tempStart >= 0) { startIndex = Math.min(startIndex, tempStart); }
        });
        if (startIndex < Infinity && startIndex >= 0) {
          cutSrc = src.substring(0, startIndex + 1);
        }
      }
      if (this.state.top && (token = this.tokenizer.paragraph(cutSrc))) {
        lastToken = tokens[tokens.length - 1];
        if (lastParagraphClipped && lastToken.type === 'paragraph') {
          lastToken.raw += '\n' + token.raw;
          lastToken.text += '\n' + token.text;
          this.inlineQueue.pop();
          this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
        } else {
          tokens.push(token);
        }
        lastParagraphClipped = (cutSrc.length !== src.length);
        src = src.substring(token.raw.length);
        continue;
      }

      // text
      if (token = this.tokenizer.text(src)) {
        src = src.substring(token.raw.length);
        lastToken = tokens[tokens.length - 1];
        if (lastToken && lastToken.type === 'text') {
          lastToken.raw += '\n' + token.raw;
          lastToken.text += '\n' + token.text;
          this.inlineQueue.pop();
          this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
        } else {
          tokens.push(token);
        }
        continue;
      }

      if (src) {
        const errMsg = 'Infinite loop on byte: ' + src.charCodeAt(0);
        if (this.options.silent) {
          console.error(errMsg);
          break;
        } else {
          throw new Error(errMsg);
        }
      }
    }

    this.state.top = true;
    return tokens;
  }

  inline(src, tokens = []) {
    this.inlineQueue.push({ src, tokens });
    return tokens;
  }

  /**
   * Lexing/Compiling
   */
  inlineTokens(src, tokens = []) {
    let token, lastToken, cutSrc;

    // String with links masked to avoid interference with em and strong
    let maskedSrc = src;
    let match;
    let keepPrevChar, prevChar;

    // Mask out reflinks
    if (this.tokens.links) {
      const links = Object.keys(this.tokens.links);
      if (links.length > 0) {
        while ((match = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null) {
          if (links.includes(match[0].slice(match[0].lastIndexOf('[') + 1, -1))) {
            maskedSrc = maskedSrc.slice(0, match.index) + '[' + repeatString('a', match[0].length - 2) + ']' + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
          }
        }
      }
    }
    // Mask out other blocks
    while ((match = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null) {
      maskedSrc = maskedSrc.slice(0, match.index) + '[' + repeatString('a', match[0].length - 2) + ']' + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
    }

    // Mask out escaped em & strong delimiters
    while ((match = this.tokenizer.rules.inline.escapedEmSt.exec(maskedSrc)) != null) {
      maskedSrc = maskedSrc.slice(0, match.index) + '++' + maskedSrc.slice(this.tokenizer.rules.inline.escapedEmSt.lastIndex);
    }

    while (src) {
      if (!keepPrevChar) {
        prevChar = '';
      }
      keepPrevChar = false;

      // extensions
      if (this.options.extensions
        && this.options.extensions.inline
        && this.options.extensions.inline.some((extTokenizer) => {
          if (token = extTokenizer.call({ lexer: this }, src, tokens)) {
            src = src.substring(token.raw.length);
            tokens.push(token);
            return true;
          }
          return false;
        })) {
        continue;
      }

      // escape
      if (token = this.tokenizer.escape(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // tag
      if (token = this.tokenizer.tag(src)) {
        src = src.substring(token.raw.length);
        lastToken = tokens[tokens.length - 1];
        if (lastToken && token.type === 'text' && lastToken.type === 'text') {
          lastToken.raw += token.raw;
          lastToken.text += token.text;
        } else {
          tokens.push(token);
        }
        continue;
      }

      // link
      if (token = this.tokenizer.link(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // reflink, nolink
      if (token = this.tokenizer.reflink(src, this.tokens.links)) {
        src = src.substring(token.raw.length);
        lastToken = tokens[tokens.length - 1];
        if (lastToken && token.type === 'text' && lastToken.type === 'text') {
          lastToken.raw += token.raw;
          lastToken.text += token.text;
        } else {
          tokens.push(token);
        }
        continue;
      }

      // em & strong
      if (token = this.tokenizer.emStrong(src, maskedSrc, prevChar)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // code
      if (token = this.tokenizer.codespan(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // br
      if (token = this.tokenizer.br(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // del (gfm)
      if (token = this.tokenizer.del(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // autolink
      if (token = this.tokenizer.autolink(src, mangle)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // url (gfm)
      if (!this.state.inLink && (token = this.tokenizer.url(src, mangle))) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // text
      // prevent inlineText consuming extensions by clipping 'src' to extension start
      cutSrc = src;
      if (this.options.extensions && this.options.extensions.startInline) {
        let startIndex = Infinity;
        const tempSrc = src.slice(1);
        let tempStart;
        this.options.extensions.startInline.forEach(function(getStartIndex) {
          tempStart = getStartIndex.call({ lexer: this }, tempSrc);
          if (typeof tempStart === 'number' && tempStart >= 0) { startIndex = Math.min(startIndex, tempStart); }
        });
        if (startIndex < Infinity && startIndex >= 0) {
          cutSrc = src.substring(0, startIndex + 1);
        }
      }
      if (token = this.tokenizer.inlineText(cutSrc, smartypants)) {
        src = src.substring(token.raw.length);
        if (token.raw.slice(-1) !== '_') { // Track prevChar before string of ____ started
          prevChar = token.raw.slice(-1);
        }
        keepPrevChar = true;
        lastToken = tokens[tokens.length - 1];
        if (lastToken && lastToken.type === 'text') {
          lastToken.raw += token.raw;
          lastToken.text += token.text;
        } else {
          tokens.push(token);
        }
        continue;
      }

      if (src) {
        const errMsg = 'Infinite loop on byte: ' + src.charCodeAt(0);
        if (this.options.silent) {
          console.error(errMsg);
          break;
        } else {
          throw new Error(errMsg);
        }
      }
    }

    return tokens;
  }
}

/**
 * Renderer
 */
class Renderer {
  constructor(options) {
    this.options = options || defaults;
  }

  code(code, infostring, escaped) {
    const lang = (infostring || '').match(/\S*/)[0];
    if (this.options.highlight) {
      const out = this.options.highlight(code, lang);
      if (out != null && out !== code) {
        escaped = true;
        code = out;
      }
    }

    code = code.replace(/\n$/, '') + '\n';

    if (!lang) {
      return '<pre><code>'
        + (escaped ? code : escape(code, true))
        + '</code></pre>\n';
    }

    return '<pre><code class="'
      + this.options.langPrefix
      + escape(lang, true)
      + '">'
      + (escaped ? code : escape(code, true))
      + '</code></pre>\n';
  }

  /**
   * @param {string} quote
   */
  blockquote(quote) {
    return `<blockquote>\n${quote}</blockquote>\n`;
  }

  html(html) {
    return html;
  }

  /**
   * @param {string} text
   * @param {string} level
   * @param {string} raw
   * @param {any} slugger
   */
  heading(text, level, raw, slugger) {
    if (this.options.headerIds) {
      const id = this.options.headerPrefix + slugger.slug(raw);
      return `<h${level} id="${id}">${text}</h${level}>\n`;
    }

    // ignore IDs
    return `<h${level}>${text}</h${level}>\n`;
  }

  hr() {
    return this.options.xhtml ? '<hr/>\n' : '<hr>\n';
  }

  list(body, ordered, start) {
    const type = ordered ? 'ol' : 'ul',
      startatt = (ordered && start !== 1) ? (' start="' + start + '"') : '';
    return '<' + type + startatt + '>\n' + body + '</' + type + '>\n';
  }

  /**
   * @param {string} text
   */
  listitem(text) {
    return `<li>${text}</li>\n`;
  }

  checkbox(checked) {
    return '<input '
      + (checked ? 'checked="" ' : '')
      + 'disabled="" type="checkbox"'
      + (this.options.xhtml ? ' /' : '')
      + '> ';
  }

  /**
   * @param {string} text
   */
  paragraph(text) {
    return `<p>${text}</p>\n`;
  }

  /**
   * @param {string} header
   * @param {string} body
   */
  table(header, body) {
    if (body) body = `<tbody>${body}</tbody>`;

    return '<table>\n'
      + '<thead>\n'
      + header
      + '</thead>\n'
      + body
      + '</table>\n';
  }

  /**
   * @param {string} content
   */
  tablerow(content) {
    return `<tr>\n${content}</tr>\n`;
  }

  tablecell(content, flags) {
    const type = flags.header ? 'th' : 'td';
    const tag = flags.align
      ? `<${type} align="${flags.align}">`
      : `<${type}>`;
    return tag + content + `</${type}>\n`;
  }

  /**
   * span level renderer
   * @param {string} text
   */
  strong(text) {
    return `<strong>${text}</strong>`;
  }

  /**
   * @param {string} text
   */
  em(text) {
    return `<em>${text}</em>`;
  }

  /**
   * @param {string} text
   */
  codespan(text) {
    return `<code>${text}</code>`;
  }

  br() {
    return this.options.xhtml ? '<br/>' : '<br>';
  }

  /**
   * @param {string} text
   */
  del(text) {
    return `<del>${text}</del>`;
  }

  /**
   * @param {string} href
   * @param {string} title
   * @param {string} text
   */
  link(href, title, text) {
    href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
    if (href === null) {
      return text;
    }
    let out = '<a href="' + escape(href) + '"';
    if (title) {
      out += ' title="' + title + '"';
    }
    out += '>' + text + '</a>';
    return out;
  }

  /**
   * @param {string} href
   * @param {string} title
   * @param {string} text
   */
  image(href, title, text) {
    href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
    if (href === null) {
      return text;
    }

    let out = `<img src="${href}" alt="${text}"`;
    if (title) {
      out += ` title="${title}"`;
    }
    out += this.options.xhtml ? '/>' : '>';
    return out;
  }

  text(text) {
    return text;
  }
}

/**
 * TextRenderer
 * returns only the textual part of the token
 */
class TextRenderer {
  // no need for block level renderers
  strong(text) {
    return text;
  }

  em(text) {
    return text;
  }

  codespan(text) {
    return text;
  }

  del(text) {
    return text;
  }

  html(text) {
    return text;
  }

  text(text) {
    return text;
  }

  link(href, title, text) {
    return '' + text;
  }

  image(href, title, text) {
    return '' + text;
  }

  br() {
    return '';
  }
}

/**
 * Slugger generates header id
 */
class Slugger {
  constructor() {
    this.seen = {};
  }

  /**
   * @param {string} value
   */
  serialize(value) {
    return value
      .toLowerCase()
      .trim()
      // remove html tags
      .replace(/<[!\/a-z].*?>/ig, '')
      // remove unwanted chars
      .replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~]/g, '')
      .replace(/\s/g, '-');
  }

  /**
   * Finds the next safe (unique) slug to use
   * @param {string} originalSlug
   * @param {boolean} isDryRun
   */
  getNextSafeSlug(originalSlug, isDryRun) {
    let slug = originalSlug;
    let occurenceAccumulator = 0;
    if (this.seen.hasOwnProperty(slug)) {
      occurenceAccumulator = this.seen[originalSlug];
      do {
        occurenceAccumulator++;
        slug = originalSlug + '-' + occurenceAccumulator;
      } while (this.seen.hasOwnProperty(slug));
    }
    if (!isDryRun) {
      this.seen[originalSlug] = occurenceAccumulator;
      this.seen[slug] = 0;
    }
    return slug;
  }

  /**
   * Convert string to unique id
   * @param {object} [options]
   * @param {boolean} [options.dryrun] Generates the next unique slug without
   * updating the internal accumulator.
   */
  slug(value, options = {}) {
    const slug = this.serialize(value);
    return this.getNextSafeSlug(slug, options.dryrun);
  }
}

/**
 * Parsing & Compiling
 */
class Parser {
  constructor(options) {
    this.options = options || defaults;
    this.options.renderer = this.options.renderer || new Renderer();
    this.renderer = this.options.renderer;
    this.renderer.options = this.options;
    this.textRenderer = new TextRenderer();
    this.slugger = new Slugger();
  }

  /**
   * Static Parse Method
   */
  static parse(tokens, options) {
    const parser = new Parser(options);
    return parser.parse(tokens);
  }

  /**
   * Static Parse Inline Method
   */
  static parseInline(tokens, options) {
    const parser = new Parser(options);
    return parser.parseInline(tokens);
  }

  /**
   * Parse Loop
   */
  parse(tokens, top = true) {
    let out = '',
      i,
      j,
      k,
      l2,
      l3,
      row,
      cell,
      header,
      body,
      token,
      ordered,
      start,
      loose,
      itemBody,
      item,
      checked,
      task,
      checkbox,
      ret;

    const l = tokens.length;
    for (i = 0; i < l; i++) {
      token = tokens[i];

      // Run any renderer extensions
      if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
        ret = this.options.extensions.renderers[token.type].call({ parser: this }, token);
        if (ret !== false || !['space', 'hr', 'heading', 'code', 'table', 'blockquote', 'list', 'html', 'paragraph', 'text'].includes(token.type)) {
          out += ret || '';
          continue;
        }
      }

      switch (token.type) {
        case 'space': {
          continue;
        }
        case 'hr': {
          out += this.renderer.hr();
          continue;
        }
        case 'heading': {
          out += this.renderer.heading(
            this.parseInline(token.tokens),
            token.depth,
            unescape(this.parseInline(token.tokens, this.textRenderer)),
            this.slugger);
          continue;
        }
        case 'code': {
          out += this.renderer.code(token.text,
            token.lang,
            token.escaped);
          continue;
        }
        case 'table': {
          header = '';

          // header
          cell = '';
          l2 = token.header.length;
          for (j = 0; j < l2; j++) {
            cell += this.renderer.tablecell(
              this.parseInline(token.header[j].tokens),
              { header: true, align: token.align[j] }
            );
          }
          header += this.renderer.tablerow(cell);

          body = '';
          l2 = token.rows.length;
          for (j = 0; j < l2; j++) {
            row = token.rows[j];

            cell = '';
            l3 = row.length;
            for (k = 0; k < l3; k++) {
              cell += this.renderer.tablecell(
                this.parseInline(row[k].tokens),
                { header: false, align: token.align[k] }
              );
            }

            body += this.renderer.tablerow(cell);
          }
          out += this.renderer.table(header, body);
          continue;
        }
        case 'blockquote': {
          body = this.parse(token.tokens);
          out += this.renderer.blockquote(body);
          continue;
        }
        case 'list': {
          ordered = token.ordered;
          start = token.start;
          loose = token.loose;
          l2 = token.items.length;

          body = '';
          for (j = 0; j < l2; j++) {
            item = token.items[j];
            checked = item.checked;
            task = item.task;

            itemBody = '';
            if (item.task) {
              checkbox = this.renderer.checkbox(checked);
              if (loose) {
                if (item.tokens.length > 0 && item.tokens[0].type === 'paragraph') {
                  item.tokens[0].text = checkbox + ' ' + item.tokens[0].text;
                  if (item.tokens[0].tokens && item.tokens[0].tokens.length > 0 && item.tokens[0].tokens[0].type === 'text') {
                    item.tokens[0].tokens[0].text = checkbox + ' ' + item.tokens[0].tokens[0].text;
                  }
                } else {
                  item.tokens.unshift({
                    type: 'text',
                    text: checkbox
                  });
                }
              } else {
                itemBody += checkbox;
              }
            }

            itemBody += this.parse(item.tokens, loose);
            body += this.renderer.listitem(itemBody, task, checked);
          }

          out += this.renderer.list(body, ordered, start);
          continue;
        }
        case 'html': {
          // TODO parse inline content if parameter markdown=1
          out += this.renderer.html(token.text);
          continue;
        }
        case 'paragraph': {
          out += this.renderer.paragraph(this.parseInline(token.tokens));
          continue;
        }
        case 'text': {
          body = token.tokens ? this.parseInline(token.tokens) : token.text;
          while (i + 1 < l && tokens[i + 1].type === 'text') {
            token = tokens[++i];
            body += '\n' + (token.tokens ? this.parseInline(token.tokens) : token.text);
          }
          out += top ? this.renderer.paragraph(body) : body;
          continue;
        }

        default: {
          const errMsg = 'Token with "' + token.type + '" type was not found.';
          if (this.options.silent) {
            console.error(errMsg);
            return;
          } else {
            throw new Error(errMsg);
          }
        }
      }
    }

    return out;
  }

  /**
   * Parse Inline Tokens
   */
  parseInline(tokens, renderer) {
    renderer = renderer || this.renderer;
    let out = '',
      i,
      token,
      ret;

    const l = tokens.length;
    for (i = 0; i < l; i++) {
      token = tokens[i];

      // Run any renderer extensions
      if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
        ret = this.options.extensions.renderers[token.type].call({ parser: this }, token);
        if (ret !== false || !['escape', 'html', 'link', 'image', 'strong', 'em', 'codespan', 'br', 'del', 'text'].includes(token.type)) {
          out += ret || '';
          continue;
        }
      }

      switch (token.type) {
        case 'escape': {
          out += renderer.text(token.text);
          break;
        }
        case 'html': {
          out += renderer.html(token.text);
          break;
        }
        case 'link': {
          out += renderer.link(token.href, token.title, this.parseInline(token.tokens, renderer));
          break;
        }
        case 'image': {
          out += renderer.image(token.href, token.title, token.text);
          break;
        }
        case 'strong': {
          out += renderer.strong(this.parseInline(token.tokens, renderer));
          break;
        }
        case 'em': {
          out += renderer.em(this.parseInline(token.tokens, renderer));
          break;
        }
        case 'codespan': {
          out += renderer.codespan(token.text);
          break;
        }
        case 'br': {
          out += renderer.br();
          break;
        }
        case 'del': {
          out += renderer.del(this.parseInline(token.tokens, renderer));
          break;
        }
        case 'text': {
          out += renderer.text(token.text);
          break;
        }
        default: {
          const errMsg = 'Token with "' + token.type + '" type was not found.';
          if (this.options.silent) {
            console.error(errMsg);
            return;
          } else {
            throw new Error(errMsg);
          }
        }
      }
    }
    return out;
  }
}

/**
 * Marked
 */
function marked(src, opt, callback) {
  // throw error in case of non string input
  if (typeof src === 'undefined' || src === null) {
    throw new Error('marked(): input parameter is undefined or null');
  }
  if (typeof src !== 'string') {
    throw new Error('marked(): input parameter is of type '
      + Object.prototype.toString.call(src) + ', string expected');
  }

  if (typeof opt === 'function') {
    callback = opt;
    opt = null;
  }

  opt = merge({}, marked.defaults, opt || {});
  checkSanitizeDeprecation(opt);

  if (callback) {
    const highlight = opt.highlight;
    let tokens;

    try {
      tokens = Lexer.lex(src, opt);
    } catch (e) {
      return callback(e);
    }

    const done = function(err) {
      let out;

      if (!err) {
        try {
          if (opt.walkTokens) {
            marked.walkTokens(tokens, opt.walkTokens);
          }
          out = Parser.parse(tokens, opt);
        } catch (e) {
          err = e;
        }
      }

      opt.highlight = highlight;

      return err
        ? callback(err)
        : callback(null, out);
    };

    if (!highlight || highlight.length < 3) {
      return done();
    }

    delete opt.highlight;

    if (!tokens.length) return done();

    let pending = 0;
    marked.walkTokens(tokens, function(token) {
      if (token.type === 'code') {
        pending++;
        setTimeout(() => {
          highlight(token.text, token.lang, function(err, code) {
            if (err) {
              return done(err);
            }
            if (code != null && code !== token.text) {
              token.text = code;
              token.escaped = true;
            }

            pending--;
            if (pending === 0) {
              done();
            }
          });
        }, 0);
      }
    });

    if (pending === 0) {
      done();
    }

    return;
  }

  function onError(e) {
    e.message += '\nPlease report this to https://github.com/markedjs/marked.';
    if (opt.silent) {
      return '<p>An error occurred:</p><pre>'
        + escape(e.message + '', true)
        + '</pre>';
    }
    throw e;
  }

  try {
    const tokens = Lexer.lex(src, opt);
    if (opt.walkTokens) {
      if (opt.async) {
        return Promise.all(marked.walkTokens(tokens, opt.walkTokens))
          .then(() => {
            return Parser.parse(tokens, opt);
          })
          .catch(onError);
      }
      marked.walkTokens(tokens, opt.walkTokens);
    }
    return Parser.parse(tokens, opt);
  } catch (e) {
    onError(e);
  }
}

/**
 * Options
 */

marked.options =
marked.setOptions = function(opt) {
  merge(marked.defaults, opt);
  changeDefaults(marked.defaults);
  return marked;
};

marked.getDefaults = getDefaults;

marked.defaults = defaults;

/**
 * Use Extension
 */

marked.use = function(...args) {
  const opts = merge({}, ...args);
  const extensions = marked.defaults.extensions || { renderers: {}, childTokens: {} };
  let hasExtensions;

  args.forEach((pack) => {
    // ==-- Parse "addon" extensions --== //
    if (pack.extensions) {
      hasExtensions = true;
      pack.extensions.forEach((ext) => {
        if (!ext.name) {
          throw new Error('extension name required');
        }
        if (ext.renderer) { // Renderer extensions
          const prevRenderer = extensions.renderers ? extensions.renderers[ext.name] : null;
          if (prevRenderer) {
            // Replace extension with func to run new extension but fall back if false
            extensions.renderers[ext.name] = function(...args) {
              let ret = ext.renderer.apply(this, args);
              if (ret === false) {
                ret = prevRenderer.apply(this, args);
              }
              return ret;
            };
          } else {
            extensions.renderers[ext.name] = ext.renderer;
          }
        }
        if (ext.tokenizer) { // Tokenizer Extensions
          if (!ext.level || (ext.level !== 'block' && ext.level !== 'inline')) {
            throw new Error("extension level must be 'block' or 'inline'");
          }
          if (extensions[ext.level]) {
            extensions[ext.level].unshift(ext.tokenizer);
          } else {
            extensions[ext.level] = [ext.tokenizer];
          }
          if (ext.start) { // Function to check for start of token
            if (ext.level === 'block') {
              if (extensions.startBlock) {
                extensions.startBlock.push(ext.start);
              } else {
                extensions.startBlock = [ext.start];
              }
            } else if (ext.level === 'inline') {
              if (extensions.startInline) {
                extensions.startInline.push(ext.start);
              } else {
                extensions.startInline = [ext.start];
              }
            }
          }
        }
        if (ext.childTokens) { // Child tokens to be visited by walkTokens
          extensions.childTokens[ext.name] = ext.childTokens;
        }
      });
    }

    // ==-- Parse "overwrite" extensions --== //
    if (pack.renderer) {
      const renderer = marked.defaults.renderer || new Renderer();
      for (const prop in pack.renderer) {
        const prevRenderer = renderer[prop];
        // Replace renderer with func to run extension, but fall back if false
        renderer[prop] = (...args) => {
          let ret = pack.renderer[prop].apply(renderer, args);
          if (ret === false) {
            ret = prevRenderer.apply(renderer, args);
          }
          return ret;
        };
      }
      opts.renderer = renderer;
    }
    if (pack.tokenizer) {
      const tokenizer = marked.defaults.tokenizer || new Tokenizer();
      for (const prop in pack.tokenizer) {
        const prevTokenizer = tokenizer[prop];
        // Replace tokenizer with func to run extension, but fall back if false
        tokenizer[prop] = (...args) => {
          let ret = pack.tokenizer[prop].apply(tokenizer, args);
          if (ret === false) {
            ret = prevTokenizer.apply(tokenizer, args);
          }
          return ret;
        };
      }
      opts.tokenizer = tokenizer;
    }

    // ==-- Parse WalkTokens extensions --== //
    if (pack.walkTokens) {
      const walkTokens = marked.defaults.walkTokens;
      opts.walkTokens = function(token) {
        let values = [];
        values.push(pack.walkTokens.call(this, token));
        if (walkTokens) {
          values = values.concat(walkTokens.call(this, token));
        }
        return values;
      };
    }

    if (hasExtensions) {
      opts.extensions = extensions;
    }

    marked.setOptions(opts);
  });
};

/**
 * Run callback for every token
 */

marked.walkTokens = function(tokens, callback) {
  let values = [];
  for (const token of tokens) {
    values = values.concat(callback.call(marked, token));
    switch (token.type) {
      case 'table': {
        for (const cell of token.header) {
          values = values.concat(marked.walkTokens(cell.tokens, callback));
        }
        for (const row of token.rows) {
          for (const cell of row) {
            values = values.concat(marked.walkTokens(cell.tokens, callback));
          }
        }
        break;
      }
      case 'list': {
        values = values.concat(marked.walkTokens(token.items, callback));
        break;
      }
      default: {
        if (marked.defaults.extensions && marked.defaults.extensions.childTokens && marked.defaults.extensions.childTokens[token.type]) { // Walk any extensions
          marked.defaults.extensions.childTokens[token.type].forEach(function(childTokens) {
            values = values.concat(marked.walkTokens(token[childTokens], callback));
          });
        } else if (token.tokens) {
          values = values.concat(marked.walkTokens(token.tokens, callback));
        }
      }
    }
  }
  return values;
};

/**
 * Parse Inline
 * @param {string} src
 */
marked.parseInline = function(src, opt) {
  // throw error in case of non string input
  if (typeof src === 'undefined' || src === null) {
    throw new Error('marked.parseInline(): input parameter is undefined or null');
  }
  if (typeof src !== 'string') {
    throw new Error('marked.parseInline(): input parameter is of type '
      + Object.prototype.toString.call(src) + ', string expected');
  }

  opt = merge({}, marked.defaults, opt || {});
  checkSanitizeDeprecation(opt);

  try {
    const tokens = Lexer.lexInline(src, opt);
    if (opt.walkTokens) {
      marked.walkTokens(tokens, opt.walkTokens);
    }
    return Parser.parseInline(tokens, opt);
  } catch (e) {
    e.message += '\nPlease report this to https://github.com/markedjs/marked.';
    if (opt.silent) {
      return '<p>An error occurred:</p><pre>'
        + escape(e.message + '', true)
        + '</pre>';
    }
    throw e;
  }
};

/**
 * Expose
 */
marked.Parser = Parser;
marked.parser = Parser.parse;
marked.Renderer = Renderer;
marked.TextRenderer = TextRenderer;
marked.Lexer = Lexer;
marked.lexer = Lexer.lex;
marked.Tokenizer = Tokenizer;
marked.Slugger = Slugger;
marked.parse = marked;
Parser.parse;
Lexer.lex;

// i18n
// - deconf.general.closeDialog
//
// icons
// - n/a
//
// sass
// - $speakerDialog-nameSize
// - $speakerDialog-nameWeight
// - $speakerDialog-nameFamily
//

var script$I = {
  name: 'SpeakerDialog',
  props: {
    speaker: {
      type: Object,
      required: true
    }
  },
  computed: {
    localeRole: function localeRole() {
      var content = localiseFromObject(this.$i18n.locale, this.speaker.role);
      return content ? stripMarkdown(content) : null;
    },
    localeContent: function localeContent() {
      var content = localiseFromObject(this.$i18n.locale, this.speaker.bio);
      return content ? marked(content) : null;
    }
  },
  methods: {
    onClose: function onClose() {
      this.$deconf.closeDialog();
    }
  }
};

/* script */
var __vue_script__$I = script$I;
/* template */

var __vue_render__$I = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "speakerDialog"
  }, [_c('div', {
    staticClass: "speakerDialog-header"
  }, [_c('img', {
    staticClass: "speakerDialog-headshot",
    attrs: {
      "src": _vm.speaker.headshot
    }
  }), _c('div', [_c('h1', {
    staticClass: "speakerDialog-name"
  }, [_vm._v(_vm._s(_vm.speaker.name))]), _c('p', {
    staticClass: "speakerDialog-role"
  }, [_vm._v(_vm._s(_vm.localeRole))])])]), _c('p', {
    staticClass: "speakerDialog-bio content",
    domProps: {
      "innerHTML": _vm._s(_vm.localeContent)
    }
  }), _c('div', {
    staticClass: "buttons"
  }, [_c('button', {
    staticClass: "button is-link",
    on: {
      "click": _vm.onClose
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('deconf.general.closeDialog')) + " ")])])]);
};

var __vue_staticRenderFns__$I = [];
/* style */

var __vue_inject_styles__$J = undefined;
/* scoped */

var __vue_scope_id__$J = undefined;
/* module identifier */

var __vue_module_identifier__$J = undefined;
/* functional template */

var __vue_is_functional_template__$J = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$J = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$I,
  staticRenderFns: __vue_staticRenderFns__$I
}, __vue_inject_styles__$J, __vue_script__$I, __vue_scope_id__$J, __vue_is_functional_template__$J, __vue_module_identifier__$J, false, undefined, undefined, undefined);

// i18n
// - n/a
//
// icons
// - n/a
//
// sass
// - $speakerGrid-rounding
// - $speakerGrid-cellWidth
//

var script$H = {
  name: 'SpeakerGrid',
  props: {
    speakers: {
      type: Array,
      required: true
    }
  },
  methods: {
    localiseRole: function localiseRole(speaker) {
      var str = localiseFromObject(this.$i18n.locale, speaker.role);
      return str ? stripMarkdown(str) : null;
    },
    showDialog: function showDialog(speaker) {
      this.$deconf.showDialog(__vue_component__$J, {
        speaker: speaker
      });
    }
  }
};

/* script */
var __vue_script__$H = script$H;
/* template */

var __vue_render__$H = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "speakerGrid"
  }, _vm._l(_vm.speakers, function (speaker) {
    return _c('div', {
      key: speaker.id,
      staticClass: "speakerGrid-speaker",
      on: {
        "click": function click($event) {
          return _vm.showDialog(speaker);
        }
      }
    }, [_c('div', {
      staticClass: "speakerGrid-headshot"
    }, [_c('img', {
      attrs: {
        "src": speaker.headshot,
        "width": "42",
        "height": "42"
      }
    })]), _c('div', {
      staticClass: "speakerGrid-speakerInfo"
    }, [_c('div', {
      staticClass: "speakerGrid-name"
    }, [_vm._v(_vm._s(speaker.name))]), _c('div', {
      staticClass: "speakerGrid-role"
    }, [_vm._v(_vm._s(_vm.localiseRole(speaker)))])])]);
  }), 0);
};

var __vue_staticRenderFns__$H = [];
/* style */

var __vue_inject_styles__$I = undefined;
/* scoped */

var __vue_scope_id__$I = undefined;
/* module identifier */

var __vue_module_identifier__$I = undefined;
/* functional template */

var __vue_is_functional_template__$I = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$I = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$H,
  staticRenderFns: __vue_staticRenderFns__$H
}, __vue_inject_styles__$I, __vue_script__$H, __vue_scope_id__$I, __vue_is_functional_template__$I, __vue_module_identifier__$I, false, undefined, undefined, undefined);

//
// A reusable component to quickly flex between items without needing styles
//
//
// i18n
// - n/a
//
// icons
// - n/a
//
// sass
// - $stack-smallGap
// - $stack-regularGap
// - $stack-mediumGap
// - $stack-largeGap
//

/** Create a Vue enum-based prop w/ validation  */
function enumProp(values) {
  return {
    type: String,
    validator: function validator(v) {
      return values.includes(v);
    },
    required: true
  };
}

var script$G = {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Stack',
  props: {
    direction: enumProp(['horizontal', 'vertical']),
    gap: enumProp(['none', 'small', 'regular', 'medium', 'large']),
    align: enumProp(['start', 'end', 'center', 'stretch'])
  },
  computed: {
    classes: function classes() {
      return ["is-".concat(this.gap), "is-".concat(this.direction), "is-aligned-".concat(this.align)];
    }
  }
};

/* script */
var __vue_script__$G = script$G;
/* template */

var __vue_render__$G = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "stack",
    class: _vm.classes
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__$G = [];
/* style */

var __vue_inject_styles__$H = undefined;
/* scoped */

var __vue_scope_id__$H = undefined;
/* module identifier */

var __vue_module_identifier__$H = undefined;
/* functional template */

var __vue_is_functional_template__$H = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$H = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$G,
  staticRenderFns: __vue_staticRenderFns__$G
}, __vue_inject_styles__$H, __vue_script__$G, __vue_scope_id__$H, __vue_is_functional_template__$H, __vue_module_identifier__$H, false, undefined, undefined, undefined);

//
// i18n
// - n/a
//
// icons
// - n/a
//
// sass
// - $staticLayout-background
//

/** @deprecated This wasn't used, a combination of `UtilLayout` and `ApiContent` work well */
var script$F = {
  name: 'StaticLayout',
  computed: {
    showLanguageControl: function showLanguageControl() {
      return false;
    }
  }
};

/* script */
var __vue_script__$F = script$F;
/* template */

var __vue_render__$F = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "staticLayout"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "staticLayout-header"
  }, [_c('div', {
    staticClass: "staticLayout-backButton"
  }, [_vm._t("backButton")], 2), _vm.showLanguageControl ? _c('div', {
    staticClass: "staticLayout-languageControl"
  }) : _vm._e()]), _c('div', {
    staticClass: "staticLayout-main"
  }, [_vm._t("main")], 2)])])]);
};

var __vue_staticRenderFns__$F = [];
/* style */

var __vue_inject_styles__$G = undefined;
/* scoped */

var __vue_scope_id__$G = undefined;
/* module identifier */

var __vue_module_identifier__$G = undefined;
/* functional template */

var __vue_is_functional_template__$G = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$G = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$F,
  staticRenderFns: __vue_staticRenderFns__$F
}, __vue_inject_styles__$G, __vue_script__$F, __vue_scope_id__$G, __vue_is_functional_template__$G, __vue_module_identifier__$G, false, undefined, undefined, undefined);

//
// i18n
// - deconf.timeSlot.past - Label when in the past
// - deconf.timeSlot.live - Label when happening now
//
// icons
// - fas long-arrow-alt-right
// - fas long-arrow-alt-left
//
// sass
// - $timeSlot-presentColor
// - $timeSlot-presentBackground
// - $timeSlot-pastColor
// - $timeSlot-pastBackground
//
var script$E = {
  name: 'TimeSlot',
  components: {
    BidirectionalIcon: __vue_component__$_
  },
  props: {
    slotState: {
      type: String,
      required: true
    },
    startDate: {
      type: Date,
      required: true
    },
    endDate: {
      type: Date,
      required: true
    }
  },
  filters: {
    shortTime: function shortTime(date) {
      return new Date(date).toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    localeDate: function localeDate(date) {
      return new Date(date).toLocaleString();
    },
    localeDateShort: function localeDateShort(date) {
      return new Date(date).toLocaleDateString([], {
        month: 'long',
        day: 'numeric'
      });
    }
  },
  computed: {
    tagClasses: function tagClasses() {
      return "is-".concat(this.slotState);
    },
    tagI18nKey: function tagI18nKey() {
      if (this.slotState === 'past') return 'deconf.timeSlot.past';
      if (this.slotState === 'present') return 'deconf.timeSlot.live';
      return null;
    },
    timezone: function timezone() {
      var intl = Intl.DateTimeFormat().resolvedOptions();
      return intl.timeZoneName || intl.timeZone;
    },
    isMultiDay: function isMultiDay() {
      return this.endDate.getDate() !== this.startDate.getDate();
    }
  }
};

/* script */
var __vue_script__$E = script$E;
/* template */

var __vue_render__$E = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "timeSlot"
  }, [_vm.tagI18nKey ? _c('div', {
    staticClass: "timeSlot-tag",
    class: _vm.tagClasses
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.tagI18nKey)) + " ")]) : _vm._e(), _c('h3', {
    staticClass: "timeSlot-time icon-text"
  }, [_c('span', {
    attrs: {
      "title": _vm._f("localeDate")(_vm.startDate)
    }
  }, [_vm._v(" " + _vm._s(_vm._f("shortTime")(_vm.startDate)) + " ")]), _c('BidirectionalIcon', {
    attrs: {
      "ltr": ['fas', 'long-arrow-alt-right'],
      "rtl": ['fas', 'long-arrow-alt-left']
    }
  }), _c('span', {
    attrs: {
      "title": _vm._f("localeDate")(_vm.endDate)
    }
  }, [_vm._v(" " + _vm._s(_vm._f("shortTime")(_vm.endDate)) + " ")])], 1), _c('p', {
    staticClass: "timeSlot-date icon-text"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm._f("localeDateShort")(_vm.startDate)) + " ")]), _vm.isMultiDay ? [_c('BidirectionalIcon', {
    attrs: {
      "ltr": ['fas', 'long-arrow-alt-right'],
      "rtl": ['fas', 'long-arrow-alt-left']
    }
  }), _c('span', [_vm._v(_vm._s(_vm._f("localeDateShort")(_vm.endDate)))])] : _vm._e()], 2), _c('p', {
    staticClass: "timeSlot-timezone"
  }, [_c('span', [_vm._v(_vm._s(_vm.timezone))])])]);
};

var __vue_staticRenderFns__$E = [];
/* style */

var __vue_inject_styles__$F = undefined;
/* scoped */

var __vue_scope_id__$F = undefined;
/* module identifier */

var __vue_module_identifier__$F = undefined;
/* functional template */

var __vue_is_functional_template__$F = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$F = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$E,
  staticRenderFns: __vue_staticRenderFns__$E
}, __vue_inject_styles__$F, __vue_script__$E, __vue_scope_id__$F, __vue_is_functional_template__$F, __vue_module_identifier__$F, false, undefined, undefined, undefined);

// i18n
// - deconf.tokenCaptureView.message - temporary message to show
//
// icons
// - n/a
//
// sass
// - n/a
//
// events
// - success (user) - emitted when a token was captured and parsed
// - failed () - emitted when a token was not captured
//

var script$D = {
  name: 'TokenCaptureView',
  props: {
    tokenKey: {
      type: String,
      required: true
    }
  },
  mounted: function mounted() {
    this.processHash(window.location.hash);
  },
  methods: {
    processHash: function processHash(hash) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        var params, authToken, user;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!hash || !hash.startsWith('#'))) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", _this.$emit('failed'));

              case 2:
                params = new URLSearchParams(hash.slice(1));
                authToken = params.get('token');

                if (authToken) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return", _this.$emit('failed'));

              case 6:
                localStorage.setItem(_this.tokenKey, authToken);
                _context.next = 9;
                return _this.$store.dispatch('api/authenticate', {
                  token: authToken
                });

              case 9:
                user = _this.$store.state.api.user;
                if (!user) _this.$emit('failed');

                _this.$deconf.trackMetric(createLoginFinishEvent());

                _this.$emit('success', user);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};

/* script */
var __vue_script__$D = script$D;
/* template */

var __vue_render__$D = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('deconf.tokenCaptureView.message')))])]);
};

var __vue_staticRenderFns__$D = [];
/* style */

var __vue_inject_styles__$E = undefined;
/* scoped */

var __vue_scope_id__$E = undefined;
/* module identifier */

var __vue_module_identifier__$E = undefined;
/* functional template */

var __vue_is_functional_template__$E = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$E = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$D,
  staticRenderFns: __vue_staticRenderFns__$D
}, __vue_inject_styles__$E, __vue_script__$D, __vue_scope_id__$E, __vue_is_functional_template__$E, __vue_module_identifier__$E, false, undefined, undefined, undefined);

// i18n
// - n/a
//
// icons
// - fas chevron-right
// - fas chevron-left
// - [or by prop]
//
// sass
// - n/a
//

var script$C = {
  name: 'ColorWidget',
  components: {
    FontAwesomeIcon: FontAwesomeIcon,
    BidirectionalIcon: __vue_component__$_
  },
  props: {
    kind: {
      type: String,
      required: true,
      validator: function validator(v) {
        return ['primary', 'secondary', 'twitter', 'custom'].includes(v);
      }
    },
    icon: {
      type: [String, Array],
      required: true
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    href: {
      type: String,
      default: null
    }
  },
  computed: {
    rootComponent: function rootComponent() {
      return this.href ? 'a' : 'div';
    },
    extraArgs: function extraArgs() {
      return this.href ? {
        href: this.href
      } : {};
    },
    classes: function classes() {
      return ["is-".concat(this.kind), this.href ? 'is-hoverable' : ''];
    }
  }
};

/* script */
var __vue_script__$C = script$C;
/* template */

var __vue_render__$C = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c(_vm.rootComponent, _vm._b({
    tag: "component",
    staticClass: "colorWidget",
    class: _vm.classes
  }, 'component', _vm.extraArgs, false), [_c('h2', {
    staticClass: "colorWidget-title"
  }, [_c('FontAwesomeIcon', {
    staticClass: "fa-fw",
    attrs: {
      "icon": _vm.icon
    }
  }), _vm._v(" " + _vm._s(_vm.title) + " ")], 1), _c('p', {
    staticClass: "colorWidget-subtitle"
  }, [_vm._v(" " + _vm._s(_vm.subtitle) + " ")]), _vm.href ? _c('span', {
    staticClass: "colorWidget-arrow"
  }, [_c('BidirectionalIcon', {
    attrs: {
      "ltr": ['fas', 'chevron-right'],
      "rtl": ['fas', 'chevron-left']
    }
  })], 1) : _vm._e()]);
};

var __vue_staticRenderFns__$C = [];
/* style */

var __vue_inject_styles__$D = undefined;
/* scoped */

var __vue_scope_id__$D = undefined;
/* module identifier */

var __vue_module_identifier__$D = undefined;
/* functional template */

var __vue_is_functional_template__$D = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$D = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$C,
  staticRenderFns: __vue_staticRenderFns__$C
}, __vue_inject_styles__$D, __vue_script__$C, __vue_scope_id__$D, __vue_is_functional_template__$D, __vue_module_identifier__$D, false, undefined, undefined, undefined);

// i18n
// - deconf.miniSession.live - Live tag on a mini session
// - deconf.miniSession.view - Action to view a mini session
// - deconf.general.hours
// - deconf.general.minutes
// - deconf.general.seconds
//
// icons
// - fas arrow-right
// - fas arrow-left
//
// sass
// - $miniSession-titleSize
// - $miniSession-titleWeight
//

var script$B = {
  name: 'MiniSession',
  components: {
    BidirectionalIcon: __vue_component__$_
  },
  props: {
    session: {
      type: Object,
      required: true
    },
    sessionSlot: {
      type: Object,
      required: true
    },
    currentDate: {
      type: Date,
      required: true
    }
  },
  computed: {
    localeTitle: function localeTitle() {
      return localiseFromObject(this.$i18n.locale, this.session.title);
    },
    localeDate: function localeDate() {
      return this.sessionSlot.start.toLocaleString(undefined, {
        hour: '2-digit',
        minute: '2-digit',
        month: 'long',
        day: 'numeric',
        year: 'numeric'
      });
    },
    sessionRoute: function sessionRoute() {
      return {
        name: Routes.Session,
        params: {
          sessionId: this.session.id
        }
      };
    },
    isLive: function isLive() {
      return this.currentDate.getTime() > this.sessionSlot.start.getTime() && this.currentDate.getTime() < this.sessionSlot.end.getTime();
    },
    localeCountdown: function localeCountdown() {
      var _this = this;

      return getCountdownMessage(getCountdown(this.currentDate, this.sessionSlot.start), function (key, value) {
        return _this.$tc(key, value);
      });
    }
  }
};

/* script */
var __vue_script__$B = script$B;
/* template */

var __vue_render__$B = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "miniSession"
  }, [_c('div', {
    staticClass: "tags"
  }, [_vm.isLive ? _c('span', {
    staticClass: "tag is-danger is-uppercase"
  }, [_vm._v(" " + _vm._s(_vm.$t('deconf.miniSession.live')) + " ")]) : _c('span', {
    staticClass: "tag is-grey"
  }, [_vm._v(" " + _vm._s(_vm.localeCountdown) + " ")])]), _c('p', {
    staticClass: "miniSession-title"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.sessionRoute
    }
  }, [_vm._v(" " + _vm._s(_vm.localeTitle) + " ")])], 1), _c('div', {
    staticClass: "miniSession-columns"
  }, [_c('p', {
    staticClass: "miniSession-date"
  }, [_vm._v(" " + _vm._s(_vm.localeDate) + " ")]), _c('p', {
    staticClass: "miniSession-actions"
  }, [_c('router-link', {
    staticClass: "button is-link is-light",
    attrs: {
      "to": _vm.sessionRoute
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t('deconf.miniSession.view')) + " ")]), _c('BidirectionalIcon', {
    attrs: {
      "ltr": ['fas', 'arrow-right'],
      "rtl": ['fas', 'arrow-left']
    }
  })], 1)], 1)])]);
};

var __vue_staticRenderFns__$B = [];
/* style */

var __vue_inject_styles__$C = undefined;
/* scoped */

var __vue_scope_id__$C = undefined;
/* module identifier */

var __vue_module_identifier__$C = undefined;
/* functional template */

var __vue_is_functional_template__$C = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$C = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$B,
  staticRenderFns: __vue_staticRenderFns__$B
}, __vue_inject_styles__$C, __vue_script__$B, __vue_scope_id__$C, __vue_is_functional_template__$C, __vue_module_identifier__$C, false, undefined, undefined, undefined);

// i18n
// - deconf.featuredSessions.title - Title of featured sessions section
// - deconf.featuredSessions.action - Action of featured sessions section
//
// icons
// - n/a
//
// sass
// - $featuredSessions-titleSize
// - $featuredSessions-titleWeight
//

var script$A = {
  name: 'FeaturedSessions',
  components: {
    MiniSession: __vue_component__$C
  },
  props: {
    featured: {
      type: Array,
      required: true
    },
    currentDate: {
      type: Date,
      required: true
    },
    showAction: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    scheduleRoute: function scheduleRoute() {
      return {
        name: Routes.Schedule
      };
    }
  }
};

/* script */
var __vue_script__$A = script$A;
/* template */

var __vue_render__$A = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "featuredSessions"
  }, [_c('p', {
    staticClass: "featuredSessions-title"
  }, [_vm._v(" " + _vm._s(_vm.$t('deconf.featuredSessions.title')) + " ")]), _c('div', {
    staticClass: "featuredSessions-sessions"
  }, _vm._l(_vm.featured, function (group) {
    return _c('MiniSession', {
      key: group.session.id,
      staticClass: "featuredSessions-session",
      attrs: {
        "session": group.session,
        "session-slot": group.slot,
        "current-date": _vm.currentDate
      }
    });
  }), 1), _vm.showAction ? _c('div', {
    staticClass: "buttons"
  }, [_c('router-link', {
    staticClass: "button is-link is-fullwidth",
    attrs: {
      "to": _vm.scheduleRoute
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('deconf.featuredSessions.action')) + " ")])], 1) : _vm._e()]);
};

var __vue_staticRenderFns__$A = [];
/* style */

var __vue_inject_styles__$B = undefined;
/* scoped */

var __vue_scope_id__$B = undefined;
/* module identifier */

var __vue_module_identifier__$B = undefined;
/* functional template */

var __vue_is_functional_template__$B = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$B = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$A,
  staticRenderFns: __vue_staticRenderFns__$A
}, __vue_inject_styles__$B, __vue_script__$A, __vue_scope_id__$B, __vue_is_functional_template__$B, __vue_module_identifier__$B, false, undefined, undefined, undefined);

//
// i18n
// - n/a
//
// icons
// - n/a
//
// sass
// - $heroCard-color
// - $heroCard-family
//
var script$z = {
  name: 'HeroCard',
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    coverImage: {
      type: String,
      required: true
    }
  },
  computed: {
    style: function style() {
      return {
        'background-image': "url(".concat(this.coverImage, ")")
      };
    }
  }
};

/* script */
var __vue_script__$z = script$z;
/* template */

var __vue_render__$z = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "heroCard",
    style: _vm.style
  }, [_c('div', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('h1', {
    staticClass: "heroCard-title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('p', {
    staticClass: "heroCard-subtitle"
  }, [_vm._v(_vm._s(_vm.subtitle))])])])]);
};

var __vue_staticRenderFns__$z = [];
/* style */

var __vue_inject_styles__$A = undefined;
/* scoped */

var __vue_scope_id__$A = undefined;
/* module identifier */

var __vue_module_identifier__$A = undefined;
/* functional template */

var __vue_is_functional_template__$A = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$A = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$z,
  staticRenderFns: __vue_staticRenderFns__$z
}, __vue_inject_styles__$A, __vue_script__$z, __vue_scope_id__$A, __vue_is_functional_template__$A, __vue_module_identifier__$A, false, undefined, undefined, undefined);

//
// i18n
// - n/a
//
// icons
// - n/a
//
// sass
// - $sponsorRow-regularHeight
// - $sponsorRow-largeHeight
// - $sponsorRow-mediumHeight
// - $sponsorRow-smallHeight
//
var sizes = ['large', 'medium', 'regular', 'small'];
var script$y = {
  name: 'SponsorRow',
  props: {
    title: {
      type: String,
      required: true
    },
    size: {
      type: String,
      required: true,
      validator: function validator(v) {
        return sizes.includes(v);
      }
    },
    sponsors: {
      type: Array,
      required: true
    }
  },
  computed: {
    classes: function classes() {
      return "is-".concat(this.size);
    }
  },
  methods: {
    sponsorComponent: function sponsorComponent(sponsor) {
      return sponsor.href ? 'a' : 'span';
    }
  }
};

/* script */
var __vue_script__$y = script$y;
/* template */

var __vue_render__$y = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "sponsorRow",
    class: _vm.classes
  }, [_c('h3', {
    staticClass: "sponsorRow-title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('div', {
    staticClass: "sponsorRow-sponsors"
  }, _vm._l(_vm.sponsors, function (sponsor) {
    return _c(_vm.sponsorComponent(sponsor), {
      key: sponsor.title,
      tag: "component",
      staticClass: "sponsorRow-sponsor",
      attrs: {
        "href": sponsor.href
      }
    }, [_c('img', {
      staticClass: "sponsorRow-image",
      attrs: {
        "src": sponsor.image,
        "alt": sponsor.title,
        "title": sponsor.title
      }
    })]);
  }), 1)]);
};

var __vue_staticRenderFns__$y = [];
/* style */

var __vue_inject_styles__$z = undefined;
/* scoped */

var __vue_scope_id__$z = undefined;
/* module identifier */

var __vue_module_identifier__$z = undefined;
/* functional template */

var __vue_is_functional_template__$z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$y,
  staticRenderFns: __vue_staticRenderFns__$y
}, __vue_inject_styles__$z, __vue_script__$y, __vue_scope_id__$z, __vue_is_functional_template__$z, __vue_module_identifier__$z, false, undefined, undefined, undefined);

// i18n
// - n/a
//
// icons
// - n/a
//
// sass
// - $sponsorGrid-spacing
//

var script$x = {
  name: 'SponsorGrid',
  components: {
    SponsorRow: __vue_component__$z
  },
  props: {
    groups: {
      type: Array,
      required: true
    }
  }
};

/* script */
var __vue_script__$x = script$x;
/* template */

var __vue_render__$x = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "sponsorGrid"
  }, _vm._l(_vm.groups, function (group) {
    return _c('SponsorRow', {
      key: group.size,
      attrs: {
        "size": group.size,
        "title": group.title,
        "sponsors": group.sponsors
      }
    });
  }), 1);
};

var __vue_staticRenderFns__$x = [];
/* style */

var __vue_inject_styles__$y = undefined;
/* scoped */

var __vue_scope_id__$y = undefined;
/* module identifier */

var __vue_module_identifier__$y = undefined;
/* functional template */

var __vue_is_functional_template__$y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$x,
  staticRenderFns: __vue_staticRenderFns__$x
}, __vue_inject_styles__$y, __vue_script__$x, __vue_scope_id__$y, __vue_is_functional_template__$y, __vue_module_identifier__$y, false, undefined, undefined, undefined);

function getAudioContext() {
  return window.AudioContext || window.webkitAudioContext || null;
}

/**
 * Interpolate between two values
 */
function lerp(v0, v1, factor) {
  return (1 - factor) * v0 + factor * v1;
}
/**
 * Given a number of samples at a given rate,
 * work out how many samples would needed at a new rate
 */

function getResampledLength(inputLength, inputRate, outputRate) {
  return Math.round(outputRate * inputLength / inputRate);
}
function linearResample(from, to) {
  for (var i = 0; i < to.length; i++) {
    var pivot = i * from.length / to.length;
    var j0 = Math.floor(pivot);
    var ratio = pivot - j0;
    var j1 = Math.min(from.length - 1, j0 + 1);
    to[i] = lerp(from[j0], from[j1], ratio);
  }

  return to;
}
function nearestNeighbourResample(from, to) {
  for (var i = 0; i < to.length; i++) {
    var j = Math.floor(i * from.length / to.length);
    to[i] = from[j];
  }

  return to;
}
var MAX_FACTOR = Math.pow(2, 15);
/** Convert a Float32Array array into an Int16Array array */

function float32ToInt16(float32s) {
  var output = new Int16Array(float32s.length);

  for (var i = 0; i < output.length; i++) {
    output[i] = Math.trunc(float32s[i] * (MAX_FACTOR * 0.5));
  }

  return output;
}
/** Convert a Int16Array array into an Float32Array array */

function int16ToFloat32(int16s) {
  var output = new Float32Array(int16s.length);

  for (var i = 0; i < output.length; i++) {
    output[i] = int16s[i] / MAX_FACTOR;
  }

  return output;
}

var BroadcasterState;

(function (BroadcasterState) {
  BroadcasterState["active"] = "active";
  BroadcasterState["inactive"] = "inactive";
})(BroadcasterState || (BroadcasterState = {}));

var AudioBroadcaster = /*#__PURE__*/function () {
  function AudioBroadcaster(options) {
    _classCallCheck(this, AudioBroadcaster);

    _defineProperty(this, "_state", BroadcasterState.inactive);

    _defineProperty(this, "stream", null);

    _defineProperty(this, "recorder", null);

    _defineProperty(this, "ctx", null);

    _defineProperty(this, "source", null);

    this.options = options;
  }

  _createClass(AudioBroadcaster, [{
    key: "state",
    get: function get() {
      return this._state;
    },
    set: function set(newState) {
      this._state = newState;
      this.emitChange();
    }
  }, {
    key: "emitChange",
    value: function emitChange() {
      this.options.onChange({
        state: this.state
      });
    }
  }, {
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(previousDeviceId) {
        var _this = this;

        var AudioContext, _this$stream$getAudio, deviceId, sampleRate;

        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.state === BroadcasterState.active)) {
                  _context.next = 2;
                  break;
                }

                throw new Error('Already started');

              case 2:
                AudioContext = getAudioContext();
                this.ctx = new AudioContext({
                  sampleRate: this.options.audioTransportRate
                });
                _context.next = 6;
                return navigator.mediaDevices.getUserMedia({
                  video: false,
                  audio: {
                    deviceId: {
                      ideal: previousDeviceId
                    },
                    sampleRate: {
                      ideal: this.options.audioTransportRate
                    },
                    echoCancellation: {
                      ideal: true
                    }
                  }
                });

              case 6:
                this.stream = _context.sent;
                _this$stream$getAudio = this.stream.getAudioTracks()[0].getSettings(), deviceId = _this$stream$getAudio.deviceId;
                sampleRate = this.ctx.sampleRate; // Register the user's audio worklet

                _context.next = 11;
                return this.ctx.audioWorklet.addModule(this.options.audioWorklet.path);

              case 11:
                // Create a recorder to process the oudio
                this.recorder = new AudioWorkletNode(this.ctx, this.options.audioWorklet.name, {
                  channelCount: 1,
                  numberOfInputs: 1,
                  numberOfOutputs: 0
                });

                this.recorder.port.onmessage = function (event) {
                  var _event$data = event.data,
                      kind = _event$data.kind,
                      arrayBuffer = _event$data.arrayBuffer;

                  if (kind === 'ondata' && arrayBuffer) {
                    _this.handleData(arrayBuffer, sampleRate, _this.options.audioTransportRate);

                    return;
                  }

                  console.error('Unknown AudioBroadcaster port message', event.data);
                }; // Create a source to connect the stream to the recorder


                this.source = this.ctx.createMediaStreamSource(this.stream);
                this.source.connect(this.recorder);
                this.state = BroadcasterState.active;
                return _context.abrupt("return", {
                  chosenDevice: deviceId
                });

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function start(_x) {
        return _start.apply(this, arguments);
      }

      return start;
    }()
  }, {
    key: "stop",
    value: function stop() {
      if (this.state !== BroadcasterState.active) {
        throw new Error('Not recording');
      }

      this.state = BroadcasterState.inactive;

      if (this.stream) {
        this.stream.getTracks().forEach(function (t) {
          return t.stop();
        });
      }

      if (this.source) {
        this.source.disconnect();
      }

      if (this.recorder) {
        this.recorder.port.onmessage = null;
        this.recorder.disconnect();
      }

      if (this.ctx) {
        this.ctx.close();
      }
    }
  }, {
    key: "handleData",
    value: function handleData(arrayBuffer, inputRate, outputRate) {
      var inputFloats = new Float32Array(arrayBuffer);
      var targetLength = getResampledLength(inputFloats.length, inputRate, outputRate);
      this.options.onDebug('AudioBroadcaster#handleData byteLength=%d inputRate=%d outputRate=%d outputLength=%d', arrayBuffer.byteLength, inputRate, outputRate, targetLength);
      var outputFloats = new Float32Array(targetLength);
      linearResample(inputFloats, outputFloats);
      this.options.onData(float32ToInt16(outputFloats).buffer, outputRate);
    }
  }, {
    key: "handleStreamError",
    value: function handleStreamError(error) {
      switch (error.name) {
        case 'NotFoundError':
          alert('No microphones found');
          break;

        case 'SecurityError':
        case 'PermissionDeniedError':
          // Do nothing; this is the same as the user canceling the call.
          break;

        default:
          alert('Error opening your microphone: ' + error.message);
          break;
      }
    }
  }], [{
    key: "isSupported",
    value: function isSupported() {
      return Boolean(getAudioContext());
    }
  }]);

  return AudioBroadcaster;
}();

function _toArray(arr) {
  return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray$5(arr) || _nonIterableRest();
}

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var ReceiverState;

(function (ReceiverState) {
  ReceiverState["inactive"] = "inactive";
  ReceiverState["buffering"] = "buffering";
  ReceiverState["playing"] = "playing";
})(ReceiverState || (ReceiverState = {}));

var AudioReceiver = /*#__PURE__*/function () {
  function AudioReceiver(options) {
    _classCallCheck(this, AudioReceiver);

    _defineProperty(this, "ctx", null);

    _defineProperty(this, "buffers", []);

    _defineProperty(this, "nextPacket", 1);

    _defineProperty(this, "state", ReceiverState.inactive);

    _defineProperty(this, "rawStats", null);

    this.options = options;
  }

  _createClass(AudioReceiver, [{
    key: "getState",
    value: function getState() {
      return this.state;
    }
  }, {
    key: "getStats",
    value: function getStats() {
      return _objectSpread$2({
        state: this.state
      }, this.rawStats);
    }
  }, {
    key: "emitChange",
    value: function emitChange() {
      this.options.onChange({
        state: this.state,
        bufferSize: this.buffers.length,
        rawStats: this.rawStats
      });
    }
  }, {
    key: "open",
    value: function open() {
      var AudioContext = getAudioContext();
      this.ctx = new AudioContext({
        sampleRate: this.options.playbackRate
      });
      this.buffers = [];
      this.nextPacket = 1;
      this.state = ReceiverState.inactive;
      this.rawStats = null;
      this.emitChange();
    }
  }, {
    key: "close",
    value: function close() {
      this.buffers = [];
      this.state = ReceiverState.inactive;
      this.rawStats = null;
      if (this.ctx) this.ctx.close();
      this.ctx = null;
      this.emitChange();
    }
  }, {
    key: "playOrBuffer",
    value: function playOrBuffer() {
      this.state = ReceiverState.buffering;

      if (this.buffers.length > this.options.audioLowLevel) {
        this.state = ReceiverState.playing;
        this.unqueueBuffer();
      } else {
        this.emitChange();
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      this.state = ReceiverState.inactive;
    }
  }, {
    key: "pushData",
    value: function pushData(_ref) {
      var arrayBuffer = _ref.arrayBuffer,
          sampleRate = _ref.sampleRate;
      if (!this.ctx) return; // Confert int16 transport arrays to float32 audio arrays

      var inputFloats = int16ToFloat32(new Int16Array(arrayBuffer)); // Work out how long the resampled array needs to be

      var targetLength = getResampledLength(inputFloats.length, sampleRate, this.options.playbackRate);
      this.options.onDebug('AudioReceiver#push intLength=%d floatsLength=%d inputRate=%d outputRate=%d', arrayBuffer.byteLength, inputFloats.buffer.byteLength, sampleRate, this.options.playbackRate); // Create an audio buffer to put the resampled audio into

      var audioBuffer = this.ctx.createBuffer(1, targetLength, this.options.playbackRate);
      var outputFloats = audioBuffer.getChannelData(0); // Resample the audio into the buffer

      linearResample(inputFloats, outputFloats); // Store the buffer to play later

      this.buffers.push({
        index: this.nextPacket++,
        buffer: audioBuffer
      }); // Update our stats

      this.rawStats = {
        input: {
          byteLength: arrayBuffer.byteLength,
          sampleRate: sampleRate
        },
        output: {
          byteLength: outputFloats.buffer.byteLength,
          sampleRate: this.options.playbackRate
        }
      };
      this.emitChange();
    }
  }, {
    key: "unqueueBuffer",
    value: function unqueueBuffer() {
      var _this = this;

      // Do nothing if we're inactive
      if (this.state === ReceiverState.inactive || !this.ctx) return; // If we're out of data, enter the buffering state

      if (this.buffers.length === 0) {
        this.state = ReceiverState.buffering;
        return;
      } // If we aren't in the playing state, stop here


      if (this.state !== ReceiverState.playing) return; // If we're playing and run out of data, start buffering again

      if (this.state === ReceiverState.playing && this.buffers.length < 1) {
        this.state = ReceiverState.buffering;
        return;
      } // Get the next and remaining buffers to play
      // also removing any packets over the "high" level to maintain liveness


      var _this$buffers$slice = this.buffers.slice(-this.options.audioHighLevel),
          _this$buffers$slice2 = _toArray(_this$buffers$slice),
          next = _this$buffers$slice2[0],
          remaining = _this$buffers$slice2.slice(1);

      this.buffers = remaining; // Create a source to play the audio

      var source = this.ctx.createBufferSource();
      source.buffer = next.buffer;
      source.connect(this.ctx.destination); // When the source finishes, play another

      source.onended = function () {
        _this.options.onDebug('AudioReceiver source@ended packet=%d', next.index);

        source.disconnect();

        _this.unqueueBuffer();
      }; // Start playing the audio


      source.start(); // Notify changes

      this.emitChange();
    }
  }], [{
    key: "isSupported",
    value: function isSupported() {
      return Boolean(getAudioContext());
    }
  }]);

  return AudioReceiver;
}(); //
// Deprecated typo naming
//

/** @deprecated use AudioReceiver */

var AudioReciever = AudioReceiver;
/** @deprecated use AudioReceiver */

/** @deprecated use AudioReceiver */
var RecieverState = ReceiverState;
/** @deprecated use AudioReceiver */

function _createForOfIteratorHelper$1(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }

function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
// i18n
// - n/a
//
// icons
// - n/a
// - n/a
//
// sass
// - n/a
//
// store actions
// - api/fetchContent { slug }
//

var script$w = {
  name: 'ApiContent',
  props: {
    slug: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      content: undefined
    };
  },
  computed: {
    domContent: function domContent() {
      var html = document.createElement('div');

      if (this.content) {
        var localeHtml = localiseFromObject(this.$i18n.locale, this.content);
        if (localeHtml) html.innerHTML = localeHtml;
      }

      return html;
    }
  },
  mounted: function mounted() {
    this.fetchData();
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$store.dispatch('api/fetchContent', {
                  slug: _this.slug
                });

              case 2:
                _this.content = _context.sent;

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },

    /** Convert a HTML node to a Vue.js VNode */
    domToVue: function domToVue(node) {
      var _this2 = this;

      if (node instanceof Text) return node.textContent || ''; // Convert dom attributes to a plain record

      var attrs = {};

      if (node instanceof Element) {
        var _iterator = _createForOfIteratorHelper$1(node.attributes),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var key = _step.value;
            attrs[key.name] = key.value;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      return this.$createElement(node.nodeName, {
        attrs: attrs
      }, Array.from(node.childNodes).map(function (child) {
        return _this2.domToVue(child);
      }));
    }
  },
  render: function render(createElement) {
    var _this3 = this;

    // Go through each child of the api content
    // if a <div id="xyz"> attempt to replace with a slot
    // otherwise, copy the dom node across
    var children = Array.from(this.domContent.children).map(function (child) {
      return child.id && _this3.$slots[child.id] ? _this3.$slots[child.id] : _this3.domToVue(child);
    });
    return createElement('div', {
      staticClass: 'content'
    }, children);
  }
};

/* script */
var __vue_script__$w = script$w;
/* template */

/* style */

var __vue_inject_styles__$x = undefined;
/* scoped */

var __vue_scope_id__$x = undefined;
/* module identifier */

var __vue_module_identifier__$x = undefined;
/* functional template */

var __vue_is_functional_template__$x = undefined;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$x = /*#__PURE__*/normalizeComponent({}, __vue_inject_styles__$x, __vue_script__$w, __vue_scope_id__$x, __vue_is_functional_template__$x, __vue_module_identifier__$x, false, undefined, undefined, undefined);

// i18n
// - n/a
//
// icons
// - fas terminal
// - fas clock
// - fas forward
// - fas fast-forward
// - fas backward
// - fas fast-backward
// - fas stop
// - fas play
//
// sass
// - n/a
//

// compose a real date from our date/time components from <input> elements
function makeDate(date, time) {
  var _Date$toISOString$spl = new Date().toISOString().split(/[TZ.]/),
      _Date$toISOString$spl2 = _slicedToArray(_Date$toISOString$spl, 2),
      fallbackDate = _Date$toISOString$spl2[0],
      fallbackTime = _Date$toISOString$spl2[1];

  try {
    var result = new Date("".concat(date || fallbackDate, "T").concat(time || fallbackTime, ".000Z"));
    result.setMinutes(result.getMinutes() + result.getTimezoneOffset(), result.getSeconds(), result.getMilliseconds());

    if (Number.isNaN(result)) {
      console.error('Failed to create a date');
      return undefined;
    }

    return result;
  } catch (error) {
    return undefined;
  }
} //
// Icons
// - fas terminal
// - fas clock
//


var trackingSpeeds = {
  fastBackward: -1000,
  backward: -200,
  play: 1,
  forward: 200,
  fastForward: 1000
};
var script$v = {
  name: 'DevControl',
  components: {
    FontAwesomeIcon: FontAwesomeIcon
  },
  data: function data() {
    return {
      tracking: null
    };
  },
  props: {
    devPlugin: {
      type: Object,
      required: true
    },
    forceEnable: {
      type: Boolean,
      default: false
    },
    controls: {
      type: Array,
      default: function _default() {
        return ['slotState', 'scheduleDate'];
      }
    }
  },
  computed: {
    slotStateIsEnabled: function slotStateIsEnabled() {
      return this.controls.includes('slotState');
    },
    scheduleDateIsEnabled: function scheduleDateIsEnabled() {
      return this.controls.includes('scheduleDate');
    },
    scheduleDate: function scheduleDate() {
      var scheduleDate = new Date(this.devPlugin.scheduleDate);

      var padStart = function padStart(n) {
        return n.toString().padStart(2, '0');
      };

      return {
        date: [scheduleDate.getFullYear(), padStart(scheduleDate.getMonth() + 1), padStart(scheduleDate.getDate())].join('-'),
        time: [padStart(scheduleDate.getHours()), padStart(scheduleDate.getMinutes()), padStart(scheduleDate.getSeconds())].join(':')
      };
    }
  },
  methods: {
    toggleExpanded: function toggleExpanded() {
      this.devPlugin.isVisible = !this.devPlugin.isVisible;
    },
    updateSlotState: function updateSlotState(event) {
      if (this.devPlugin) {
        this.devPlugin.slotState = event.target.value || undefined;
      }
    },
    updateScheduleDate: function updateScheduleDate(event) {
      var target = event.target;
      console.debug('updateScheduleDate', target.value);
      this.devPlugin.scheduleDate = makeDate(target.value, this.scheduleDate.time);
    },
    updateScheduleTime: function updateScheduleTime(event) {
      var target = event.target;
      console.debug('updateScheduleTime', target.value);

      var _target$value$split = target.value.split(':'),
          _target$value$split2 = _slicedToArray(_target$value$split, 3),
          _target$value$split2$ = _target$value$split2[0],
          h = _target$value$split2$ === void 0 ? '00' : _target$value$split2$,
          _target$value$split2$2 = _target$value$split2[1],
          m = _target$value$split2$2 === void 0 ? '00' : _target$value$split2$2,
          _target$value$split2$3 = _target$value$split2[2],
          s = _target$value$split2$3 === void 0 ? '00' : _target$value$split2$3;

      var newTime = [h, m, s].join(':');
      this.devPlugin.scheduleDate = makeDate(this.scheduleDate.date, newTime);
    },
    setScheduleDate: function setScheduleDate() {
      this.devPlugin.scheduleDate = new Date();
    },
    clearScheduleDate: function clearScheduleDate() {
      this.devPlugin.scheduleDate = undefined;
    },
    startTracking: function startTracking(speed) {
      var _this = this;

      this.stopTracking();
      var lastTick = Date.now();
      var timerId = window.setInterval(function () {
        var date = _this.devPlugin.scheduleDate;

        if (!date) {
          _this.stopTracking();

          return;
        }

        var dt = Date.now() - lastTick;
        lastTick = Date.now();
        _this.devPlugin.scheduleDate = new Date(date.getTime() + dt * trackingSpeeds[speed]);
      }, 250);
      this.tracking = {
        timerId: timerId,
        speed: speed
      };
    },
    stopTracking: function stopTracking() {
      if (!this.tracking) return;
      window.clearInterval(this.tracking.timerId);
      this.tracking = null;
    },
    disableButton: function disableButton(speed) {
      if (!this.devPlugin.scheduleDate) return true;
      return this.tracking ? this.tracking.speed === speed : false;
    },
    trackClasses: function trackClasses() {
      return {
        button: true,
        'is-primary': true
      };
    }
  },
  destroyed: function destroyed() {
    this.stopTracking();
  }
};

/* script */
var __vue_script__$v = script$v;
/* template */

var __vue_render__$w = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.devPlugin.isEnabled || _vm.forceEnable ? _c('div', {
    staticClass: "devControl"
  }, [!_vm.devPlugin.isVisible ? _c('button', {
    staticClass: "button devControl-toggle",
    on: {
      "click": _vm.toggleExpanded
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('FontAwesomeIcon', {
    attrs: {
      "icon": ['fas', 'terminal']
    }
  })], 1)]) : _vm._e(), _vm.devPlugin.isVisible ? _c('div', {
    staticClass: "devControl-panel"
  }, [_c('div', {
    staticClass: "panel is-warning"
  }, [_c('p', {
    staticClass: "devControl-heading"
  }, [_vm._v("Dev controls")]), _vm.slotStateIsEnabled ? [!_vm.devPlugin.slotState ? _c('div', {
    staticClass: "devControl-block"
  }, [_c('button', {
    staticClass: "button is-fullwidth is-primary is-light",
    on: {
      "click": function click($event) {
        _vm.devPlugin.slotState = 'future';
      }
    }
  }, [_vm._v(" Override session slot state ")])]) : _c('div', {
    staticClass: "devControl-block"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Override slot state")]), _c('div', {
    staticClass: "control has-icons-left"
  }, [_c('div', {
    staticClass: "select is-fullwidth"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.devPlugin.slotState,
      expression: "devPlugin.slotState"
    }],
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });

        _vm.$set(_vm.devPlugin, "slotState", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Reset")]), _c('option', {
    attrs: {
      "value": "future"
    }
  }, [_vm._v("Future")]), _c('option', {
    attrs: {
      "value": "soon"
    }
  }, [_vm._v("Soon")]), _c('option', {
    attrs: {
      "value": "present"
    }
  }, [_vm._v("Present")]), _c('option', {
    attrs: {
      "value": "past"
    }
  }, [_vm._v("Past")])])]), _c('span', {
    staticClass: "icon is-left"
  }, [_c('FontAwesomeIcon', {
    attrs: {
      "icon": ['fas', 'clock']
    }
  })], 1)])])])] : _vm._e(), _vm.scheduleDateIsEnabled ? [!_vm.devPlugin.scheduleDate ? _c('div', {
    staticClass: "devControl-block"
  }, [_c('button', {
    staticClass: "button is-fullwidth is-primary is-light",
    on: {
      "click": function click($event) {
        _vm.devPlugin.scheduleDate = new Date();
      }
    }
  }, [_vm._v(" Override schedule date ")])]) : _c('div', {
    staticClass: "devControl-block has-columns"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Schedule Date")]), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": _vm.scheduleDate.date
    },
    on: {
      "input": _vm.updateScheduleDate
    }
  })])]), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Time")]), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "input",
    attrs: {
      "type": "time"
    },
    domProps: {
      "value": _vm.scheduleDate.time
    },
    on: {
      "input": _vm.updateScheduleTime
    }
  })])]), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "devControl-smallButton button is-danger",
    on: {
      "click": function click($event) {
        _vm.devPlugin.scheduleDate = undefined;
      }
    }
  }, [_vm._v(" Clear ")])])])])] : _vm._e(), _c('div', {
    staticClass: "devControl-block"
  }, [_c('div', {
    staticClass: "buttons is-centered"
  }, [_c('button', {
    class: _vm.trackClasses('fastBackward'),
    attrs: {
      "disabled": _vm.disableButton('fastBackward')
    },
    on: {
      "click": function click($event) {
        return _vm.startTracking('fastBackward');
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('FontAwesomeIcon', {
    attrs: {
      "icon": ['fas', 'fast-backward']
    }
  })], 1)]), _c('button', {
    class: _vm.trackClasses('backward'),
    attrs: {
      "disabled": _vm.disableButton('backward')
    },
    on: {
      "click": function click($event) {
        return _vm.startTracking('backward');
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('FontAwesomeIcon', {
    attrs: {
      "icon": ['fas', 'backward']
    }
  })], 1)]), _c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": !_vm.tracking
    },
    on: {
      "click": _vm.stopTracking
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('FontAwesomeIcon', {
    attrs: {
      "icon": ['fas', 'stop']
    }
  })], 1)]), _c('button', {
    class: _vm.trackClasses('play'),
    attrs: {
      "disabled": _vm.disableButton('play')
    },
    on: {
      "click": function click($event) {
        return _vm.startTracking('play');
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('FontAwesomeIcon', {
    attrs: {
      "icon": ['fas', 'play']
    }
  })], 1)]), _c('button', {
    class: _vm.trackClasses('forward'),
    attrs: {
      "disabled": _vm.disableButton('forward')
    },
    on: {
      "click": function click($event) {
        return _vm.startTracking('forward');
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('FontAwesomeIcon', {
    attrs: {
      "icon": ['fas', 'forward']
    }
  })], 1)]), _c('button', {
    class: _vm.trackClasses('fastForward'),
    attrs: {
      "disabled": _vm.disableButton('fastForward')
    },
    on: {
      "click": function click($event) {
        return _vm.startTracking('fastForward');
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('FontAwesomeIcon', {
    attrs: {
      "icon": ['fas', 'fast-forward']
    }
  })], 1)])])]), _vm._t("extras"), _c('div', {
    staticClass: "devControl-block"
  }, [_c('button', {
    staticClass: "button is-fullwidth is-small",
    on: {
      "click": _vm.toggleExpanded
    }
  }, [_vm._v(" Close ")])])], 2)]) : _vm._e()]) : _vm._e();
};

var __vue_staticRenderFns__$w = [];
/* style */

var __vue_inject_styles__$w = undefined;
/* scoped */

var __vue_scope_id__$w = undefined;
/* module identifier */

var __vue_module_identifier__$w = undefined;
/* functional template */

var __vue_is_functional_template__$w = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$w = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$w,
  staticRenderFns: __vue_staticRenderFns__$w
}, __vue_inject_styles__$w, __vue_script__$v, __vue_scope_id__$w, __vue_is_functional_template__$w, __vue_module_identifier__$w, false, undefined, undefined, undefined);

//
// Wraps a bulma checkbox field
//
//
// i18n
// - n/a
//
// icons
// - n/a
//
// sass
// - n/a
//
var script$u = {
  name: 'CheckboxField',
  props: {
    name: {
      type: String,
      required: true
    },
    value: {
      type: Boolean,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    hasError: {
      type: Boolean,
      default: false
    },
    help: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    labelClass: function labelClass() {
      return {
        'is-danger': this.hasError
      };
    }
  },
  methods: {
    onInput: function onInput(event) {
      if (!(event.target instanceof HTMLInputElement)) return;
      this.$emit('input', event.target.checked);
    }
  }
};

/* script */
var __vue_script__$u = script$u;
/* template */

var __vue_render__$v = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "checkbox",
    class: _vm.labelClass,
    attrs: {
      "for": _vm.name
    }
  }, [_c('input', {
    staticClass: "checkbox",
    attrs: {
      "id": _vm.name,
      "type": "checkbox",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "change": _vm.onInput
    }
  }), _vm._v(" " + _vm._s(_vm.text) + " ")]), _vm.help ? _c('p', {
    staticClass: "help",
    class: _vm.labelClass
  }, [_vm._v(_vm._s(_vm.help))]) : _vm._e()]);
};

var __vue_staticRenderFns__$v = [];
/* style */

var __vue_inject_styles__$v = undefined;
/* scoped */

var __vue_scope_id__$v = undefined;
/* module identifier */

var __vue_module_identifier__$v = undefined;
/* functional template */

var __vue_is_functional_template__$v = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$v = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$v,
  staticRenderFns: __vue_staticRenderFns__$v
}, __vue_inject_styles__$v, __vue_script__$u, __vue_scope_id__$v, __vue_is_functional_template__$v, __vue_module_identifier__$v, false, undefined, undefined, undefined);

//
// i18n
// - n/a
//
// icons
// - n/a
//
// sass
// - n/a
//
var script$t = {
  name: 'SegmentControl',
  props: {
    value: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    }
  },
  methods: {
    optionClasses: function optionClasses(option) {
      return {
        'is-primary': option.value === this.value
      };
    },
    onOption: function onOption(option) {
      this.$emit('input', option.value);
    }
  }
};

/* script */
var __vue_script__$t = script$t;
/* template */

var __vue_render__$u = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "inlineField"
  }, _vm._l(_vm.options, function (option) {
    return _c('button', {
      key: option.value,
      staticClass: "button",
      class: _vm.optionClasses(option),
      on: {
        "click": function click($event) {
          return _vm.onOption(option);
        }
      }
    }, [_vm._v(" " + _vm._s(option.text) + " ")]);
  }), 0);
};

var __vue_staticRenderFns__$u = [];
/* style */

var __vue_inject_styles__$u = undefined;
/* scoped */

var __vue_scope_id__$u = undefined;
/* module identifier */

var __vue_module_identifier__$u = undefined;
/* functional template */

var __vue_is_functional_template__$u = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$u = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$u,
  staticRenderFns: __vue_staticRenderFns__$u
}, __vue_inject_styles__$u, __vue_script__$t, __vue_scope_id__$u, __vue_is_functional_template__$u, __vue_module_identifier__$u, false, undefined, undefined, undefined);

//
// Wraps a bulma select field
//
//
// i18n
// - n/a
//
// icons
// - n/a
//
// sass
// - n/a
//
var script$s = {
  name: 'SelectField',
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: null
    },
    value: {
      type: String,
      default: null
    },
    help: {
      type: String,
      default: null
    },
    options: {
      type: Array,
      required: true
    },
    hasError: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fullwidth: {
      type: Boolean,
      default: false
    },
    notSelected: {
      type: String,
      default: 'Please select...'
    }
  },
  computed: {
    selectClass: function selectClass() {
      return {
        'is-danger': this.hasError,
        'is-fullwidth': this.fullwidth
      };
    }
  },
  methods: {
    onInput: function onInput(e) {
      if (!(e.target instanceof HTMLSelectElement)) return;
      this.$emit('input', e.target.value);
    }
  }
};

/* script */
var __vue_script__$s = script$s;
/* template */

var __vue_render__$t = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "field"
  }, [_vm.label ? _c('label', {
    staticClass: "label",
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(" " + _vm._s(_vm.label) + " ")]) : _vm._e(), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select",
    class: _vm.selectClass
  }, [_c('select', {
    attrs: {
      "id": _vm.name,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "change": _vm.onInput
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.notSelected))]), _vm._l(_vm.options, function (option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(" " + _vm._s(option.text) + " ")]);
  })], 2)])]), _vm.help ? _c('div', {
    staticClass: "help",
    class: _vm.selectClass
  }, [_vm._v(" " + _vm._s(_vm.help) + " ")]) : _vm._e()]);
};

var __vue_staticRenderFns__$t = [];
/* style */

var __vue_inject_styles__$t = undefined;
/* scoped */

var __vue_scope_id__$t = undefined;
/* module identifier */

var __vue_module_identifier__$t = undefined;
/* functional template */

var __vue_is_functional_template__$t = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$t = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$t,
  staticRenderFns: __vue_staticRenderFns__$t
}, __vue_inject_styles__$t, __vue_script__$s, __vue_scope_id__$t, __vue_is_functional_template__$t, __vue_module_identifier__$t, false, undefined, undefined, undefined);

//
// Wraps a bulma input field
//
//
// i18n
// - n/a
//
// icons
// - n/a
//
// sass
// - n/a
//
var script$r = {
  name: 'TextField',
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    help: {
      type: String,
      default: null
    },
    hasError: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'text'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    inputClass: function inputClass() {
      return {
        'is-danger': this.hasError
      };
    }
  },
  methods: {
    onInput: function onInput(event) {
      if (!(event.target instanceof HTMLInputElement)) return;
      this.$emit('input', event.target.value);
    },
    onEnter: function onEnter() {
      this.$emit('enter');
    }
  }
};

/* script */
var __vue_script__$r = script$r;
/* template */

var __vue_render__$s = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(" " + _vm._s(_vm.label) + " ")]), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "input",
    class: _vm.inputClass,
    attrs: {
      "id": _vm.name,
      "type": _vm.type,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.onInput,
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.onEnter.apply(null, arguments);
      }
    }
  })]), _vm.help ? _c('div', {
    staticClass: "help",
    class: _vm.inputClass
  }, [_vm._v(" " + _vm._s(_vm.help) + " ")]) : _vm._e()]);
};

var __vue_staticRenderFns__$s = [];
/* style */

var __vue_inject_styles__$s = undefined;
/* scoped */

var __vue_scope_id__$s = undefined;
/* module identifier */

var __vue_module_identifier__$s = undefined;
/* functional template */

var __vue_is_functional_template__$s = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$s = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$s,
  staticRenderFns: __vue_staticRenderFns__$s
}, __vue_inject_styles__$s, __vue_script__$r, __vue_scope_id__$s, __vue_is_functional_template__$s, __vue_module_identifier__$s, false, undefined, undefined, undefined);

// i18n
// - deconf.login.title
// - deconf.login.badEmail
// - deconf.login.email.label
// - deconf.login.email.placeholder
// - deconf.login.email.help
// - deconf.login.submitButton
// - deconf.login.registerLabel
// - deconf.login.registerAction
//
// icons
// - n/a
//
// sass
// - n/a
//

var script$q = {
  name: 'LoginView',
  components: {
    TextField: __vue_component__$s
  },
  props: {
    apiModule: {
      type: String,
      required: true
    },
    initialState: {
      type: String,
      default: 'pending'
    }
  },
  data: function data() {
    return {
      email: '',
      state: this.initialState
    };
  },
  computed: {
    registerRoute: function registerRoute() {
      return {
        name: Routes.Register
      };
    }
  },
  methods: {
    submit: function submit() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        var success;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.state = 'working';
                _context.next = 3;
                return _this.$store.dispatch("".concat(_this.apiModule, "/login"), _this.email);

              case 3:
                success = _context.sent;
                _this.state = success ? 'success' : 'error';

                _this.$deconf.trackMetric(createLoginStartEvent('_feature_removed_'));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};

/* script */
var __vue_script__$q = script$q;
/* template */

var __vue_render__$r = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "loginView"
  }, [_c('div', {
    staticClass: "loginView"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('deconf.login.title')))]), _c('div', {
    staticClass: "content"
  }, [_vm._t("infoText")], 2), _vm.state === 'success' ? _c('div', {
    staticClass: "notification is-success"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": function click($event) {
        _vm.state = 'pending';
      }
    }
  }), _vm._t("doneText")], 2) : _vm._e(), _vm.state === 'error' ? _c('div', {
    staticClass: "notification is-danger"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('deconf.login.badEmail')))])]) : _vm._e(), _vm.state !== 'success' ? _c('div', {
    staticClass: "loginView-form"
  }, [_c('TextField', {
    attrs: {
      "name": "email",
      "type": "email",
      "label": _vm.$t('deconf.login.email.label'),
      "placeholder": _vm.$t('deconf.login.email.placeholder'),
      "help": _vm.$t('deconf.login.email.help'),
      "has-error": _vm.state === 'error',
      "disabled": _vm.state === 'working'
    },
    on: {
      "enter": _vm.submit
    },
    model: {
      value: _vm.email,
      callback: function callback($$v) {
        _vm.email = $$v;
      },
      expression: "email"
    }
  }), _c('div', {
    staticClass: "buttons"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": _vm.state === 'working'
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('deconf.login.submitButton')) + " ")])])], 1) : _vm._e(), _c('hr'), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v(" " + _vm._s(_vm.$t('deconf.login.registerLabel')) + " "), _c('router-link', {
    attrs: {
      "to": _vm.registerRoute
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('deconf.login.registerAction')) + " ")])], 1)])])]);
};

var __vue_staticRenderFns__$r = [];
/* style */

var __vue_inject_styles__$r = undefined;
/* scoped */

var __vue_scope_id__$r = undefined;
/* module identifier */

var __vue_module_identifier__$r = undefined;
/* functional template */

var __vue_is_functional_template__$r = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$r = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$r,
  staticRenderFns: __vue_staticRenderFns__$r
}, __vue_inject_styles__$r, __vue_script__$q, __vue_scope_id__$r, __vue_is_functional_template__$r, __vue_module_identifier__$r, false, undefined, undefined, undefined);

//
// i18n
// - deconf.profile.title
// - deconf.profile.actionLabel
// - deconf.profile.logoutButton
// - deconf.profile.dangerLabel
// - deconf.profile.deleteButton
// - deconf.profile.deleteText
// - deconf.general.genericError
//
// icons
// - n/a
//
// sass
// - $profileView-headingWeight
// - $profileView-headingSize
// - $profileView-headingFamily
// - $profileView-titleWeight
// - $profileView-titleSize
// - $profileView-titleFamily
//
// events
// - logout – When the user logged out
// - unregister – When the user unregistered
//
var script$p = {
  name: 'ProfileView',
  props: {
    apiModule: {
      type: String,
      required: true
    },
    fields: {
      type: Array,
      required: true
    }
  },
  methods: {
    logout: function logout() {
      this.$deconf.trackMetric(createLogoutEvent());
      this.$emit('logout');
    },
    unregister: function unregister() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        var msg, confirmed, success;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                msg = _this.$t('deconf.profile.deleteText');
                confirmed = window.confirm(msg);

                _this.$deconf.trackMetric(createUnregisterEvent(confirmed));

                if (confirmed) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return");

              case 5:
                _context.next = 7;
                return _this.$store.dispatch("".concat(_this.apiModule, "/unregister"));

              case 7:
                success = _context.sent;

                if (success) {
                  _context.next = 11;
                  break;
                }

                alert(_this.$t('deconf.general.genericError'));
                return _context.abrupt("return");

              case 11:
                _this.$emit('unregister');

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};

/* script */
var __vue_script__$p = script$p;
/* template */

var __vue_render__$q = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "profileView"
  }, [_c('h1', {
    staticClass: "profileView-title"
  }, [_vm._v(" " + _vm._s(_vm.$t('deconf.profile.title')) + " ")]), _c('table', {
    staticClass: "table"
  }, [_c('tbody', _vm._l(_vm.fields, function (field) {
    return _c('tr', {
      key: field.label
    }, [_c('th', [_vm._v(_vm._s(field.label))]), _c('td', [_vm._v(_vm._s(field.value))])]);
  }), 0)]), _vm._t("preActions"), _c('p', {
    staticClass: "profileView-heading"
  }, [_vm._v(" " + _vm._s(_vm.$t('deconf.profile.actionLabel')) + " ")]), _c('div', {
    staticClass: "buttons"
  }, [_c('button', {
    staticClass: "button is-link",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('deconf.profile.logoutButton')) + " ")])]), [_c('p', {
    staticClass: "profileView-heading"
  }, [_vm._v(" " + _vm._s(_vm.$t('deconf.profile.dangerLabel')) + " ")]), _c('div', {
    staticClass: "buttons"
  }, [_c('button', {
    staticClass: "button is-danger",
    on: {
      "click": _vm.unregister
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('deconf.profile.deleteButton')) + " ")])])]], 2);
};

var __vue_staticRenderFns__$q = [];
/* style */

var __vue_inject_styles__$q = undefined;
/* scoped */

var __vue_scope_id__$q = undefined;
/* module identifier */

var __vue_module_identifier__$q = undefined;
/* functional template */

var __vue_is_functional_template__$q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$q,
  staticRenderFns: __vue_staticRenderFns__$q
}, __vue_inject_styles__$q, __vue_script__$p, __vue_scope_id__$q, __vue_is_functional_template__$q, __vue_module_identifier__$q, false, undefined, undefined, undefined);

/* script */

/* template */
var __vue_render__$p = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "registerView"
  }, [_vm._v("Work in progress")]);
};

var __vue_staticRenderFns__$p = [];
/* style */

var __vue_inject_styles__$p = undefined;
/* scoped */

var __vue_scope_id__$p = undefined;
/* module identifier */

var __vue_module_identifier__$p = undefined;
/* functional template */

var __vue_is_functional_template__$p = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$p = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$p,
  staticRenderFns: __vue_staticRenderFns__$p
}, __vue_inject_styles__$p, {}, __vue_scope_id__$p, __vue_is_functional_template__$p, __vue_module_identifier__$p, false, undefined, undefined, undefined);

var script$o = {
  name: 'PrivateCalendarCreator',
  props: {
    apiModule: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      privateCal: null,
      didCopy: false,
      timerId: null
    };
  },
  computed: {
    copyClasses: function copyClasses() {
      return {
        'is-dark': !this.didCopy,
        'is-success': this.didCopy
      };
    }
  },
  destroyed: function destroyed() {
    if (this.timerId) {
      window.clearInterval(this.timerId);
      this.timerId = null;
    }
  },
  methods: {
    generate: function generate() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$deconf.trackMetric({
                  eventName: 'profile/userCalendar',
                  payload: {}
                });

                _context.next = 3;
                return _this.$store.dispatch("".concat(_this.apiModule, "/fetchUserCalendar"));

              case 3:
                _this.privateCal = _context.sent;
                if (!_this.privateCal) alert('Something went wrong');

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    copyLink: function copyLink() {
      var _this2 = this;

      if (!this.privateCal) return;
      copyToClipboard(this.privateCal.url.toString());
      this.didCopy = true;
      this.timerId = window.setTimeout(function () {
        return _this2.didCopy = false;
      }, 5000);
    }
  }
};

/* script */
var __vue_script__$o = script$o;
/* template */

var __vue_render__$o = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "privateCalendarCreator"
  }, [_c('p', {
    staticClass: "privateCalendarCreator-title"
  }, [_vm._v(" " + _vm._s(_vm.$t('deconf.addUserCalendar.title')) + " ")]), !_vm.privateCal ? [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.generate
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('deconf.addUserCalendar.generate')) + " ")])] : [_c('div', {
    staticClass: "addUserCalendar-control"
  }, [_c('input', {
    staticClass: "input addUserCalendar-input",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.privateCal.url
    }
  }), _c('button', {
    staticClass: "button",
    class: _vm.copyClasses,
    on: {
      "click": _vm.copyLink
    }
  }, [_vm._v(" " + _vm._s(_vm.didCopy ? _vm.$t('deconf.addUserCalendar.copied') : _vm.$t('deconf.addUserCalendar.copy')) + " ")]), _c('p', {
    staticClass: "addUserCalendar-help"
  }, [_vm._v(" " + _vm._s(_vm.$t('deconf.addUserCalendar.info')) + " ")])])]], 2);
};

var __vue_staticRenderFns__$o = [];
/* style */

var __vue_inject_styles__$o = undefined;
/* scoped */

var __vue_scope_id__$o = undefined;
/* module identifier */

var __vue_module_identifier__$o = undefined;
/* functional template */

var __vue_is_functional_template__$o = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$o = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$o,
  staticRenderFns: __vue_staticRenderFns__$o
}, __vue_inject_styles__$o, __vue_script__$o, __vue_scope_id__$o, __vue_is_functional_template__$o, __vue_module_identifier__$o, false, undefined, undefined, undefined);

//
// i18n
// - n/a
//
// icons
// - n/a
//
// sass
// - n/a
//
var script$n = {
  name: 'InlineFilter',
  props: {
    label: {
      type: String,
      required: true
    },
    offLabel: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    value: {
      required: true
    }
  },
  methods: {
    localise: function localise(object) {
      return localiseFromObject(this.$i18n.locale, object);
    },
    onInput: function onInput(event) {
      var target = event.target;
      if (!target) return;
      var allOptions = [null].concat(_toConsumableArray(this.options.map(function (o) {
        return o.value;
      })));
      var value = allOptions[target.selectedIndex];
      this.$emit('input', value);
    }
  }
};

/* script */
var __vue_script__$n = script$n;
/* template */

var __vue_render__$n = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "inlineField"
  }, [_c('div', {
    staticClass: "button is-static"
  }, [_vm._v(" " + _vm._s(_vm.label) + " ")]), _c('div', {
    staticClass: "select"
  }, [_c('select', {
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.onInput
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(" " + _vm._s(_vm.offLabel) + " ")]), _vm._l(_vm.options, function (item) {
    return _c('option', {
      key: item.value.toString(),
      domProps: {
        "value": item.value
      }
    }, [_vm._v(" " + _vm._s(item.text) + " ")]);
  })], 2)])]);
};

var __vue_staticRenderFns__$n = [];
/* style */

var __vue_inject_styles__$n = undefined;
/* scoped */

var __vue_scope_id__$n = undefined;
/* module identifier */

var __vue_module_identifier__$n = undefined;
/* functional template */

var __vue_is_functional_template__$n = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$n = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$n,
  staticRenderFns: __vue_staticRenderFns__$n
}, __vue_inject_styles__$n, __vue_script__$n, __vue_scope_id__$n, __vue_is_functional_template__$n, __vue_module_identifier__$n, false, undefined, undefined, undefined);

var QUERY_DEBOUNCE = 500;
var DEFAULT_FILTERS = ['query', 'sessionType', 'track', 'theme', 'date', 'isRecorded', 'language']; //
// i18n
// - deconf.scheduleFilters.query - Label of the search field
// - deconf.scheduleFilters.showFilters - Button to show the extra filters
// - deconf.scheduleFilters.hideFilters - Button to hide the extra filters
// - deconf.scheduleFilters.clearFilters - Button to reset filtering
// - deconf.scheduleFilters.dateFilter - The label of the date filter
// - deconf.scheduleFilters.typeFilter - The label of the type filter
// - deconf.scheduleFilters.trackFilter - The label of the track filter
// - deconf.scheduleFilters.themeFilter - The label of the theme filter
// - deconf.scheduleFilters.languageFilter - The label of the language filter
// - deconf.scheduleFilters.recordedFilter - The label of the "is recorded" filter
// - deconf.scheduleFilters.offLabel - The label when no value is applied, e.g. "All"
// - deconf.scheduleFilters.yes - "Yes" option
// - deconf.scheduleFilters.no - "No" option
//
// icons
// - n/a
//
// sass
// - n/a
//

var script$m = {
  name: 'ScheduleFilters',
  components: {
    InlineFilter: __vue_component__$n
  },
  props: {
    schedule: {
      type: Object,
      required: true
    },
    filters: {
      type: Object,
      required: true
    },
    enabledFilters: {
      type: Array,
      default: function _default() {
        return DEFAULT_FILTERS;
      }
    },
    languageOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      showExtraFilters: false,
      queryHandler: null
    };
  },
  computed: {
    dateOptions: function dateOptions() {
      var dates = new Map(this.schedule.slots.map(function (s) {
        return [startOfDay(s.start).toISOString(), s.start];
      }));
      return _toConsumableArray(dates.entries()).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            start = _ref2[0],
            date = _ref2[1];

        return {
          value: start,
          text: friendlyDate(date),
          date: date
        };
      }).sort(function (a, b) {
        return a.date.getTime() - b.date.getTime();
      });
    },
    sessionTypeOptions: function sessionTypeOptions() {
      var _this = this;

      return this.schedule.types.map(function (t) {
        return {
          value: t.id,
          text: _this.localise(t.title)
        };
      });
    },
    trackOptions: function trackOptions() {
      var _this2 = this;

      return this.schedule.tracks.map(function (t) {
        return {
          value: t.id,
          text: _this2.localise(t.title)
        };
      });
    },
    themeOptions: function themeOptions() {
      var _this3 = this;

      return this.schedule.themes.map(function (t) {
        return {
          value: t.id,
          text: _this3.localise(t.title)
        };
      });
    },
    recordedOptions: function recordedOptions() {
      return [{
        value: true,
        text: this.$t('deconf.scheduleFilters.yes')
      }, {
        value: false,
        text: this.$t('deconf.scheduleFilters.no')
      }];
    },
    hasFilters: function hasFilters() {
      if (!this.filters) return false;
      return Boolean(this.filters.query) || this.filters.sessionType !== null || this.filters.track !== null || this.filters.theme !== null || this.filters.date !== null || this.filters.isRecorded !== null || this.filters.language !== null;
    },
    enabledFiltersSet: function enabledFiltersSet() {
      return new Set(this.enabledFilters);
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    this.showExtraFilters = this.showExtraFilters || this.hasFilters;
    this.queryHandler = debounce(QUERY_DEBOUNCE, function (value) {
      _this4.updateFilter('query', value);
    });
  },
  destroyed: function destroyed() {
    if (this.queryHandler) {
      this.queryHandler.cancel();
    }

    this.queryHandler = null;
  },
  methods: {
    updateFilter: function updateFilter(key, newValue) {
      // eslint-disable-next-line vue/no-mutating-props
      this.filters[key] = newValue;
      this.$emit('filter', this.filters);
    },
    updateDateFilter: function updateDateFilter(newValue) {
      this.updateFilter('date', newValue ? new Date(newValue) : null);
    },
    localise: function localise(object) {
      return localiseFromObject(this.$i18n.locale, object);
    },
    toggleFilters: function toggleFilters() {
      this.showExtraFilters = !this.showExtraFilters;
    },
    clearFilters: function clearFilters() {
      this.showExtraFilters = false;
      /* eslint-disable vue/no-mutating-props */

      this.filters.query = '';
      this.filters.sessionType = null;
      this.filters.track = null;
      this.filters.theme = null;
      this.filters.date = null;
      this.filters.isRecorded = null;
      this.filters.language = null;
      /* eslint-enable vue/no-mutating-props */

      this.$emit('filter', this.filters);
    },
    onQuery: function onQuery(e) {
      if (!this.queryHandler) return;
      this.queryHandler(e.target.value);
    },
    isEnabled: function isEnabled(filterName) {
      return this.enabledFiltersSet.has(filterName);
    }
  }
};

/* script */
var __vue_script__$m = script$m;
/* template */

var __vue_render__$m = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "scheduleFilters"
  }, [_c('div', {
    staticClass: "scheduleFilters-row"
  }, [_vm.isEnabled('query') ? _c('div', {
    staticClass: "inlineField"
  }, [_c('div', {
    staticClass: "button is-static"
  }, [_vm._v(" " + _vm._s(_vm.$t('deconf.scheduleFilters.query')) + " ")]), _c('input', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('deconf.scheduleFilters.query')
    },
    domProps: {
      "value": _vm.filters.query
    },
    on: {
      "input": _vm.onQuery
    }
  })]) : _vm._e(), !_vm.showExtraFilters ? _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary is-light",
    on: {
      "click": _vm.toggleFilters
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t('deconf.scheduleFilters.showFilters')) + " ")])])])]) : _vm._e(), _vm.hasFilters ? _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "button is-danger",
    on: {
      "click": _vm.clearFilters
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t('deconf.scheduleFilters.clearFilters')) + " ")])])])]) : _vm._e()]), _vm.showExtraFilters ? _c('div', {
    staticClass: "scheduleFilters-row"
  }, [_vm.isEnabled('date') && _vm.dateOptions.length > 0 ? _c('InlineFilter', {
    staticClass: "scheduleFilters-date",
    attrs: {
      "value": _vm.filters.date ? _vm.filters.date.toISOString() : null,
      "label": _vm.$t('deconf.scheduleFilters.dateFilter'),
      "off-label": _vm.$t('deconf.scheduleFilters.offLabel'),
      "options": _vm.dateOptions
    },
    on: {
      "input": function input(v) {
        return _vm.updateDateFilter(v);
      }
    }
  }) : _vm._e(), _vm.isEnabled('sessionType') && _vm.sessionTypeOptions.length > 0 ? _c('InlineFilter', {
    staticClass: "scheduleFilters-type",
    attrs: {
      "value": _vm.filters.sessionType,
      "label": _vm.$t('deconf.scheduleFilters.typeFilter'),
      "off-label": _vm.$t('deconf.scheduleFilters.offLabel'),
      "options": _vm.sessionTypeOptions
    },
    on: {
      "input": function input(v) {
        return _vm.updateFilter('sessionType', v);
      }
    }
  }) : _vm._e(), _vm.isEnabled('track') && _vm.trackOptions.length > 0 ? _c('InlineFilter', {
    staticClass: "scheduleFilters-track",
    attrs: {
      "value": _vm.filters.track,
      "label": _vm.$t('deconf.scheduleFilters.trackFilter'),
      "off-label": _vm.$t('deconf.scheduleFilters.offLabel'),
      "options": _vm.trackOptions
    },
    on: {
      "input": function input(v) {
        return _vm.updateFilter('track', v);
      }
    }
  }) : _vm._e(), _vm.isEnabled('theme') && _vm.themeOptions.length > 0 ? _c('InlineFilter', {
    staticClass: "scheduleFilters-theme",
    attrs: {
      "value": _vm.filters.theme,
      "label": _vm.$t('deconf.scheduleFilters.themeFilter'),
      "off-label": _vm.$t('deconf.scheduleFilters.offLabel'),
      "options": _vm.themeOptions
    },
    on: {
      "input": function input(v) {
        return _vm.updateFilter('theme', v);
      }
    }
  }) : _vm._e(), _vm.isEnabled('language') && _vm.languageOptions.length > 0 ? _c('InlineFilter', {
    staticClass: "scheduleFilters-language",
    attrs: {
      "value": _vm.filters.language,
      "label": _vm.$t('deconf.scheduleFilters.languageFilter'),
      "off-label": _vm.$t('deconf.scheduleFilters.offLabel'),
      "options": _vm.languageOptions
    },
    on: {
      "input": function input(v) {
        return _vm.updateFilter('language', v);
      }
    }
  }) : _vm._e(), _vm.isEnabled('isRecorded') ? _c('InlineFilter', {
    staticClass: "scheduleFilters-recorded",
    attrs: {
      "value": _vm.filters.isRecorded,
      "label": _vm.$t('deconf.scheduleFilters.recordedFilter'),
      "off-label": _vm.$t('deconf.scheduleFilters.offLabel'),
      "options": _vm.recordedOptions
    },
    on: {
      "input": function input(v) {
        return _vm.updateFilter('isRecorded', v);
      }
    }
  }) : _vm._e(), _vm.showExtraFilters ? _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary is-light",
    on: {
      "click": _vm.toggleFilters
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t('deconf.scheduleFilters.hideFilters')) + " ")])])])]) : _vm._e()], 1) : _vm._e()]);
};

var __vue_staticRenderFns__$m = [];
/* style */

var __vue_inject_styles__$m = undefined;
/* scoped */

var __vue_scope_id__$m = undefined;
/* module identifier */

var __vue_module_identifier__$m = undefined;
/* functional template */

var __vue_is_functional_template__$m = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$m = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$m,
  staticRenderFns: __vue_staticRenderFns__$m
}, __vue_inject_styles__$m, __vue_script__$m, __vue_scope_id__$m, __vue_is_functional_template__$m, __vue_module_identifier__$m, false, undefined, undefined, undefined);

//
// i18n
// - n/a
//
// icons
// - n/a
//
// sass
// - n/a
//
var script$l = {
  name: 'ScheduleHeader'
};

/* script */
var __vue_script__$l = script$l;
/* template */

var __vue_render__$l = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "scheduleHeader"
  }, [_c('h2', {
    staticClass: "scheduleHeader-title"
  }, [_vm._t("default")], 2)]);
};

var __vue_staticRenderFns__$l = [];
/* style */

var __vue_inject_styles__$l = undefined;
/* scoped */

var __vue_scope_id__$l = undefined;
/* module identifier */

var __vue_module_identifier__$l = undefined;
/* functional template */

var __vue_is_functional_template__$l = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$l = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$l,
  staticRenderFns: __vue_staticRenderFns__$l
}, __vue_inject_styles__$l, __vue_script__$l, __vue_scope_id__$l, __vue_is_functional_template__$l, __vue_module_identifier__$l, false, undefined, undefined, undefined);

// A heading that is sticky around a set of inner-content in it's slot
//
//
// i18n
// - n/a
//
// icons
// - n/a
//
// sass
// - $stickyHeading-top
// - $stickyHeading-left
// - $stickyHeading-right
// - $stickyHeading-z
//

var script$k = {
  name: 'StickyHeading',
  components: {
    ScheduleHeader: __vue_component__$l
  },
  props: {
    title: {
      type: String,
      required: true
    },
    titleClass: {
      type: String,
      default: 'is-primary'
    }
  }
};

/* script */
var __vue_script__$k = script$k;
/* template */

var __vue_render__$k = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "stickyHeading"
  }, [_c('div', {
    staticClass: "stickyHeading-header"
  }, [_c('ScheduleHeader', {
    class: _vm.titleClass
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")])], 1), _c('div', {
    staticClass: "stickyHeading-content"
  }, [_vm._t("default")], 2)]);
};

var __vue_staticRenderFns__$k = [];
/* style */

var __vue_inject_styles__$k = undefined;
/* scoped */

var __vue_scope_id__$k = undefined;
/* module identifier */

var __vue_module_identifier__$k = undefined;
/* functional template */

var __vue_is_functional_template__$k = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$k = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$k,
  staticRenderFns: __vue_staticRenderFns__$k
}, __vue_inject_styles__$k, __vue_script__$k, __vue_scope_id__$k, __vue_is_functional_template__$k, __vue_module_identifier__$k, false, undefined, undefined, undefined);

//
// i18n
// - n/a
//
// icons
// - n/a
//
// sass
// - $sessionTile-titleWeight
// - $sessionTile-titleSize
// - $sessionTile-titleColor
// - $sessionTile-descriptionColor
// - $sessionTile-textWidth
//
function mapById(records) {
  return new Map(records.map(function (r) {
    return [r.id, r];
  }));
}

function lookup(records, query) {
  return records.find(function (r) {
    return r.id === query;
  });
}

var script$j = {
  name: 'SessionTile',
  components: {
    SessionHeader: __vue_component__$X,
    SessionAttributes: __vue_component__$Y,
    SpeakerGrid: __vue_component__$I,
    AddToCalendar: __vue_component__$$,
    JoinSession: __vue_component__$Z
  },
  props: {
    slotState: {
      type: String,
      required: true
    },
    session: {
      type: Object,
      required: true
    },
    schedule: {
      type: Object,
      required: true
    },
    config: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    speakers: function speakers() {
      var map = mapById(this.schedule.speakers);
      return this.session.speakers.map(function (id) {
        return map.get(id);
      }).filter(function (s) {
        return Boolean(s);
      });
    },
    themes: function themes() {
      var map = mapById(this.schedule.themes);
      return this.session.themes.map(function (id) {
        return map.get(id);
      }).filter(function (t) {
        return Boolean(t);
      });
    },
    sessionType: function sessionType() {
      return lookup(this.schedule.types, this.session.type);
    },
    sessionSlot: function sessionSlot() {
      return lookup(this.schedule.slots, this.session.slot);
    },
    track: function track() {
      return lookup(this.schedule.tracks, this.session.track);
    },
    sessionRoute: function sessionRoute() {
      if (this.config.getSessionRoute) {
        return this.config.getSessionRoute(this.session);
      }

      return {
        name: Routes.Session,
        params: {
          sessionId: this.session.id
        }
      };
    },
    sessionSpeakers: function sessionSpeakers() {
      var _this = this;

      return this.session.speakers.map(function (id) {
        return _this.speakers.find(function (s) {
          return s.id === id;
        });
      }).filter(function (s) {
        return Boolean(s);
      });
    },
    localeTitle: function localeTitle() {
      return this.localise(this.session.title);
    },
    localeContent: function localeContent() {
      var content = this.localise(this.session.content);
      return content ? this.trim(stripMarkdown(content), 300) : null;
    },
    canAddToCalendar: function canAddToCalendar() {
      return ['soon', 'future'].includes(this.slotState);
    },
    canJoinSession: function canJoinSession() {
      return true;
    },
    headerAttributes: function headerAttributes() {
      var set = new Set(this.config.tileHeader);
      return {
        sessionType: set.has('type') ? this.sessionType : null,
        track: set.has('track') ? this.track : null,
        themes: set.has('themes') ? this.themes : null
      };
    },
    attributesAttributes: function attributesAttributes() {
      var set = new Set(this.config.tileAttributes);
      return {
        languages: set.has('languages') ? this.session.hostLanguages : null,
        isRecorded: set.has('recorded') ? this.session.isRecorded : null,
        track: set.has('track') ? this.track : null,
        themes: set.has('themes') ? this.themes : null,
        organisation: set.has('organisation') ? this.localise(this.session.hostOrganisation) : null
      };
    }
  },
  methods: {
    trim: function trim(value, length) {
      if (value.length < length) return value;
      return "".concat(value.substring(0, length), "\u2026");
    },
    localise: function localise(object) {
      var fallbacks = _toConsumableArray(this.session.hostLanguages);

      if (!fallbacks.includes('en')) fallbacks.push('en');
      return localiseFromObject(this.$i18n.locale, object, {
        fallbacks: fallbacks
      });
    }
  }
};

/* script */
var __vue_script__$j = script$j;
/* template */

var __vue_render__$j = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "sessionTile"
  }, [_c('div', {
    staticClass: "sessionTile-header"
  }, [_c('SessionHeader', _vm._b({}, 'SessionHeader', _vm.headerAttributes, false))], 1), _c('div', {
    staticClass: "sessionTile-info"
  }, [_c('h2', {
    staticClass: "sessionTile-title"
  }, [_vm.readonly ? [_vm._v(" " + _vm._s(_vm.localeTitle) + " ")] : [_c('router-link', {
    attrs: {
      "to": _vm.sessionRoute
    }
  }, [_vm._v(" " + _vm._s(_vm.localeTitle) + " ")])]], 2), _c('p', {
    staticClass: "sessionTile-description"
  }, [_vm._v(" " + _vm._s(_vm.localeContent) + " ")])]), _c('div', {
    staticClass: "sessionTile-attributes"
  }, [_c('SessionAttributes', _vm._b({}, 'SessionAttributes', _vm.attributesAttributes, false))], 1), _c('div', {
    staticClass: "sessionTile-speakers"
  }, [_c('SpeakerGrid', {
    attrs: {
      "speakers": _vm.sessionSpeakers
    }
  })], 1), !_vm.readonly ? _c('div', {
    staticClass: "sessionTile-actions"
  }, [_c('div', {
    staticClass: "buttons is-right"
  }, [_vm.canAddToCalendar ? [_c('AddToCalendar', {
    staticClass: "is-small is-link",
    attrs: {
      "session": _vm.session
    }
  })] : _vm._e(), _vm.canJoinSession ? [_c('JoinSession', {
    staticClass: "is-small",
    attrs: {
      "slot-state": _vm.slotState,
      "session-id": _vm.session.id
    }
  })] : _vm._e()], 2)]) : _vm._e()]);
};

var __vue_staticRenderFns__$j = [];
/* style */

var __vue_inject_styles__$j = undefined;
/* scoped */

var __vue_scope_id__$j = undefined;
/* module identifier */

var __vue_module_identifier__$j = undefined;
/* functional template */

var __vue_is_functional_template__$j = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$j = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$j,
  staticRenderFns: __vue_staticRenderFns__$j
}, __vue_inject_styles__$j, __vue_script__$j, __vue_scope_id__$j, __vue_is_functional_template__$j, __vue_module_identifier__$j, false, undefined, undefined, undefined);

//
// i18n
// - n/a
//
// icons
// - n/a
//
// sass
// - $toggleContents-background
// - $toggleContents-color
//
var script$i = {
  name: 'ToggleContents',
  data: function data() {
    return {
      showContents: false
    };
  },
  props: {
    title: {
      type: String,
      required: true
    },
    showButton: {
      type: String,
      required: true
    },
    hideButton: {
      type: String,
      required: true
    },
    forceOpen: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    toggleText: function toggleText() {
      return this.showContents ? this.hideButton : this.showButton;
    }
  },
  methods: {
    toggle: function toggle() {
      this.showContents = !this.showContents;
      this.$emit('toggle', this.showContents);
    }
  }
};

/* script */
var __vue_script__$i = script$i;
/* template */

var __vue_render__$i = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "toggleContents"
  }, [!_vm.forceOpen ? _c('div', {
    staticClass: "toggleContents-header"
  }, [_c('span', {
    staticClass: "toggleContents-title"
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")]), _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.toggle
    }
  }, [_vm._v(" " + _vm._s(_vm.toggleText) + " ")])]) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_vm.showContents || _vm.forceOpen ? _c('div', {
    staticClass: "toggleContents-contents"
  }, [_vm._t("default")], 2) : _vm._e()])], 1);
};

var __vue_staticRenderFns__$i = [];
/* style */

var __vue_inject_styles__$i = undefined;
/* scoped */

var __vue_scope_id__$i = undefined;
/* module identifier */

var __vue_module_identifier__$i = undefined;
/* functional template */

var __vue_is_functional_template__$i = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$i = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$i,
  staticRenderFns: __vue_staticRenderFns__$i
}, __vue_inject_styles__$i, __vue_script__$i, __vue_scope_id__$i, __vue_is_functional_template__$i, __vue_module_identifier__$i, false, undefined, undefined, undefined);

// i18n
// - deconf.scheduleBlock.workshopTitle - Heading for workshops
// - deconf.scheduleBlock.workshopDescription - Subtitle for workshops
// - deconf.scheduleBlock.workshops - Number of workshops (^c)
// - deconf.scheduleBlock.showWorkshops - Button to show workshops
// - deconf.scheduleBlock.hideWorkshops - Button to hide workshops
//
// icons
// - n/a
//
// sass
// - $scheduleBlock-background
//

var script$h = {
  name: 'ScheduleBlock',
  components: {
    TimeSlot: __vue_component__$F,
    SessionTile: __vue_component__$j,
    ToggleContents: __vue_component__$i
  },
  props: {
    currentDate: {
      type: Date,
      required: true
    },
    sessionSlot: {
      type: Object,
      required: true
    },
    sessions: {
      type: Array,
      required: true
    },
    showOtherSessions: {
      type: Boolean,
      default: false
    },
    schedule: {
      type: Object,
      required: true
    },
    config: {
      type: Object,
      required: true
    }
  },
  computed: {
    classes: function classes() {
      var isNow = this.currentDate.getTime() > this.sessionSlot.start.getTime() && this.currentDate.getTime() < this.sessionSlot.end.getTime();
      return isNow ? 'is-present' : '';
    },
    speakerMap: function speakerMap() {
      return new Map(this.schedule.speakers.map(function (s) {
        return [s.id, s];
      }));
    },
    sessionTypeMap: function sessionTypeMap() {
      return new Map(this.schedule.types.map(function (s) {
        return [s.id, s];
      }));
    },
    trackMap: function trackMap() {
      return new Map(this.schedule.tracks.map(function (t) {
        return [t.id, t];
      }));
    },
    themeMap: function themeMap() {
      return new Map(this.schedule.themes.map(function (t) {
        return [t.id, t];
      }));
    },
    plenaryTypes: function plenaryTypes() {
      return new Set(this.schedule.types.filter(function (t) {
        return t.layout === 'plenary';
      }).map(function (t) {
        return t.id;
      }));
    },
    plenarySessions: function plenarySessions() {
      var _this = this;

      return this.sessions.filter(function (s) {
        return _this.plenaryTypes.has(s.type);
      });
    },
    otherSessions: function otherSessions() {
      var _this2 = this;

      return this.sessions.filter(function (s) {
        return !_this2.plenaryTypes.has(s.type);
      });
    },
    slotState: function slotState() {
      return getSlotState(this.currentDate, this.sessionSlot.start, this.sessionSlot.end);
    },
    shouldOpenWorkshops: function shouldOpenWorkshops() {
      if (this.slotState === 'present') return true;
      return false;
    }
  },
  methods: {
    getSessionType: function getSessionType(session) {
      return this.sessionTypeMap.get(session.type);
    },
    getSessionSpeakers: function getSessionSpeakers(session) {
      var _this3 = this;

      return session.speakers.map(function (id) {
        return _this3.speakerMap.get(id);
      }).filter(function (s) {
        return Boolean(s);
      });
    },
    getSessionTrack: function getSessionTrack(session) {
      return this.trackMap.get(session.track);
    },
    getSessionThemes: function getSessionThemes(session) {
      var _this4 = this;

      return session.themes.map(function (t) {
        return _this4.themeMap.get(t);
      }).filter(function (t) {
        return Boolean(t);
      });
    }
  }
};

/* script */
var __vue_script__$h = script$h;
/* template */

var __vue_render__$h = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "scheduleBlock",
    class: _vm.classes
  }, [_c('div', {
    staticClass: "scheduleBlock-slotColumn"
  }, [_c('div', {
    staticClass: "scheduleBlock-slot"
  }, [_c('TimeSlot', {
    attrs: {
      "slot-state": _vm.slotState,
      "start-date": _vm.sessionSlot.start,
      "end-date": _vm.sessionSlot.end
    }
  })], 1)]), _c('div', {
    staticClass: "scheduleBlock-sessions"
  }, [_vm._l(_vm.plenarySessions, function (session) {
    return _c('div', {
      key: session.id,
      staticClass: "scheduleBlock-session"
    }, [_c('SessionTile', {
      attrs: {
        "slot-state": _vm.slotState,
        "session": session,
        "schedule": _vm.schedule,
        "config": _vm.config
      }
    })], 1);
  }), _vm.otherSessions.length > 0 ? _c('div', {
    staticClass: "scheduleBlock-session"
  }, [_c('div', {
    staticClass: "scheduleBlock-workshopInfo"
  }, [_c('h3', {
    staticClass: "scheduleBlock-workshopTitle"
  }, [_vm._v(" " + _vm._s(_vm.$t('deconf.scheduleBlock.workshopTitle')) + " ")]), _c('p', {
    staticClass: "scheduleBlock-workshopDescription"
  }, [_vm._v(" " + _vm._s(_vm.$t('deconf.scheduleBlock.workshopDescription')) + " ")])]), _c('ToggleContents', {
    attrs: {
      "title": _vm.$tc('deconf.scheduleBlock.workshops', _vm.otherSessions.length),
      "show-button": _vm.$t('deconf.scheduleBlock.showWorkshops'),
      "hide-button": _vm.$t('deconf.scheduleBlock.hideWorkshops'),
      "force-open": _vm.showOtherSessions || _vm.shouldOpenWorkshops
    }
  }, _vm._l(_vm.otherSessions, function (session) {
    return _c('div', {
      key: session.id,
      staticClass: "scheduleBlock-session"
    }, [_c('SessionTile', {
      attrs: {
        "slot-state": _vm.slotState,
        "session": session,
        "schedule": _vm.schedule,
        "config": _vm.config
      }
    })], 1);
  }), 0)], 1) : _vm._e()], 2)]);
};

var __vue_staticRenderFns__$h = [];
/* style */

var __vue_inject_styles__$h = undefined;
/* scoped */

var __vue_scope_id__$h = undefined;
/* module identifier */

var __vue_module_identifier__$h = undefined;
/* functional template */

var __vue_is_functional_template__$h = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$h = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$h,
  staticRenderFns: __vue_staticRenderFns__$h
}, __vue_inject_styles__$h, __vue_script__$h, __vue_scope_id__$h, __vue_is_functional_template__$h, __vue_module_identifier__$h, false, undefined, undefined, undefined);

// i18n
// - n/a
//
// icons
// - fas search
//
// sass
// - n/a
//

var script$g = {
  name: 'NoResults',
  components: {
    FontAwesomeIcon: FontAwesomeIcon
  }
};

/* script */
var __vue_script__$g = script$g;
/* template */

var __vue_render__$g = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "noResults"
  }, [_c('section', {
    staticClass: "section is-medium"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "notification is-size-4 has-text-weight-bold has-text-centered"
  }, [_c('span', {
    staticClass: "icon-text"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('FontAwesomeIcon', {
    attrs: {
      "icon": ['fas', 'search']
    }
  })], 1), _c('span', [_vm._t("default")], 2)])])])])]);
};

var __vue_staticRenderFns__$g = [];
/* style */

var __vue_inject_styles__$g = undefined;
/* scoped */

var __vue_scope_id__$g = undefined;
/* module identifier */

var __vue_module_identifier__$g = undefined;
/* functional template */

var __vue_is_functional_template__$g = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$g = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$g,
  staticRenderFns: __vue_staticRenderFns__$g
}, __vue_inject_styles__$g, __vue_script__$g, __vue_scope_id__$g, __vue_is_functional_template__$g, __vue_module_identifier__$g, false, undefined, undefined, undefined);

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var script$f = {
  name: 'ScheduleView',
  components: {
    ScheduleFilters: __vue_component__$m,
    StickyHeading: __vue_component__$k,
    ScheduleBlock: __vue_component__$h,
    NoResults: __vue_component__$g,
    SegmentControl: __vue_component__$u
  },
  props: {
    schedule: {
      type: Object,
      required: true
    },
    sessions: {
      type: Array,
      required: true
    },
    filtersKey: {
      type: String,
      required: true
    },
    enabledFilters: {
      type: Array,
      default: undefined
    },
    userSessions: {
      type: Array,
      required: true
    },
    config: {
      type: Object,
      required: true
    },
    scheduleDate: {
      type: Date,
      required: true
    },
    isDuringConference: {
      type: Boolean,
      required: true
    },
    languageOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    urlFilters: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      showPastSessions: false,
      filters: this.urlFilters || loadScheduleFilters(this.filtersKey)
    };
  },
  computed: _objectSpread$1(_objectSpread$1({
    localePastAction: function localePastAction() {
      return this.showPastSessions ? this.$t('deconf.schedule.hidePast') : this.$t('deconf.schedule.showPast');
    }
  }, scheduleComputed()), {}, {
    showOtherSessions: function showOtherSessions() {
      return this.filteredSessions.length < 50;
    },
    viewModeOptions: function viewModeOptions() {
      return [{
        value: 'all',
        text: this.$t('deconf.schedule.allSessions')
      }, {
        value: 'user',
        text: this.$t('deconf.schedule.userSessions')
      }];
    }
  }),
  methods: {
    onFilter: function onFilter(filters) {
      var _this = this;

      this.filters = filters;
      this.$emit('filter', filters);
      window.setTimeout(function () {
        var encoded = encodeScheduleFilters(filters);
        localStorage.setItem(_this.filtersKey, JSON.stringify(encoded));
      });
    },
    togglePastSessions: function togglePastSessions() {
      this.showPastSessions = !this.showPastSessions;
    }
  }
};

/* script */
var __vue_script__$f = script$f;
/* template */

var __vue_render__$f = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.schedule ? _c('div', {
    staticClass: "scheduleView"
  }, [_c('div', {
    staticClass: "scheduleView-header"
  }, [_c('div', {
    staticClass: "scheduleView-headerSplit"
  }, [_c('h1', {
    staticClass: "scheduleView-title"
  }, [_vm._t("title", function () {
    return [_vm._v(" " + _vm._s(_vm.$t('deconf.schedule.title')) + " ")];
  })], 2), _c('div', {
    staticClass: "scheduleView-viewControl"
  }, [_c('SegmentControl', {
    attrs: {
      "options": _vm.viewModeOptions
    },
    model: {
      value: _vm.filters.viewMode,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "viewMode", $$v);
      },
      expression: "filters.viewMode"
    }
  })], 1)]), _c('p', {
    staticClass: "scheduleView-content"
  }, [_vm._t("infoText", function () {
    return [_vm._v(" " + _vm._s(_vm.$t('deconf.schedule.infoText')) + " ")];
  })], 2), _c('ScheduleFilters', {
    attrs: {
      "schedule": _vm.schedule,
      "filters": _vm.filters,
      "enabled-filters": _vm.enabledFilters,
      "language-options": _vm.languageOptions
    },
    on: {
      "filter": _vm.onFilter
    }
  })], 1), _c('div', {
    staticClass: "scheduleView-blocks"
  }, [_vm.previousDays && _vm.previousDays.length > 0 ? [_vm.showPastSessions ? _vm._l(_vm.previousDays, function (day) {
    return _c('div', {
      key: day.title + '-past',
      staticClass: "scheduleView-day is-passed"
    }, [_c('StickyHeading', {
      attrs: {
        "title": day.title,
        "title-class": "is-dark"
      }
    }, _vm._l(day.groups, function (group) {
      return _c('ScheduleBlock', {
        key: group.slot.id,
        attrs: {
          "current-date": _vm.scheduleDate,
          "session-slot": group.slot,
          "sessions": group.sessions,
          "schedule": _vm.schedule,
          "config": _vm.config,
          "show-other-sessions": _vm.showOtherSessions
        }
      });
    }), 1)], 1);
  }) : _vm._e(), _c('div', {
    staticClass: "scheduleView-toggleHistory"
  }, [_c('div', {
    staticClass: "buttons is-centered"
  }, [_c('button', {
    staticClass: "button is-text",
    on: {
      "click": _vm.togglePastSessions
    }
  }, [_vm._v(" " + _vm._s(_vm.localePastAction) + " ")])])])] : _vm._e(), _vm.filteredSessions.length === 0 ? _c('NoResults', [_vm._t("noResults", function () {
    return [_vm._v(" " + _vm._s(_vm.$t('deconf.schedule.noResults')) + " ")];
  })], 2) : _vm._l(_vm.upcomingDays, function (day) {
    return _c('div', {
      key: day.title,
      staticClass: "scheduleView-day"
    }, [_c('StickyHeading', {
      attrs: {
        "title": day.title
      }
    }, _vm._l(day.groups, function (group) {
      return _c('ScheduleBlock', {
        key: group.slot.id,
        attrs: {
          "current-date": _vm.scheduleDate,
          "session-slot": group.slot,
          "sessions": group.sessions,
          "schedule": _vm.schedule,
          "config": _vm.config,
          "show-other-sessions": _vm.showOtherSessions
        }
      });
    }), 1)], 1);
  })], 2)]) : _vm._e();
};

var __vue_staticRenderFns__$f = [];
/* style */

var __vue_inject_styles__$f = undefined;
/* scoped */

var __vue_scope_id__$f = undefined;
/* module identifier */

var __vue_module_identifier__$f = undefined;
/* functional template */

var __vue_is_functional_template__$f = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$f,
  staticRenderFns: __vue_staticRenderFns__$f
}, __vue_inject_styles__$f, __vue_script__$f, __vue_scope_id__$f, __vue_is_functional_template__$f, __vue_module_identifier__$f, false, undefined, undefined, undefined);

var script$e = {
  name: 'FilteredScheduleView',
  components: {
    ScheduleView: __vue_component__$f
  },
  props: {
    schedule: {
      type: Object,
      required: true
    },
    userSessions: {
      type: Array,
      required: false
    },
    options: {
      type: Object,
      required: true
    },
    scheduleDate: {
      type: Date,
      required: true
    },
    routeQuery: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      urlFilters: decodeUrlScheduleFilters(this.routeQuery)
    };
  },
  computed: {
    filteredSessions: function filteredSessions() {
      var _this = this;

      return this.schedule.sessions.filter(function (s) {
        return s.slot && _this.options.predicate(s);
      });
    },
    isDuringConference: function isDuringConference() {
      var range = getScheduleStartAndEnd(this.filteredSessions, this.schedule);
      if (!range) return false;
      return isInRange(range, this.scheduleDate);
    },
    filteredSchedule: function filteredSchedule() {
      return filterScheduleFromSessions(this.schedule, this.filteredSessions);
    }
  },
  methods: {
    onFilter: function onFilter(filters) {
      this.$emit('filter', encodeScheduleFilters(filters));
    }
  }
};

/* script */
var __vue_script__$e = script$e;
/* template */

var __vue_render__$e = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('ScheduleView', {
    attrs: {
      "schedule": _vm.filteredSchedule,
      "sessions": _vm.filteredSessions,
      "user-sessions": _vm.userSessions || [],
      "schedule-date": _vm.scheduleDate,
      "url-filters": _vm.urlFilters,
      "filters-key": _vm.options.filtersKey,
      "config": _vm.options.scheduleConfig,
      "enabled-filters": _vm.options.enabledFilters,
      "is-during-conference": _vm.isDuringConference,
      "language-options": _vm.options.languages
    },
    on: {
      "filter": _vm.onFilter
    }
  }, [_vm._t("title", null, {
    "slot": "title"
  }), _vm._t("noResults", null, {
    "slot": "noResults"
  }), _vm._t("infoText", null, {
    "slot": "infoText"
  })], 2);
};

var __vue_staticRenderFns__$e = [];
/* style */

var __vue_inject_styles__$e = undefined;
/* scoped */

var __vue_scope_id__$e = undefined;
/* module identifier */

var __vue_module_identifier__$e = undefined;
/* functional template */

var __vue_is_functional_template__$e = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$e = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$e,
  staticRenderFns: __vue_staticRenderFns__$e
}, __vue_inject_styles__$e, __vue_script__$e, __vue_scope_id__$e, __vue_is_functional_template__$e, __vue_module_identifier__$e, false, undefined, undefined, undefined);

//
// An abstract pinboard-style grid of items
//
//
// i18n
// - n/a
//
// icons
// - n/a
//
// sass
// - $sessionBoard-columns
// - $sessionBoard-spacing
// - $sessionBoard-padding
// - $sessionBoard-background
//
var script$d = {
  name: 'SessionBoard'
};

/* script */
var __vue_script__$d = script$d;
/* template */

var __vue_render__$d = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "sessionBoard"
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__$d = [];
/* style */

var __vue_inject_styles__$d = undefined;
/* scoped */

var __vue_scope_id__$d = undefined;
/* module identifier */

var __vue_module_identifier__$d = undefined;
/* functional template */

var __vue_is_functional_template__$d = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$d,
  staticRenderFns: __vue_staticRenderFns__$d
}, __vue_inject_styles__$d, __vue_script__$d, __vue_scope_id__$d, __vue_is_functional_template__$d, __vue_module_identifier__$d, false, undefined, undefined, undefined);

var script$c = {
  name: 'WhatsOnView',
  components: {
    ScheduleFilters: __vue_component__$m,
    SessionTile: __vue_component__$j,
    SessionBoard: __vue_component__$d,
    NoResults: __vue_component__$g
  },
  props: {
    schedule: {
      type: Object,
      required: true
    },
    sessions: {
      type: Array,
      required: true
    },
    filtersKey: {
      type: String,
      required: true
    },
    enabledFilters: {
      type: Array,
      default: undefined
    },
    config: {
      type: Object,
      required: true
    },
    slotState: {
      type: String,
      required: true
    },
    languageOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    urlFilters: {
      type: Object,
      default: null
    },
    readonly: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      filters: this.urlFilters || loadScheduleFilters(this.filtersKey)
    };
  },
  computed: {
    filteredSessions: function filteredSessions() {
      var predicate = createFilterPredicate(this.$i18n.locale, this.filters, this.schedule);
      if (!predicate) return this.sessions;
      return this.sessions.filter(function (s) {
        return predicate(s);
      });
    }
  },
  methods: {
    onFilter: function onFilter(filters) {
      var _this = this;

      this.filters = filters;
      this.$emit('filter', filters);
      window.setTimeout(function () {
        var encoded = encodeScheduleFilters(filters);
        localStorage.setItem(_this.filtersKey, JSON.stringify(encoded));
      });
    }
  }
};

/* script */
var __vue_script__$c = script$c;
/* template */

var __vue_render__$c = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "whatsOnView"
  }, [_c('div', {
    staticClass: "whatsOnView-header"
  }, [_c('h1', {
    staticClass: "whatsOnView-title"
  }, [_vm._t("title", function () {
    return [_vm._v(" " + _vm._s(_vm.$t('deconf.whatsOn.title')) + " ")];
  })], 2), _c('div', {
    staticClass: "whatsOnView-content"
  }, [_vm._t("info", function () {
    return [_c('p', [_vm._v(_vm._s(_vm.$t('deconf.whatsOn.infoText')))])];
  })], 2), _c('ScheduleFilters', {
    attrs: {
      "schedule": _vm.schedule,
      "filters": _vm.filters,
      "enabled-filters": _vm.enabledFilters,
      "language-options": _vm.languageOptions
    },
    on: {
      "filter": _vm.onFilter
    }
  })], 1), _c('div', {
    staticClass: "whatsOnView-sessions"
  }, [_vm.filteredSessions.length === 0 ? _c('NoResults', [_vm._t("noResults", function () {
    return [_vm._v(" " + _vm._s(_vm.$t('deconf.whatsOn.noResults')) + " ")];
  })], 2) : _vm._e(), _c('SessionBoard', _vm._l(_vm.filteredSessions, function (session) {
    return _c('SessionTile', {
      key: session.id,
      attrs: {
        "slot-state": _vm.slotState,
        "session": session,
        "schedule": _vm.schedule,
        "config": _vm.config,
        "readonly": _vm.readonly
      }
    });
  }), 1)], 1)]);
};

var __vue_staticRenderFns__$c = [];
/* style */

var __vue_inject_styles__$c = undefined;
/* scoped */

var __vue_scope_id__$c = undefined;
/* module identifier */

var __vue_module_identifier__$c = undefined;
/* functional template */

var __vue_is_functional_template__$c = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$c = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c,
  staticRenderFns: __vue_staticRenderFns__$c
}, __vue_inject_styles__$c, __vue_script__$c, __vue_scope_id__$c, __vue_is_functional_template__$c, __vue_module_identifier__$c, false, undefined, undefined, undefined);

//
// i18n
// - deconf.attendanceSection.loading - Message when attendance is being loaded
// - deconf.attendanceSection.processing - Message when attendance is being changed
// - deconf.attendanceSection.registered - Message when registered for a session
// - deconf.attendanceSection.full - Message when a session is full
// - deconf.attendanceSection.spacesLeft - How many seats are available ^2
// - deconf.attendanceSection.registerButton - Action to take a seat
// - deconf.attendanceSection.unregisterButton - Action to release a seat
//
// icons
// - fas times
// - fas user-plus
//
// sass
// - n/a
//
var script$b = {
  name: 'AttendanceSection',
  components: {
    FontAwesomeIcon: FontAwesomeIcon
  },
  props: {
    session: {
      type: Object,
      required: true
    },
    sessionCap: {
      type: Number,
      required: true
    },
    attendance: {
      type: Object,
      default: null
    },
    isProcessing: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isRegistered: function isRegistered() {
      if (!this.attendance) return false;
      return this.attendance.isAttending;
    },
    isFull: function isFull() {
      if (!this.attendance) return false;
      return this.attendance.sessionCount >= this.sessionCap;
    },
    isInactive: function isInactive() {
      return this.isProcessing || this.attendance === null;
    },
    buttonClasses: function buttonClasses() {
      if (this.isInactive) return 'is-loading';
      if (this.isRegistered) return 'is-danger is-outlined';
      return 'is-primary';
    },
    disabled: function disabled() {
      return this.isInactive || this.isFull && !this.isRegistered;
    },
    icon: function icon() {
      return this.isRegistered ? ['fas', 'times'] : ['fas', 'user-plus'];
    },
    localeMessage: function localeMessage() {
      if (!this.attendance) return this.$t('deconf.attendanceSection.loading');

      if (this.isInactive) {
        return this.$t('deconf.attendanceSection.processing');
      }

      if (this.isRegistered) {
        return this.$t('deconf.attendanceSection.registered');
      }

      if (this.isFull) {
        return this.$t('deconf.attendanceSection.full');
      }

      var spacesLeft = this.sessionCap - this.attendance.sessionCount;
      return this.$t('deconf.attendanceSection.spacesLeft', [spacesLeft, this.sessionCap]);
    },
    localeAction: function localeAction() {
      return this.isRegistered ? this.$t('deconf.attendanceSection.unregisterButton') : this.$t('deconf.attendanceSection.registerButton');
    }
  },
  methods: {
    register: function register() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.disabled) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _this.$emit(_this.isRegistered ? 'unattend' : 'attend');

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};

/* script */
var __vue_script__$b = script$b;
/* template */

var __vue_render__$b = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "attendanceSection"
  }, [_c('p', {
    staticClass: "attendanceSection-message"
  }, [_vm._v(" " + _vm._s(_vm.localeMessage) + " ")]), _c('button', {
    staticClass: "attendanceSection-button button",
    class: _vm.buttonClasses,
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.register
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('FontAwesomeIcon', {
    attrs: {
      "icon": _vm.icon
    }
  })], 1), _c('span', [_vm._v(" " + _vm._s(_vm.localeAction) + " ")])])]);
};

var __vue_staticRenderFns__$b = [];
/* style */

var __vue_inject_styles__$b = undefined;
/* scoped */

var __vue_scope_id__$b = undefined;
/* module identifier */

var __vue_module_identifier__$b = undefined;
/* functional template */

var __vue_is_functional_template__$b = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b,
  staticRenderFns: __vue_staticRenderFns__$b
}, __vue_inject_styles__$b, __vue_script__$b, __vue_scope_id__$b, __vue_is_functional_template__$b, __vue_module_identifier__$b, false, undefined, undefined, undefined);

// i18n
// - deconf.general.hours
// - deconf.general.minutes
// - deconf.general.seconds
//
// icons
// - n/a
//
// sass
// - $countdown-background
// - $countdown-color
//

var script$a = {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Countdown',
  props: {
    currentDate: {
      type: Date,
      required: true
    },
    targetDate: {
      type: Date,
      required: true
    }
  },
  computed: {
    remaining: function remaining() {
      return getCountdown(this.currentDate, this.targetDate);
    },
    hoursRemaining: function hoursRemaining() {
      return this.remaining.hours;
    },
    minutesRemaining: function minutesRemaining() {
      return this.remaining.minutes;
    },
    secondsRemaining: function secondsRemaining() {
      return this.remaining.seconds;
    }
  }
};

/* script */
var __vue_script__$a = script$a;
/* template */

var __vue_render__$a = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "countdown"
  }, [_c('div', {
    staticClass: "countdown-component"
  }, [_c('div', {
    staticClass: "countdown-number"
  }, [_vm._v(_vm._s(_vm.hoursRemaining))]), _c('div', {
    staticClass: "countdown-unit"
  }, [_vm._v(" " + _vm._s(_vm.$tc('deconf.general.hours', _vm.hoursRemaining)) + " ")])]), _c('div', {
    staticClass: "countdown-component"
  }, [_c('div', {
    staticClass: "countdown-number"
  }, [_vm._v(_vm._s(_vm.minutesRemaining))]), _c('div', {
    staticClass: "countdown-unit"
  }, [_vm._v(" " + _vm._s(_vm.$tc('deconf.general.minutes', _vm.minutesRemaining)) + " ")])]), _c('div', {
    staticClass: "countdown-component"
  }, [_c('div', {
    staticClass: "countdown-number"
  }, [_vm._v(_vm._s(_vm.secondsRemaining))]), _c('div', {
    staticClass: "countdown-unit"
  }, [_vm._v(" " + _vm._s(_vm.$tc('deconf.general.seconds', _vm.secondsRemaining)) + " ")])])]);
};

var __vue_staticRenderFns__$a = [];
/* style */

var __vue_inject_styles__$a = undefined;
/* scoped */

var __vue_scope_id__$a = undefined;
/* module identifier */

var __vue_module_identifier__$a = undefined;
/* functional template */

var __vue_is_functional_template__$a = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a,
  staticRenderFns: __vue_staticRenderFns__$a
}, __vue_inject_styles__$a, __vue_script__$a, __vue_scope_id__$a, __vue_is_functional_template__$a, __vue_module_identifier__$a, false, undefined, undefined, undefined);

//
// i18n
// - n/a
//
// icons
// - n/a
//
// sass
// - $iframeEmbed-ratio
// - $iframeEmbed-background
//
var script$9 = {
  name: 'IframeEmbed',
  props: {
    src: {
      type: String,
      required: true
    },
    allow: {
      type: String,
      default: ''
    }
  }
};

/* script */
var __vue_script__$9 = script$9;
/* template */

var __vue_render__$9 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "iframeEmbed"
  }, [_c('iframe', {
    staticClass: "iframeEmbed-iframe",
    attrs: {
      "width": "100%",
      "height": "100%",
      "src": _vm.src,
      "frameborder": "0",
      "allow": _vm.allow,
      "allowfullscreen": ""
    }
  })]);
};

var __vue_staticRenderFns__$9 = [];
/* style */

var __vue_inject_styles__$9 = undefined;
/* scoped */

var __vue_scope_id__$9 = undefined;
/* module identifier */

var __vue_module_identifier__$9 = undefined;
/* functional template */

var __vue_is_functional_template__$9 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$9 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9,
  staticRenderFns: __vue_staticRenderFns__$9
}, __vue_inject_styles__$9, __vue_script__$9, __vue_scope_id__$9, __vue_is_functional_template__$9, __vue_module_identifier__$9, false, undefined, undefined, undefined);

//
// i18n
// - deconf.interestSection.message
// - deconf.interestSection.unregisterButton
// - deconf.interestSection.registerButton
//
// icons
// - fas times
// - fas user-plus
//
// sass
// - n/a
//
var script$8 = Vue.extend({
  name: 'InterestSection',
  components: {
    FontAwesomeIcon: FontAwesomeIcon
  },
  props: {
    attendance: {
      type: Object,
      default: null
    },
    isProcessing: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isRegistered: function isRegistered() {
      if (!this.attendance) return false;
      return this.attendance.isAttending;
    },
    buttonClasses: function buttonClasses() {
      if (this.isProcessing) return 'is-loading';
      if (this.isRegistered) return 'is-danger is-outlined';
      return 'is-primary';
    },
    disabled: function disabled() {
      return this.isProcessing;
    }
  },
  methods: {
    register: function register() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$emit(_this.isRegistered ? 'unattend' : 'attend');

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
});

/* script */
var __vue_script__$8 = script$8;
/* template */

var __vue_render__$8 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "interestSection"
  }, [_c('p', {
    staticClass: "interestSection-message"
  }, [_vm._v(" " + _vm._s(_vm.$t('deconf.interestSection.message')) + " ")]), _vm.isRegistered ? _c('button', {
    staticClass: "button interestSection-button",
    class: _vm.buttonClasses,
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.register
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('FontAwesomeIcon', {
    attrs: {
      "icon": ['fas', 'times']
    }
  })], 1), _c('span', [_vm._v(" " + _vm._s(_vm.$t('deconf.interestSection.unregisterButton')) + " ")])]) : _c('button', {
    staticClass: "button interestSection-button",
    class: _vm.buttonClasses,
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.register
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('FontAwesomeIcon', {
    attrs: {
      "icon": ['fas', 'user-plus']
    }
  })], 1), _c('span', [_vm._v(" " + _vm._s(_vm.$t('deconf.interestSection.registerButton')) + " ")])])]);
};

var __vue_staticRenderFns__$8 = [];
/* style */

var __vue_inject_styles__$8 = undefined;
/* scoped */

var __vue_scope_id__$8 = undefined;
/* module identifier */

var __vue_module_identifier__$8 = undefined;
/* functional template */

var __vue_is_functional_template__$8 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$8 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8,
  staticRenderFns: __vue_staticRenderFns__$8
}, __vue_inject_styles__$8, __vue_script__$8, __vue_scope_id__$8, __vue_is_functional_template__$8, __vue_module_identifier__$8, false, undefined, undefined, undefined);

// i18n
// - deconf.languageWarning.message - The warning when a session is in a different language (^1)
//
// icons
// - fas globe
//
// sass
// - n/a
//

var script$7 = {
  name: 'LanguageWarning',
  components: {
    FontAwesomeIcon: FontAwesomeIcon
  },
  data: function data() {
    return {
      isDismissed: false
    };
  },
  props: {
    availableLanguages: {
      type: Array,
      required: true
    }
  },
  computed: {
    languages: function languages() {
      return this.availableLanguages.join('/').toUpperCase();
    }
  },
  methods: {
    dismiss: function dismiss() {
      this.isDismissed = true;
    }
  }
};

/* script */
var __vue_script__$7 = script$7;
/* template */

var __vue_render__$7 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return !_vm.isDismissed ? _c('div', {
    staticClass: "languageWarning"
  }, [_c('div', {
    staticClass: "notification is-warning"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": _vm.dismiss
    }
  }), _c('span', {
    staticClass: "languageWarning-text"
  }, [_c('div', {
    staticClass: "icon-text"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('FontAwesomeIcon', {
    attrs: {
      "icon": ['fas', 'globe']
    }
  })], 1), _c('span', [_vm._v(" " + _vm._s(_vm.$t('deconf.languageWarning.message', [_vm.languages])) + " ")])])])])]) : _vm._e();
};

var __vue_staticRenderFns__$7 = [];
/* style */

var __vue_inject_styles__$7 = undefined;
/* scoped */

var __vue_scope_id__$7 = undefined;
/* module identifier */

var __vue_module_identifier__$7 = undefined;
/* functional template */

var __vue_is_functional_template__$7 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$7 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7,
  staticRenderFns: __vue_staticRenderFns__$7
}, __vue_inject_styles__$7, __vue_script__$7, __vue_scope_id__$7, __vue_is_functional_template__$7, __vue_module_identifier__$7, false, undefined, undefined, undefined);

// i18n
// - deconf.sessionEmbed.noEmbed - The warning when no embedable option is available
// - deconf.sessionEmbed.openTeams - Button to open a teams link
// - deconf.sessionEmbed.openZoom - Button to open a zoom link
// - deconf.sessionEmbed.openZoomRegister - Button to open a zoom registration
// - deconf.sessionEmbed.openGoogleMeet - Button to open a Google Meet event
// - deconf.sessionEmbed.openHubs - Button to open a Mozilla Hubs link
// - deconf.sessionEmbed.openSpatial - Button to open a Spatial Chat link
//
// icons
// - fas video
//
// sass
// - n/a
//

var script$6 = {
  name: 'PrimaryEmbed',
  components: {
    IframeEmbed: __vue_component__$9,
    FontAwesomeIcon: FontAwesomeIcon
  },
  props: {
    link: {
      type: String,
      required: true
    }
  },
  computed: {
    parsed: function parsed() {
      return parsePrimaryLink(this.link);
    }
  },
  methods: {
    onClick: function onClick() {
      this.$emit('click');
    },
    youtubeVideoLink: function youtubeVideoLink(data) {
      return "https://www.youtube-nocookie.com/embed/".concat(data);
    },
    youtubeChannelLink: function youtubeChannelLink(data) {
      return "https://www.youtube-nocookie.com/embed/live_stream?channel=".concat(data);
    },
    vimeoVideoLink: function vimeoVideoLink(data) {
      return "https://player.vimeo.com/video/".concat(data);
    },
    vimeoEventLink: function vimeoEventLink(data) {
      return "https://vimeo.com/event/".concat(data, "/embed");
    },
    panoptoVideoLink: function panoptoVideoLink(data) {
      return data;
    },
    twitchVideoLink: function twitchVideoLink(data) {
      return "https://player.twitch.tv/?channel=".concat(data, "&parent=").concat(location.hostname);
    }
  }
};

/* script */
var __vue_script__$6 = script$6;
/* template */

var __vue_render__$6 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "primaryEmbed"
  }, [!_vm.parsed ? [_c('div', {
    staticClass: "notification is-warning"
  }, [_vm._v(" " + _vm._s(_vm.$t('deconf.sessionEmbed.noEmbed')) + " ")])] : _vm.parsed.kind === 'youtube-video' ? _c('div', {
    staticClass: "primaryEmbed-video"
  }, [_c('IframeEmbed', {
    attrs: {
      "src": _vm.youtubeVideoLink(_vm.parsed.data),
      "allow": "autoplay; encrypted-media; picture-in-picture"
    }
  })], 1) : _vm.parsed.kind === 'youtube-channel' ? _c('div', {
    staticClass: "primaryEmbed-video"
  }, [_c('IframeEmbed', {
    attrs: {
      "src": _vm.youtubeChannelLink(_vm.parsed.data),
      "allow": "autoplay; encrypted-media; picture-in-picture"
    }
  })], 1) : _vm.parsed.kind === 'vimeo' ? _c('div', {
    staticClass: "primaryEmbed-video"
  }, [_c('IframeEmbed', {
    attrs: {
      "src": _vm.vimeoVideoLink(_vm.parsed.data),
      "allow": "autoplay"
    }
  })], 1) : _vm.parsed.kind === 'vimeo-event' ? _c('div', {
    staticClass: "primaryEmbed-video"
  }, [_c('IframeEmbed', {
    attrs: {
      "src": _vm.vimeoEventLink(_vm.parsed.data),
      "allow": "autoplay"
    }
  })], 1) : _vm.parsed.kind === 'panopto' ? _c('div', {
    staticClass: "primaryEmbed-video"
  }, [_c('IframeEmbed', {
    attrs: {
      "src": _vm.panoptoVideoLink(_vm.parsed.data),
      "allow": "autoplay"
    }
  })], 1) : _vm.parsed.kind === 'twitch' ? _c('div', {
    staticClass: "primaryEmbed-video"
  }, [_c('IframeEmbed', {
    attrs: {
      "src": _vm.twitchVideoLink(_vm.parsed.data),
      "allow": "autoplay"
    }
  })], 1) : _vm.parsed.kind === 'anchor-fm-embed' ? _c('div', {
    staticClass: "primaryEmbed-video"
  }, [_c('iframe', {
    attrs: {
      "src": _vm.parsed.data,
      "height": "98px",
      "width": "400px",
      "frameborder": "0",
      "scrolling": "no"
    }
  })]) : _vm.parsed.kind === 'cinnamon-video' ? _c('div', {
    staticClass: "primaryEmbed-video is-cinnamonVideo"
  }, [_c('iframe', {
    attrs: {
      "width": "640",
      "height": "360",
      "src": "https://cinnamon.video/embed?v=" + _vm.parsed.data,
      "frameborder": "0",
      "allow": "monetization; accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
      "allowfullscreen": ""
    }
  })]) : _vm.parsed.kind === 'teams' ? _c('div', {
    staticClass: "primaryEmbed-link is-teams"
  }, [_c('a', {
    staticClass: "button is-medium",
    attrs: {
      "href": _vm.parsed.data,
      "target": "_blank",
      "rel": "noopener"
    },
    on: {
      "click": _vm.onClick
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('FontAwesomeIcon', {
    attrs: {
      "icon": ['fas', 'video']
    }
  })], 1), _c('span', [_vm._v(_vm._s(_vm.$t('deconf.sessionEmbed.openTeams')))])])]) : _vm.parsed.kind === 'zoom' ? _c('div', {
    staticClass: "primaryEmbed-link is-zoom"
  }, [_c('a', {
    staticClass: "button is-medium",
    attrs: {
      "href": _vm.parsed.data,
      "target": "_blank",
      "rel": "noopener"
    },
    on: {
      "click": _vm.onClick
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('FontAwesomeIcon', {
    attrs: {
      "icon": ['fas', 'video']
    }
  })], 1), _c('span', [_vm._v(_vm._s(_vm.$t('deconf.sessionEmbed.openZoom')))])])]) : _vm.parsed.kind === 'zoom-register' ? _c('div', {
    staticClass: "primaryEmbed-link is-zoom"
  }, [_c('a', {
    staticClass: "button is-medium",
    attrs: {
      "href": _vm.parsed.data,
      "target": "_blank",
      "rel": "noopener"
    },
    on: {
      "click": _vm.onClick
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('FontAwesomeIcon', {
    attrs: {
      "icon": ['fas', 'video']
    }
  })], 1), _c('span', [_vm._v(_vm._s(_vm.$t('deconf.sessionEmbed.openZoomRegister')))])])]) : _vm.parsed.kind === 'google-meet' ? _c('div', {
    staticClass: "primaryEmbed-link is-googleMeet"
  }, [_c('a', {
    staticClass: "button is-medium",
    attrs: {
      "href": _vm.parsed.data,
      "target": "_blank",
      "rel": "noopener"
    },
    on: {
      "click": _vm.onClick
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('FontAwesomeIcon', {
    attrs: {
      "icon": ['fas', 'video']
    }
  })], 1), _c('span', [_vm._v(_vm._s(_vm.$t('deconf.sessionEmbed.openGoogleMeet')))])])]) : _vm.parsed.kind === 'mozilla-hubs' ? _c('div', {
    staticClass: "primaryEmbed-link is-mozillaHubs"
  }, [_c('a', {
    staticClass: "button is-medium",
    attrs: {
      "href": _vm.parsed.data,
      "target": "_blank",
      "rel": "noopener"
    },
    on: {
      "click": _vm.onClick
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('FontAwesomeIcon', {
    attrs: {
      "icon": ['fas', 'video']
    }
  })], 1), _c('span', [_vm._v(_vm._s(_vm.$t('deconf.sessionEmbed.openHubs')))])])]) : _vm.parsed.kind === 'spatial-chat' ? _c('div', {
    staticClass: "primaryEmbed-link is-spatialChat"
  }, [_c('a', {
    staticClass: "button is-medium",
    attrs: {
      "href": _vm.parsed.data,
      "target": "_blank",
      "rel": "noopener"
    },
    on: {
      "click": _vm.onClick
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('FontAwesomeIcon', {
    attrs: {
      "icon": ['fas', 'video']
    }
  })], 1), _c('span', [_vm._v(_vm._s(_vm.$t('deconf.sessionEmbed.openSpatial')))])])]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$6 = [];
/* style */

var __vue_inject_styles__$6 = undefined;
/* scoped */

var __vue_scope_id__$6 = undefined;
/* module identifier */

var __vue_module_identifier__$6 = undefined;
/* functional template */

var __vue_is_functional_template__$6 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$6 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6,
  staticRenderFns: __vue_staticRenderFns__$6
}, __vue_inject_styles__$6, __vue_script__$6, __vue_scope_id__$6, __vue_is_functional_template__$6, __vue_module_identifier__$6, false, undefined, undefined, undefined);

// i18n
// - deconf.sessionEmbed.noEmbed - The warning when no embedable option is available
//
// icons
// - fas video
//
// sass
// - n/a
//

var script$5 = {
  name: 'SecondaryEmbed',
  props: {
    link: {
      type: String,
      required: true
    }
  },
  computed: {
    parsed: function parsed() {
      return parseSecondaryLink(this.link);
    }
  },
  methods: {
    vimeoChatLink: function vimeoChatLink(data) {
      return "https://vimeo.com/live-chat/".concat(data);
    },
    vimeoEventChatLink: function vimeoEventChatLink(data) {
      return "https://vimeo.com/event/".concat(data, "/chat/");
    }
  }
};

/* script */
var __vue_script__$5 = script$5;
/* template */

var __vue_render__$5 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "secondaryEmbed"
  }, [!_vm.parsed ? [_c('div', {
    staticClass: "notification is-warning"
  }, [_vm._v(" " + _vm._s(_vm.$t('deconf.sessionEmbed.noEmbed')) + " ")])] : _vm.parsed.kind === 'vimeo-chat' ? _c('div', {
    staticClass: "secondaryEmbed-iframe"
  }, [_c('iframe', {
    attrs: {
      "width": "100%",
      "height": "100%",
      "src": _vm.vimeoChatLink(_vm.parsed.data),
      "frameborder": "0"
    }
  })]) : _vm.parsed.kind === 'vimeo-event-chat' ? _c('div', {
    staticClass: "secondaryEmbed-iframe"
  }, [_c('iframe', {
    attrs: {
      "width": "100%",
      "height": "100%",
      "src": _vm.vimeoEventChatLink(_vm.parsed.data),
      "frameborder": "0"
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$5 = [];
/* style */

var __vue_inject_styles__$5 = undefined;
/* scoped */

var __vue_scope_id__$5 = undefined;
/* module identifier */

var __vue_module_identifier__$5 = undefined;
/* functional template */

var __vue_is_functional_template__$5 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$5 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5,
  staticRenderFns: __vue_staticRenderFns__$5
}, __vue_inject_styles__$5, __vue_script__$5, __vue_scope_id__$5, __vue_is_functional_template__$5, __vue_module_identifier__$5, false, undefined, undefined, undefined);

/** @deprecated renamed to `PrimaryEmbed` */

var SessionEmbed = __vue_component__$6;

// i18n
// - n/a
//
// icons
// - n/a
//
// sass
// - $sessionLayout-background
//
var script$4 = {
  name: 'SessionLayout'
};

/* script */
var __vue_script__$4 = script$4;
/* template */

var __vue_render__$4 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "sessionLayout"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "sessionLayout-header"
  }, [_c('div', {
    staticClass: "sessionLayout-back"
  }, [_vm._t("backButton")], 2), _c('div', {
    staticClass: "sessionLayout-state"
  }, [_vm._t("state")], 2)]), _c('div', {
    staticClass: "sessionLayout-box"
  }, [_c('div', {
    staticClass: "sessionLayout-main"
  }, [_vm._t("main")], 2), _c('div', {
    staticClass: "sessionLayout-sidebar"
  }, [_vm._t("sidebar")], 2)])])])]);
};

var __vue_staticRenderFns__$4 = [];
/* style */

var __vue_inject_styles__$4 = undefined;
/* scoped */

var __vue_scope_id__$4 = undefined;
/* module identifier */

var __vue_module_identifier__$4 = undefined;
/* functional template */

var __vue_is_functional_template__$4 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$4 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$4, __vue_script__$4, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, false, undefined, undefined, undefined);

// i18n
// - deconf.sessionLink.copy - Text to copy a link
// - deconf.sessionLink.copied - Text when a link has been copied
//
// icons
// - n/a
//
// sass
// - $sessionLink-background
// - $sessionLink-color
// - $sessionLink-radius
// - $sessionLink-linkFont
//

var script$3 = {
  name: 'SessionLink',
  data: function data() {
    return {
      didCopy: false
    };
  },
  props: {
    title: {
      type: String,
      required: true
    },
    link: {
      type: String,
      required: true
    }
  },
  filters: {
    cleanUrl: function cleanUrl(url) {
      return url.replace(/https?:\/\//, '');
    }
  },
  computed: {
    buttonClasses: function buttonClasses() {
      return {
        'is-dark': !this.didCopy,
        'is-success': this.didCopy
      };
    }
  },
  methods: {
    onClick: function onClick() {
      this.$emit('click', this.link);
    },
    copyLink: function copyLink() {
      var _this = this;

      copyToClipboard(this.link, {
        message: 'done'
      });
      this.didCopy = true;
      setTimeout(function () {
        return _this.didCopy = false;
      }, 5000);
      this.$emit('copy', this.link);
    }
  }
};

/* script */
var __vue_script__$3 = script$3;
/* template */

var __vue_render__$3 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "sessionLink"
  }, [_c('div', {
    staticClass: "sessionLink-title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('div', {
    staticClass: "sessionLink-link"
  }, [_c('a', {
    staticClass: "sessionLink-raw",
    attrs: {
      "href": _vm.link,
      "target": "_blank",
      "rel": "noopener"
    },
    on: {
      "click": _vm.onClick
    }
  }, [_vm._v(" " + _vm._s(_vm._f("cleanUrl")(_vm.link)) + " ")]), _c('button', {
    staticClass: "sessionLink-copy button is-small is-dark",
    class: _vm.buttonClasses,
    on: {
      "click": _vm.copyLink
    }
  }, [_vm._v(" " + _vm._s(_vm.didCopy ? _vm.$t('deconf.sessionLink.copied') : _vm.$t('deconf.sessionLink.copy')) + " ")])])]);
};

var __vue_staticRenderFns__$3 = [];
/* style */

var __vue_inject_styles__$3 = undefined;
/* scoped */

var __vue_scope_id__$3 = undefined;
/* module identifier */

var __vue_module_identifier__$3 = undefined;
/* functional template */

var __vue_is_functional_template__$3 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$3 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, undefined, undefined, undefined);

// i18n
// - deconf.sessionState.liveNow - State text when a session is live
// - deconf.sessionState.sessionOver - State text when a session is in the past
// - deconf.sessionState.interest - State text to show registrations (^c)
//
// icons
// - fas circle
// - fas exclamation-triangle
// - fas fire
//
// sass
// - n/a
//

var script$2 = {
  name: 'SessionState',
  components: {
    FontAwesomeIcon: FontAwesomeIcon
  },
  props: {
    attendance: {
      type: Number,
      default: null
    },
    slotState: {
      type: String,
      required: true
    }
  },
  computed: {
    isLive: function isLive() {
      return this.slotState === 'present';
    },
    isOver: function isOver() {
      return this.slotState === 'past';
    },
    isFuture: function isFuture() {
      return ['future', 'soon'].includes(this.slotState) && this.attendance !== null;
    }
  }
};

/* script */
var __vue_script__$2 = script$2;
/* template */

var __vue_render__$2 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "sessionState"
  }, [_vm.isLive ? _c('span', {
    staticClass: "tag is-danger"
  }, [_c('span', {
    staticClass: "icon-text"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('FontAwesomeIcon', {
    attrs: {
      "icon": ['fas', 'circle']
    }
  })], 1), _c('span', [_vm._v(" " + _vm._s(_vm.$t('deconf.sessionState.liveNow')) + " ")])])]) : _vm.isOver ? _c('span', {
    staticClass: "tag is-dark"
  }, [_c('span', {
    staticClass: "icon-text"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('FontAwesomeIcon', {
    attrs: {
      "icon": ['fas', 'exclamation-triangle']
    }
  })], 1), _c('span', [_vm._v(" " + _vm._s(_vm.$t('deconf.sessionState.sessionOver')) + " ")])])]) : _vm.isFuture ? _c('span', {
    staticClass: "tag is-white"
  }, [_c('span', {
    staticClass: "icon-text"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('FontAwesomeIcon', {
    attrs: {
      "icon": ['fas', 'fire']
    }
  })], 1), _c('span', [_vm._v(" " + _vm._s(_vm.$tc('deconf.sessionState.interest', _vm.attendance)) + " ")])])]) : _vm._e()]);
};

var __vue_staticRenderFns__$2 = [];
/* style */

var __vue_inject_styles__$2 = undefined;
/* scoped */

var __vue_scope_id__$2 = undefined;
/* module identifier */

var __vue_module_identifier__$2 = undefined;
/* functional template */

var __vue_is_functional_template__$2 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$2 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, undefined, undefined, undefined);

//
// i18n
// - n/a
//
// icons
// - n/a
//
// sass
// - n/a
//
var script$1 = {
  name: 'SidebarItem',
  props: {
    title: {
      type: String,
      default: null
    }
  }
};

/* script */
var __vue_script__$1 = script$1;
/* template */

var __vue_render__$1 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "sidebarItem"
  }, [_vm.title ? _c('h4', {
    staticClass: "sidebarItem-title"
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")]) : _vm._e(), _c('div', {
    staticClass: "sidebarItem-content"
  }, [_vm._t("default")], 2)]);
};

var __vue_staticRenderFns__$1 = [];
/* style */

var __vue_inject_styles__$1 = undefined;
/* scoped */

var __vue_scope_id__$1 = undefined;
/* module identifier */

var __vue_module_identifier__$1 = undefined;
/* functional template */

var __vue_is_functional_template__$1 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, undefined, undefined, undefined);

var LINKS_INTERVAL = 60 * 1000;
var LANGUAGES = {
  en: 'English',
  fr: 'Français',
  es: 'Español',
  ar: 'عربى'
}; //
// i18n
// - deconf.session.slot
// - deconf.session.countdown
// - deconf.session.links
// - deconf.session.linkPreview
// - deconf.session.actions
// - deconf.session.logIn
// - deconf.session.speakers
// - deconf.session.zoomLink
// - deconf.session.teamsLink
// - deconf.session.miroLink
// - deconf.session.generalLink
//
// icons
// - n/a
//
// sass
// - $sessionView-titleSize
// - $sessionView-titleWeight
// - $sessionView-titleFamily
//
// slots
// - afterAttributes
// - afterContent
// - afterEmbed
// - afterLinks
// - backButton
// - beforeHeader
// - beforeLinks
// - content
//

var script = {
  name: 'SessionView',
  components: {
    AddToCalendar: __vue_component__$$,
    AttendanceSection: __vue_component__$b,
    Countdown: __vue_component__$a,
    InterestSection: __vue_component__$8,
    LanguageWarning: __vue_component__$7,
    PrimaryEmbed: __vue_component__$6,
    SecondaryEmbed: __vue_component__$5,
    SessionAttributes: __vue_component__$Y,
    SessionHeader: __vue_component__$X,
    SessionLayout: __vue_component__$4,
    SessionLink: __vue_component__$3,
    SessionState: __vue_component__$2,
    SidebarItem: __vue_component__$1,
    SpeakerGrid: __vue_component__$I,
    Stack: __vue_component__$H,
    TimeSlot: __vue_component__$F
  },
  props: {
    apiModule: {
      type: String,
      required: true
    },
    session: {
      type: Object,
      required: true
    },
    loggedIn: {
      type: Boolean,
      required: true
    },
    schedule: {
      type: Object,
      required: true
    },
    scheduleDate: {
      type: Date,
      required: true
    }
  },
  data: function data() {
    return {
      timerId: null,
      links: null,
      attendance: null,
      isLoading: false
    };
  },
  computed: {
    sessionSlot: function sessionSlot() {
      var _this = this;

      return this.schedule.slots.find(function (s) {
        return s.id === _this.session.slot;
      }) || null;
    },
    sessionType: function sessionType() {
      var _this2 = this;

      return this.schedule.types.find(function (s) {
        return s.id === _this2.session.type;
      }) || null;
    },
    sessionTrack: function sessionTrack() {
      var _this3 = this;

      return this.schedule.tracks.find(function (s) {
        return s.id === _this3.session.track;
      }) || null;
    },
    sessionSpeakers: function sessionSpeakers() {
      var _this4 = this;

      var speakerMap = new Map(this.schedule.speakers.filter(function (s) {
        return _this4.session.speakers.includes(s.id);
      }).map(function (s) {
        return [s.id, s];
      }));
      return this.session.speakers.map(function (id) {
        return speakerMap.get(id);
      }).filter(function (s) {
        return s;
      });
    },
    sessionThemes: function sessionThemes() {
      var ids = new Set(this.session.themes);
      return this.schedule.themes.filter(function (t) {
        return ids.has(t.id);
      });
    },
    localisedSessionOrg: function localisedSessionOrg() {
      return this.localise(this.session.hostOrganisation);
    },
    localeLinks: function localeLinks() {
      if (!this.links) return null;
      return getLocaleLinks(this.links, this.$i18n.locale, 'en');
    },
    primaryLink: function primaryLink() {
      if (!this.localeLinks) return undefined;
      return this.localeLinks.find(function (l) {
        return Boolean(parsePrimaryLink(l.url));
      });
    },
    secondaryLink: function secondaryLink() {
      if (!this.localeLinks) return undefined;
      return this.localeLinks.find(function (l) {
        return Boolean(parseSecondaryLink(l.url));
      });
    },
    otherLinks: function otherLinks() {
      var _this5 = this;

      if (!this.localeLinks) return null;
      return this.localeLinks.filter(function (l) {
        return l !== _this5.primaryLink && l !== _this5.secondaryLink;
      });
    },
    slotState: function slotState() {
      if (!this.sessionSlot) return 'future';
      return getSlotState(this.scheduleDate, this.sessionSlot.start, this.sessionSlot.end);
    },
    localeTitle: function localeTitle() {
      return this.localise(this.session.title);
    },
    localeContent: function localeContent() {
      return this.localise(this.session.content);
    },
    showCountdown: function showCountdown() {
      return this.slotState === 'soon';
    },
    showLinkPreview: function showLinkPreview() {
      if (!this.links) return false;
      return this.links.length > 0 && this.slotState === 'soon';
    },

    /** Whether links can be shown at all (ie <= 15m before the session) */
    canShowLinks: function canShowLinks() {
      if (!this.sessionSlot) return false;
      var enableTime = new Date(this.sessionSlot.start.getTime());
      enableTime.setMinutes(enableTime.getMinutes() - 15);
      return this.scheduleDate.getTime() > enableTime.getTime();
    },
    showPrimaryLink: function showPrimaryLink() {
      return this.canShowLinks && Boolean(this.primaryLink);
    },
    showLinksSection: function showLinksSection() {
      if (!this.canShowLinks) return false;
      return Boolean(this.secondaryLink) || (this.otherLinks || []).length > 0;
    },
    showAttendance: function showAttendance() {
      return this.slotState !== 'past' && this.session.participantCap !== null && this.loggedIn;
    },
    showInterest: function showInterest() {
      return this.slotState !== 'past' && this.session.participantCap === null && this.loggedIn;
    },
    showAddToCalendar: function showAddToCalendar() {
      return ['future', 'soon'].includes(this.slotState) && !this.showLinksSection;
    },
    stateAttendance: function stateAttendance() {
      if (this.attendance === null) return null;
      if (this.session.participantCap !== null) return null;
      return this.attendance.sessionCount;
    },
    showLanguageWarning: function showLanguageWarning() {
      if (!this.session) return false;
      return !this.session.hostLanguages.includes(this.$i18n.locale);
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    // initially fetch links and attendance
    this.fetchSessionData(); // Setup a timers to regularly pull links and updatre the current date

    this.timerId = window.setInterval(function () {
      _this6.fetchLinks();
    }, LINKS_INTERVAL);
  },
  destroyed: function destroyed() {
    if (this.timerId) {
      window.clearInterval(this.timerId);
      this.timerId = null;
    }
  },
  methods: {
    fetchSessionData: function fetchSessionData() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this7.isLoading = true;
                _context.next = 3;
                return Promise.all([_this7.fetchLinks(), _this7.fetchAttendance()]);

              case 3:
                _this7.isLoading = false;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    fetchLinks: function fetchLinks() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
        var result;
        return regenerator.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this8.loggedIn) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                _context2.next = 4;
                return _this8.$store.dispatch("".concat(_this8.apiModule, "/fetchLinks"), _this8.session.id);

              case 4:
                result = _context2.sent;
                _this8.links = result ? result.links : null;

                _this8.$emit('links', _this8.links);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    fetchAttendance: function fetchAttendance() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
        return regenerator.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this9.$store.dispatch("".concat(_this9.apiModule, "/fetchSessionAttendance"), _this9.session.id);

              case 2:
                _this9.attendance = _context3.sent;

                _this9.$emit('attendance', _this9.attendance);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    attend: function attend() {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4() {
        return regenerator.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this10.isLoading = true;
                _context4.next = 3;
                return _this10.$store.dispatch("".concat(_this10.apiModule, "/attend"), _this10.session.id);

              case 3:
                _this10.$deconf.trackMetric(createAttendanceEvent('attend', _this10.session.id));

                _this10.fetchSessionData();

                _this10.isLoading = false;

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    unattend: function unattend() {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5() {
        return regenerator.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this11.isLoading = true;
                _context5.next = 3;
                return _this11.$store.dispatch("".concat(_this11.apiModule, "/unattend"), _this11.session.id);

              case 3:
                _this11.$deconf.trackMetric(createAttendanceEvent('unattend', _this11.session.id));

                _this11.fetchSessionData();

                _this11.isLoading = false;

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    getLinkName: function getLinkName(link) {
      var name = this.$t('deconf.session.generalLink');

      if (link.url.includes('zoom')) {
        name = this.$t('deconf.session.zoomLink');
      }

      if (link.url.includes('teams')) {
        name = this.$t('deconf.session.teamsLink');
      }

      if (link.url.includes('miro')) {
        name = this.$t('deconf.session.miroLink');
      }

      return "".concat(name, " \u2014 ").concat(LANGUAGES[link.language] || link.language);
    },
    trackLinkClick: function trackLinkClick(link) {
      this.$deconf.trackMetric(createSessionLinkEvent(this.session.id, 'click', link));
    },
    trackLinkCopy: function trackLinkCopy(link) {
      this.$deconf.trackMetric(createSessionLinkEvent(this.session.id, 'copy', link));
    },
    localise: function localise(object) {
      var fallbacks = _toConsumableArray(this.session.hostLanguages);

      if (!fallbacks.includes('en')) fallbacks.push('en');
      return localiseFromObject(this.$i18n.locale, object, {
        fallbacks: fallbacks
      });
    }
  }
};

/* script */
var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('SessionLayout', {
    staticClass: "sessionView"
  }, [_vm._t("backButton", null, {
    "slot": "backButton"
  }), _c('SessionState', {
    attrs: {
      "slot": "state",
      "slot-state": _vm.slotState,
      "attendance": _vm.stateAttendance
    },
    slot: "state"
  }), _c('div', {
    staticClass: "sessionView-main",
    attrs: {
      "slot": "main"
    },
    slot: "main"
  }, [_vm._t("beforeHeader"), _c('div', {
    staticClass: "sessionView-header"
  }, [_vm.sessionType ? _c('SessionHeader', {
    attrs: {
      "session-type": _vm.sessionType
    }
  }) : _vm._e()], 1), _c('h1', {
    staticClass: "sessionView-title"
  }, [_vm._v(" " + _vm._s(_vm.localeTitle) + " ")]), _vm.showLanguageWarning ? _c('div', {
    staticClass: "sessionView-langWarning"
  }, [_c('LanguageWarning', {
    attrs: {
      "available-languages": _vm.session.hostLanguages
    }
  })], 1) : _vm._e(), _vm.showPrimaryLink ? _c('div', {
    staticClass: "sessionView-embed"
  }, [_c('PrimaryEmbed', {
    attrs: {
      "link": _vm.primaryLink.url
    },
    on: {
      "click": function click($event) {
        return _vm.trackLinkClick(_vm.primaryLink.url);
      }
    }
  })], 1) : _vm._e(), _vm._t("afterEmbed"), _c('div', {
    staticClass: "sessionView-attributes"
  }, [_c('SessionAttributes', {
    attrs: {
      "languages": _vm.session.hostLanguages,
      "is-recorded": _vm.session.isRecorded,
      "track": _vm.sessionTrack,
      "themes": _vm.sessionThemes,
      "organisation": _vm.localisedSessionOrg
    }
  })], 1), _vm._t("afterAttributes"), _c('div', {
    staticClass: "sessionView-content"
  }, [_vm._t("content", function () {
    return [_vm.localeContent ? _c('div', {
      staticClass: "content"
    }, [_vm._v(" " + _vm._s(_vm.localeContent) + " ")]) : _vm._e()];
  })], 2), _vm._t("afterContent")], 2), _c('div', {
    staticClass: "sessionView-sidebar",
    attrs: {
      "slot": "sidebar"
    },
    slot: "sidebar"
  }, [_vm.sessionSlot ? [_c('SidebarItem', {
    staticClass: "sessionView-slot",
    attrs: {
      "title": _vm.$t('deconf.session.slot')
    }
  }, [_c('TimeSlot', {
    attrs: {
      "slot-state": _vm.slotState,
      "start-date": _vm.sessionSlot.start,
      "end-date": _vm.sessionSlot.end
    }
  })], 1)] : _vm._e(), _vm.showCountdown ? [_c('SidebarItem', {
    staticClass: "sessionView-countdown",
    attrs: {
      "title": _vm.$t('deconf.session.countdown')
    }
  }, [_c('Countdown', {
    attrs: {
      "current-date": _vm.scheduleDate,
      "target-date": _vm.sessionSlot.start
    }
  })], 1)] : _vm._e(), _vm.showLinkPreview && !_vm.canShowLinks ? [_c('SidebarItem', {
    staticClass: "sessionView-links",
    attrs: {
      "title": _vm.$t('deconf.session.links')
    }
  }, [_c('div', {
    staticClass: "notification is-warning"
  }, [_vm._v(" " + _vm._s(_vm.$t('deconf.session.linkPreview')) + " ")])])] : _vm._e(), _vm.showLinksSection ? [_c('SidebarItem', {
    staticClass: "sessionView-links",
    attrs: {
      "title": _vm.$t('deconf.session.links')
    }
  }, [_c('Stack', {
    attrs: {
      "direction": "vertical",
      "gap": "regular",
      "align": "stretch"
    }
  }, [_vm._t("beforeLinks"), _vm.secondaryLink ? _c('SecondaryEmbed', {
    attrs: {
      "link": _vm.secondaryLink.url
    }
  }) : _vm._e(), _vm._l(_vm.otherLinks, function (link) {
    return _c('SessionLink', {
      key: link.url,
      attrs: {
        "link": link.url,
        "title": link.title || _vm.getLinkName(link)
      },
      on: {
        "click": function click($event) {
          return _vm.trackLinkClick(link.url);
        },
        "copy": function copy($event) {
          return _vm.trackLinkCopy(link.url);
        }
      }
    });
  }), _vm._t("afterLinks")], 2)], 1)] : _vm._e(), _vm.showAttendance || _vm.showInterest || !_vm.loggedIn || _vm.showAddToCalendar ? [_c('SidebarItem', {
    staticClass: "sessionView-actions",
    attrs: {
      "title": _vm.$t('deconf.session.actions')
    }
  }, [_c('Stack', {
    attrs: {
      "direction": "vertical",
      "gap": "regular",
      "align": "stretch"
    }
  }, [_vm.showAttendance ? _c('AttendanceSection', {
    attrs: {
      "session": _vm.session,
      "session-cap": _vm.session.participantCap,
      "attendance": _vm.attendance,
      "is-processing": _vm.isLoading
    },
    on: {
      "attend": _vm.attend,
      "unattend": _vm.unattend
    }
  }) : _vm._e(), _vm.showInterest ? _c('InterestSection', {
    attrs: {
      "session": _vm.session,
      "attendance": _vm.attendance,
      "is-processing": _vm.isLoading
    },
    on: {
      "attend": _vm.attend,
      "unattend": _vm.unattend
    }
  }) : _vm._e(), !_vm.loggedIn ? _c('div', {
    staticClass: "notification is-danger is-light"
  }, [_vm._v(" " + _vm._s(_vm.$t('deconf.session.logIn')) + " ")]) : _vm._e(), _vm.showAddToCalendar ? _c('AddToCalendar', {
    staticClass: "is-fullwidth is-link",
    attrs: {
      "session": _vm.session
    }
  }) : _vm._e()], 1)], 1)] : _vm._e(), _vm.sessionSpeakers.length > 0 ? [_c('SidebarItem', {
    staticClass: "sessionView-speakers",
    attrs: {
      "title": _vm.$t('deconf.session.speakers')
    }
  }, [_c('SpeakerGrid', {
    attrs: {
      "speakers": _vm.sessionSpeakers
    }
  })], 1)] : _vm._e()], 2)], 2);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

var ApiState;

(function (ApiState) {
  ApiState["init"] = "init";
  ApiState["ready"] = "ready";
  ApiState["error"] = "error";
})(ApiState || (ApiState = {}));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var API_DELAY = 300;

/** This function processes data before it is put into the store */
function hydrateSchedule(data) {
  if (data === null) return null;
  data.settings.startDate = new Date(data.settings.startDate);
  data.settings.endDate = new Date(data.settings.endDate); // data.settings.endDate.setHours(23, 59, 59);

  var _iterator = _createForOfIteratorHelper(data.slots),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var slot = _step.value;
      slot.start = new Date(slot.start);
      slot.end = new Date(slot.end);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var _iterator2 = _createForOfIteratorHelper(data.speakers),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var speaker = _step2.value;
      if (!speaker.headshot) speaker.headshot = '/default-headshot.png';
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return deepSeal(data);
}

function hydrateProfile(profile) {
  if (profile === null) return null;
  return deepSeal(_objectSpread(_objectSpread({}, profile), {}, {
    created: new Date(profile.created)
  }));
} //
// NOTE:
// I'm not sure what value this can add without concrete routes
//


var mapApiState = createStateMapper();
function createApiStoreModule() {
  return {
    namespaced: true,
    state: {
      schedule: null,
      apiState: ApiState.init,
      user: null,
      profile: null,
      carbon: null,
      userSessions: null
    },
    getters: {},
    mutations: {
      schedule: function schedule(state, _schedule) {
        state.schedule = hydrateSchedule(_schedule);
        state.apiState = _schedule ? ApiState.ready : ApiState.error;
      },
      state: function state(_state, apiState) {
        _state.apiState = apiState;
      },
      user: function user(state, _user) {
        state.user = deepSeal(_user);
      },
      profile: function profile(state, _profile) {
        state.profile = hydrateProfile(_profile);
      },
      carbon: function carbon(state, _carbon) {
        state.carbon = deepSeal(_carbon);
      },
      userSessions: function userSessions(state, _userSessions) {
        state.userSessions = deepSeal(_userSessions);
      },
      userAttendance: function userAttendance(state, attendance) {
        state.userSessions = deepSeal(attendance.map(function (a) {
          return a.session;
        }));
      }
    },
    actions: {// Let library-users provide the actions
    }
  };
}
/**
 * @deprecated this will used in `createApiStoreModule` in the next major version
 * @warning the `authenticate` action must still be implemented
 */

function createApiStoreActions(api) {
  return {
    //
    // Conference
    //
    fetchData: function fetchData(_ref) {
      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        var commit, data;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commit = _ref.commit;
                _context.next = 3;
                return api.getSchedule();

              case 3:
                data = _context.sent;
                commit('schedule', data);
                return _context.abrupt("return", data !== null);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    //
    // Registration
    //
    login: function login(ctx, email) {
      return api.startEmailLogin(email);
    },
    register: function register(ctx, body) {
      return api.startRegister(body);
    },
    unregister: function unregister() {
      return api.unregister();
    },
    fetchProfile: function fetchProfile(_ref2) {
      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
        var _result$registration;

        var commit, result;
        return regenerator.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                commit = _ref2.commit;
                _context2.next = 3;
                return api.getRegistration();

              case 3:
                result = _context2.sent;
                commit('profile', (_result$registration = result === null || result === void 0 ? void 0 : result.registration) !== null && _result$registration !== void 0 ? _result$registration : null);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    //
    // Carbon
    //
    fetchCarbon: function fetchCarbon(_ref3) {
      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
        var commit;
        return regenerator.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                commit = _ref3.commit;
                _context3.t0 = commit;
                _context3.next = 4;
                return api.getCarbon();

              case 4:
                _context3.t1 = _context3.sent;
                (0, _context3.t0)('carbon', _context3.t1);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    //
    // Conference
    //
    fetchLinks: function fetchLinks(ctx, sessionId) {
      return api.getLinks(sessionId);
    },
    //
    // Attendance
    //
    attend: function attend(_ref4, sessionId) {
      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4() {
        var dispatch;
        return regenerator.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                dispatch = _ref4.dispatch;
                _context4.next = 3;
                return api.attend(sessionId);

              case 3:
                dispatch('fetchUserAttendance');
                _context4.next = 6;
                return pause(API_DELAY);

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    unattend: function unattend(_ref5, sessionId) {
      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5() {
        var dispatch;
        return regenerator.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                dispatch = _ref5.dispatch;
                _context5.next = 3;
                return api.unattend(sessionId);

              case 3:
                dispatch('fetchUserAttendance');
                _context5.next = 6;
                return pause(API_DELAY);

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    fetchUserAttendance: function fetchUserAttendance(_ref6) {
      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee6() {
        var _result$attendance;

        var commit, result;
        return regenerator.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                commit = _ref6.commit;
                _context6.next = 3;
                return api.getUserAttendance();

              case 3:
                result = _context6.sent;
                commit('userAttendance', (_result$attendance = result === null || result === void 0 ? void 0 : result.attendance) !== null && _result$attendance !== void 0 ? _result$attendance : []);

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    fetchSessionAttendance: function fetchSessionAttendance(ctx, sessionId) {
      return api.getSessionAttendance(sessionId);
    },
    //
    // Content
    //
    fetchContent: function fetchContent(ctx, _ref7) {
      var slug = _ref7.slug;
      return api.getContent(slug);
    },
    //
    // Calendar
    //
    fetchUserCalendar: function fetchUserCalendar() {
      return api.createUserCalendar();
    }
  };
}

var mapInterpretState = createStateMapper();
function createInterpretStoreModule() {
  return {
    namespaced: true,
    state: function state() {
      return {
        self: null,
        booth: null,
        activeBooth: null,
        messages: [],
        interpreters: []
      };
    },
    getters: {},
    mutations: {
      self: function self(state, interpreter) {
        state.self = interpreter;
      },
      join: function join(state, booth) {
        state.booth = booth;
      },
      leave: function leave(state) {
        state.booth = null;
        state.activeBooth = null;
        state.messages = [];
        state.interpreters = [];
      },
      messageBooth: function messageBooth(state, _ref) {
        var user = _ref.user,
            message = _ref.message;
        state.messages = state.messages.concat([{
          date: new Date(),
          body: message,
          user: user.name
        }]);
      },
      startInterpreting: function startInterpreting(state, interpreter) {
        var _state$self;

        var booth = state.booth;

        if (!booth) {
          throw new Error('Cannot go live if not in a booth');
        }

        state.activeBooth = {
          interpreter: interpreter,
          isSelf: interpreter.id === ((_state$self = state.self) === null || _state$self === void 0 ? void 0 : _state$self.id)
        };
      },
      stopInterpreting: function stopInterpreting(state) {
        state.activeBooth = null;
      },
      interpreterJoined: function interpreterJoined(state, interpreter) {
        state.interpreters = state.interpreters.filter(function (i) {
          return i.id !== interpreter.id;
        }).concat([interpreter]);
      },
      interpreterLeft: function interpreterLeft(state, interpreter) {
        state.interpreters = state.interpreters.filter(function (i) {
          return i.id !== interpreter.id;
        });
      }
    }
  };
}

var mapMetricsState = createStateMapper(); //
// NOTE:
// I'm not sure what value this can add without concrete routes
// - siteVisitors is useful
// - authenticate not so much ~ data is related from the socket id
//

function createMetricsStoreModule() {
  return {
    namespaced: true,
    state: {
      userId: null,
      socketId: null,
      siteVisitors: null
    },
    getters: {},
    mutations: {
      authenticate: function authenticate(state, options) {
        state.userId = options.userId;
        state.socketId = options.socketId;
      },
      siteVisitors: function siteVisitors(state, _siteVisitors) {
        state.siteVisitors = _siteVisitors;
      }
    }
  };
}

export { __vue_component__$$ as AddToCalendar, __vue_component__$10 as AddToCalendarDialog, __vue_component__$x as ApiContent, __vue_component__$R as ApiError, __vue_component__$U as ApiMessage, ApiState, __vue_component__$V as AppDialog, __vue_component__$O as AppLayout, __vue_component__$N as AppLoading, __vue_component__$12 as AtriumLayout, __vue_component__$b as AttendanceSection, AudioBroadcaster, AudioReceiver, AudioReciever, __vue_component__$M as BackButton, __vue_component__$_ as BidirectionalIcon, __vue_component__$11 as BoxContent, BroadcasterState, __vue_component__$v as CheckboxField, __vue_component__$D as ColorWidget, __vue_component__$a as Countdown, DeconfApiClient, __vue_component__$w as DevControl, DevPlugin, DialogPlugin, __vue_component__$B as FeaturedSessions, __vue_component__$e as FilteredScheduleView, __vue_component__$T as FullHeight, __vue_component__$W as FullScreenDialog, __vue_component__$A as HeroCard, __vue_component__$9 as IframeEmbed, __vue_component__$n as InlineFilter, __vue_component__$L as InlineMessage, __vue_component__$8 as InterestSection, __vue_component__$Z as JoinSession, __vue_component__$7 as LanguageWarning, __vue_component__$r as LoginView, __vue_component__$C as MiniSession, __vue_component__$Q as NavigationBar, __vue_component__$g as NoResults, __vue_component__$K as PageFooter, __vue_component__$6 as PrimaryEmbed, __vue_component__$o as PrivateCalendarCreator, __vue_component__$q as ProfileView, ReceiverState, RecieverState, __vue_component__$p as RegisterView, Routes, __vue_component__$h as ScheduleBlock, __vue_component__$m as ScheduleFilters, __vue_component__$l as ScheduleHeader, __vue_component__$f as ScheduleView, __vue_component__$5 as SecondaryEmbed, __vue_component__$u as SegmentControl, __vue_component__$t as SelectField, __vue_component__$Y as SessionAttributes, __vue_component__$d as SessionBoard, SessionEmbed, __vue_component__$X as SessionHeader, __vue_component__$4 as SessionLayout, __vue_component__$3 as SessionLink, __vue_component__$2 as SessionState, __vue_component__$j as SessionTile, __vue_component__ as SessionView, __vue_component__$P as SideTabs, __vue_component__$1 as SidebarItem, __vue_component__$I as SpeakerGrid, __vue_component__$y as SponsorGrid, __vue_component__$z as SponsorRow, __vue_component__$H as Stack, __vue_component__$G as StaticLayout, __vue_component__$k as StickyHeading, TemporalPlugin, __vue_component__$s as TextField, __vue_component__$F as TimeSlot, __vue_component__$i as ToggleContents, __vue_component__$E as TokenCaptureView, __vue_component__$S as UtilLayout, __vue_component__$c as WhatsOnView, createApiStoreActions, createApiStoreModule, createAtriumWidgetEvent, createAttendanceEvent, createFilterPredicate, createICalEvent, createInterpretStoreModule, createLoginFinishEvent, createLoginStartEvent, createLogoutEvent, createMetricsStoreModule, createPageViewEvent, createQueryPredicate, createRegisterStartEvent, createSessionLinkEvent, createStateMapper, createUnregisterEvent, debounce, decodeJwt, decodeScheduleFilters, decodeUrlScheduleFilters, deconfDefaultEndpoints, deepSeal, encodeScheduleFilters, filterScheduleFromSessions, filtersAreSet, float32ToInt16, friendlyDate, getAudioContext, getCountdown, getCountdownMessage, getDefaultRoutes, getFeaturedSessions, getLocaleLinks, getResampledLength, getRouteTitle, getScheduleStartAndEnd, getScrollBehaviour, getSlotState, getSlug, groupSessionsByDay, groupSessionsBySlot, guardRoute, int16ToFloat32, isDuringConference, isInRange, isSameDay, lerp, linearResample, loadScheduleFilters, localiseFromObject, mapApiState, mapInterpretState, mapMetricsState, nearestNeighbourResample, parseEmbedLink, parsePrimaryLink, parseSecondaryLink, pause, scheduleComputed, startOfDay, stripMarkdown };
